import * as Models from "./rlAdmin.models";
import * as Consts from "./rlAdmin.consts";
import * as Utils from "./rlAdmin.utils";
import * as moment from "moment";
import * as angular from "angular";
import * as uuid from "uuid";
import * as d3 from "d3";
import * as Favico from "favico.js/favico";
import * as $ from "jquery";

import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { InfoService } from "../services/info-service";
import { LocalCacheService } from "../services/local-cache-service";
import { DocGenService } from "../services/doc-gen-service"
import { AlertService } from "../services/alert-service";
import { AssetService } from "../services/asset-service";
import { EntityService } from "../services/entity-service";
import { EntityConfigService } from "../services/entity-config-service";

import { AdminService } from "../services/admin-service";
import { SearchService } from "../services/search-service";
import { AclService } from "../services/acl-service";
import { SecurityService } from "../services/security-service";

import { IFacetFilter } from "../ts/rlAdmin.filters";

import { BaseAssociationSearchController } from "../controllers/base-associations-search-controller";
import { DocumentEntityService } from "../services/document-entity-service";
import { IndexAdminController } from "../config/controllers/index-admin-controller";
import { AttachmentService } from "../services/attachment-service";
import { WorkflowService } from "../services/workflow-service";
import { FavoriteService } from "../services/favorite-service";
import { ContactService } from "../services/contact-service";
import { ReportService } from "../services/report-service";
import { DateLocaleService } from "../services/date-locale-service";

import { BaseAssociationController } from "../controllers/base-associations-controller";
import { RLAssociateContacts } from "../directives/associate-contacts";
import { HierarchyController } from "../config/controllers/hierarchy-controller";
import { RLAdvancedSearch } from "../directives/advanced-search";
import { RLActivityTreeList } from "../directives/activity-tree-list";
import { RLActivityTreeRow } from "../directives/activity-tree-row";
import { RLAddAlertToCharacteristic } from "../directives/add-alert-to-characteristic";
import { RLAdvancedSearchCriteria } from "../directives/advanced-search-criteria";
import { RLAmounts } from "../directives/amounts";
import { RLAssociationPanels } from "../directives/association-panels";
import { RLAssociationTableHierarchyItem } from "../directives/association-table-hierarchy-item";
import { RLAssociationTableHierarchy } from "../directives/association-table-hierarchy";
import { RLAssociationTable } from "../directives/association-table";
import { RLAvailExplorerChart } from "../directives/avail-explorer-chart";
import { RLAvailsSelectedCriteria } from "../directives/avails-selected-criteria";
import { RLBulkActions } from "../directives/bulk-actions";
import { RLBulkImportUpdate } from "../directives/bulk-import-update";
import { RLCatalogAvailsAssocSearch } from "../directives/catalog-avails-assoc-search";
import { RLCharacteristicPolicyEditor } from "../directives/characteristic-policy-editor";
import { RLCharTypeTemplateAssociationsTreeView } from "../directives/chartype-template-associations-tree-view";
import { RLContacts } from "../directives/contacts";
import { RLCopyEntity } from "../directives/copy-entity";
import { RLConditionalFieldsConfig } from "../directives/conditional-fields-config";
import { RLCreateAndAssociateHierarchicalRecords } from "../directives/create-and-associate-hierarchical-records";
import { CustomDashboardReport } from "../directives/custom-dashboard-report";

import { DashboardSearch } from "../directives/dashboard-search";
import { RLEditAlertList } from "../directives/edit-alert-list";
import { RLEditDateCalcByCharacteristic } from "../directives/edit-date-calc-by-characteristic";
import { RLEntityAssetsTableRowOps } from "../directives/entity-assets-table-row-ops";
import { RLEntityAssetsTableRow } from "../directives/entity-assets-table-row";
import { RLEntityAssetsTable } from "../directives/entity-assets-table";
import { RLEntityHierarchyCSVExport } from "../directives/entity-hierarchy-csv-export";
import { RLEntityInfoActions } from "../directives/entity-info-actions";
import { RLEntityQuickSearch } from "../directives/entity-quick-search";
import { RLEntityRelationships } from "../directives/entity-relationships";
import { RLEntityWorkflowNav } from "../directives/entity-workflow-nav";
import { RLFocus } from "../directives/focus";
import { RLIndeterminate } from "../directives/indeterminate";
import { RLInventoryQuickSearch } from "../directives/inventory-quick-search";
import { RLJobProgressStatusMonitor } from "../directives/job-progress-status";
import { RLListOfValuesHierarchyCSVExport } from "../directives/list-of-values-hierachy-csv-export";
import { RLListTable } from "../directives/list-table"; import { RLMigrateEntity } from "../directives/migrate-entity";
import { RLPager } from "../directives/pager"; import { RLParentEntityID } from "../directives/parent-entity-id";
import { RLProjects } from "../directives/projects";
import { RLQuickRightsEntry } from "../directives/quick-rights-entry";
import { RLReportParamDateInput } from "../directives/report-param-date-input";
import { RLReportParamInput } from "../directives/report-param-input";
import { RLReportParamPickerModal } from "../directives/report-param-picker-modal";
import { RLReportParamPicker } from "../directives/report-param-picker";
import { RLReportParamPickerV2 } from "../directives/report-param-picker-v2";
import { RLReportParamSelectedCriteria } from "../directives/report-param-selected-criteria";
import { RLRightsFilter } from "../directives/rights-search-filter";
import { RLScrollFixed } from "../directives/scroll-fixed";
import { RLScrollShadow } from "../directives/scroll-shadow";
import { Scrollable, ScrollableStickyTableHeader } from "../directives/scrollable";
import { RLSelectCharacteristics } from "../directives/select-characteristics";
import { RLShowPanel } from "../directives/show-panel";
import { RLFinancialValidation } from "../directives/financial-validation";
import { RLFinancialTools } from "../directives/financial-tools";
import { RLSidepanelToggle } from "../directives/sidepanel-toggle";
import { RLTemplateHierarchyCountItem } from "../directives/template-hierarchy-count-item"
import { RLTemplateHierarchyCountRecursive } from "../directives/template-hierarchy-count-recursive";
import { RLTitleCoverageChart } from "../directives/title-coverage-chart";
import { RLTypeAheadInput } from "../directives/type-ahead-input";
import { RLViewAddAlertToCharacteristic } from "../directives/view-add-alert-to-characteristic";
import { RLViewAlertsByCharacteristic } from "../directives/view-alerts-by-characteristic";
import { RLViewDateCalcByCharacteristic } from "../directives/view-date-calc-by-characteristic";
import { RLColumnPicker } from "../directives/column-picker";
import { RLBulkCreateAmounts, MultiValidate, PercentValidator } from "../directives/bulk-create-amounts";
import { RLComments, RLCommentThread, RecursionHelper, SharedCommentService, RLComment } from "../directives/comments"
import { RLCreateDataDefault, RLViewDataDefaults } from "../directives/data-defaults";
import { RLLovFilter } from "../directives/lov-filter";
import { RLParseNumberModel } from "../directives/parse-number-model";
import { RLRights } from "../directives/rights";
import { RLRoyaltyPanel, RLCellTotalValidator, RLCellValidator } from "../directives/royalty-panel";
import { RLSecurityTableCell } from "../directives/security-table-cell";
import { RLSecurityTableRow } from "../directives/security-table-row";
import { RLSidepanelPreviewItem } from "../directives/sidepanel-preview-item";
import { RLSidepanelPreviews } from "../directives/sidepanel-previews";
import { RLSidepanel } from "../directives/sidepanel";
import { RLSortColumn } from "../directives/sort-column";
import { RLAuditHistory } from "../directives/audit-history";
import { RLUsages } from "../directives/usages";
import { RLEntitySummaryNav } from "../directives/entity-summary-nav"
import { RLMessage } from "../directives/message";
import { IFilestackPickFile } from "./rlAdmin.models";
import { RLDocuments } from "../directives/documents";
import { RLDocumentFolderHierarchy } from "../directives/document-folder-hierarchy";
import { RLDocumentFolderHierarchyItem } from "../directives/document-folder-hierarchy-item";
import { RLBulkImportV2 } from "../directives/bulk-import-v2";
import { RLBulkImportV3 } from "../directives/bulk-import-v3";
import { RLUserNotificationsMenuBar } from "../directives/user-notifications";
import { RLUserNotificationsList } from "../directives/user-notifications";
import { StatusHistory } from "../directives/status-history";
import { RLListColumnFilter } from "../components/list-column-filter.component";
import { RLEntityValidationSelector } from "../components/entity-validation-selector";
import { RLEntityRelationshipSelector } from "../components/entity-relationship-selector.component";

import { JsonUtil } from './rlAdmin.utils';


export function RLDocViewer() {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            uri: "=",
            fileName: "=",
            templateGroupId: "="
        },
        controllerAs: "dvVM",
        controller: RLDocViewerController,
        template: require("/assets/app/templates/doc-viewer.html"),
        bindToController: true
    };
    return directive;
}

class RLDocViewerController {
    static $inject = ["$scope", "$sce", "docGenService"];
    convertExt: string[];
    iframeSrc: string;
    fileName: string;
    uri: string;
    isMSOfficeDocument: boolean;
    templateGroupId: number;
    constructor(private $scope: ng.IScope, private $sce: ng.ISCEService, private docGenService: DocGenService) {

        this.iframeSrc = "";

        this.convertExt = ['.docx', '.doc'];
        this.isMSOfficeDocument = false;
        var isReady = () => { return (!_.isEmpty(this.uri) && !_.isEmpty(this.fileName)); };
        this.$scope.$watchCollection(() => [this.uri, this.fileName],
            (newValue, oldValue) => {
                this.SetSrc(this.uri, this.fileName);

            });
    }

    SetSrc(uri: string, fileName: string) {
        if (this.templateGroupId == Consts.TemplateGroupIDs.RightslineDocTemplateGroup) {
            var msOfficeOnlineUrl = Consts.PreviewMSOfficeDocUrl.msOfficeLiveUrl;
            var newUri: string = "";

            if (_.endsWith(fileName, ".doc") || _.endsWith(fileName, ".xls") || _.endsWith(fileName, ".rtf") || _.endsWith(fileName, ".docx") || _.endsWith(fileName, ".xlsx")) {
                newUri = msOfficeOnlineUrl + encodeURIComponent(uri);
                this.iframeSrc = this.$sce.trustAsResourceUrl(newUri);
            }
            else {
                this.iframeSrc = this.$sce.trustAsResourceUrl(uri);
            }
        }
        else {
            this.iframeSrc = this.$sce.trustAsResourceUrl(uri);
        }
    }
}



export function RLRecentActivity() {
    var directive: ng.IDirective = {
        restrict: "A",
        controllerAs: "recentVM",
        require: "rlRecentActivity",
        controller: RLRecentActivityController,
        template: require("/assets/app/templates/recent-activity.html"),
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLRecentActivityController) => {
            controller.onlySelf = false;
            controller.count = 5;
            controller.Load();
        }
    };
    return directive;
}

export function RLRecentActivityMenuBar() {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "rlRecentActivityMenuBar",
        controllerAs: "recentVM",
        controller: RLRecentActivityController,
        template: require("/assets/app/templates/recent-activity-menu-bar.html"),
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLRecentActivityController) => {
            controller.onlySelf = true;
            controller.count = 10;
        }
    };
    return directive;
}

class RLRecentActivityController {

    static $inject = ["infoService", "$scope", "notifyService", "charTypeIcons"];

    recentActivities: Models.RecentActivityItem[];
    loading: boolean;
    onlySelf: boolean;
    count: number;

    constructor(private infoService: InfoService, private $scope: ng.IScope, private notifyService: NotifyService, private charTypeIcons: any) {
        this.loading = true;
        this.onlySelf = false;
        this.count = 5;
    }

    Load() {
        this.infoService.getRecentActivities(this.count, this.onlySelf)
            .then((result) => {
                result.forEach(r => {
                    //Turn all times local
                    r.localTimestamp = moment(r.timestamp).local().toString();
                });

                this.recentActivities = result;
                this.loading = false;
            });
    }

    GetCharTypeIcon(item: Models.RecentActivityItem) {
        for (var i = 0; i < this.charTypeIcons.length; i++) {
            var ct = this.charTypeIcons[i];
            if (ct.charTypeID == item.charTypeID) {
                if (ct.templateGroupID == undefined || ct.templateGroupID == item.templateGroupID) {
                    return ct.class;
                }
            }
        }
    }

    GetTitle(item: Models.RecentActivityItem) {
        var charTypeID: number = Utils.IdBuilder.splitEntityID(item.entityID).charTypeID;

        var output: string = "";
        if (charTypeID == Consts.CharTypeIDs.property) {
            output = "Catalog Item";
        } else if (charTypeID == Consts.CharTypeIDs.user) {
            output = "Contact";
        } else if (charTypeID == Consts.CharTypeIDs.transaction) {
            output = "Deal";
        } else if (charTypeID == Consts.CharTypeIDs.invoice) {
            output = "Invoice";
        } else if (charTypeID == Consts.CharTypeIDs.document) {
            output = "Document";
        } else if (charTypeID == Consts.CharTypeIDs.project) {
            output = "Project";
        } else if (charTypeID == Consts.CharTypeIDs.inventory) {
            output = "Inventory";
        } else if (charTypeID == Consts.CharTypeIDs.job) {
            output = "Job";
        }

        var momentTimestamp = moment(item.timestamp);
        var momentCreated = moment(item.created);

        var duration = moment.duration(momentTimestamp.diff(momentCreated));
        var seconds = duration.asSeconds();

        if (seconds <= 3) {
            output += " Created";
        }
        else {
            switch (moment(item.timestamp).format("MMDDYYYY LTS")) {
                case moment(item.created).format("MMDDYYYY LTS"):
                    output += " Created";
                    break;
                case moment(item.statusUpdated).format("MMDDYYYY LTS"):
                    output += " Status Updated";
                    break;
                case moment(item.lastUpdated).format("MMDDYYYY LTS"):
                    output += " Updated";
                    break;
                default:
                    output += " Updated";
                    break;
            }
        }



        return output;
    }

    GetSubTitle(item: Models.RecentActivityItem) {
        var subtitle = "";

        //If timestamp = statusUpdated show them the new status
        if (item.timestamp == item.statusUpdated) {
            subtitle = "Updated to: " + item.status;
        }
        else {
            //Else show them the current status
            subtitle = "Current status: " + item.status;
        }

        return subtitle;
    }

    GetUserName(item: Models.RecentActivityItem) {
        var output: string = item.userName;

        return output;
    }

    GetUserEntityID(item: Models.RecentActivityItem) {
        var divID = Utils.IdBuilder.splitEntityID(item.entityID).divID;
        return Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.user, item.userID);
    }
}


interface IRLBeforeUnloadScope extends ng.IScope {
    isDirty: boolean;
}

RLBeforeUnload.$inject = ["$window"];
export function RLBeforeUnload($windowNot: ng.IWindowService) {
    var directive: ng.IDirective = {
        scope: {
            isDirty: "=rlBeforeUnload"
        },
        link: (scope: IRLBeforeUnloadScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var message = "You have unsaved data, are you sure?";

            var handleUnload = (event) => {
                if (scope.isDirty) {
                    event.preventDefault();
                    (event || $windowNot.event).returnValue = message;
                    return message;
                } else {
                    return undefined;
                }
            };

            $windowNot.addEventListener("beforeunload", handleUnload);

            scope.$on("$destroy", () => {
                $windowNot.removeEventListener("beforeunload", handleUnload);
            });
        }
    };
    return directive;
}

interface IRLModalOpenScope extends ng.IScope {
    open: boolean;
    form: ng.IFormController;
}

// directive for bootstrap modal to open/close based on a scope boolean
// <div class='modal' rl-modal-open='[boolean scope var]'  >....</div>
RLModalOpen.$inject = ["$timeout", "$window"];
export function RLModalOpen($timeout: ng.ITimeoutService, $window: ng.IWindowService) {

    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            open: "=rlModalOpen",
            form: "=rlModalForm"
        },
        link: (scope: IRLModalOpenScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var modalOptions: ModalOptionsBackdropString = {
                show: false,
                backdrop: "static"
            };

            // get the modal api from the element
            var modalApi: IBoostrapModalApi = $(element).modal(modalOptions).data("bs.modal");

            // on modal initiated open, set scope var
            element.on("show.bs.modal", (e) => {
                e.stopPropagation();
                if (!modalApi.isShown) {
                    scope.open = true;
                    var control = angular.element(".set-focus").last();
                    if (control) {
                        $timeout(() => {
                            control.focus();
                        }, 200, false);
                    }
                }
            });

            element.on("shown.bs.modal", () => {
                angular.element("body").addClass("modal-open");
                // prevent slow fade on close (issues when opening another modal afterwards)
                modalApi.$element.removeClass("fade");

            });

            // on modal initiated close, set scope var
            element.on("hide.bs.modal", (e) => {
                if (scope.form && scope.form.$dirty && !scopeClosing) {
                    if (!$window.confirm("You have unsaved data, are you sure?")) {
                        e.preventDefault();
                        return false;
                    }
                }

                if (scope.form) {
                    scope.form.$setPristine();
                }

                scopeClosing = false;
                e.stopPropagation();
            });

            // on modal initiated close, set scope var
            element.on("hidden.bs.modal", (e) => {
                e.stopPropagation();
                $timeout(() => {
                    scope.$apply(() => {
                        scope.open = false;
                    });
                });
            });

            // we want to avoid the form dirty checking if this modal was closed deliberately
            var scopeClosing = false;
            // on scope var change, toggle the modal api state
            scope.$watch("open", (newValue: boolean, oldValue: boolean) => {
                if (newValue != oldValue) {
                    if (newValue && !modalApi.isShown) {
                        modalApi.show();
                    } else if (modalApi.isShown) {
                        scopeClosing = true;
                        modalApi.hide();
                    } else {
                        scopeClosing = false;
                    }
                }
            }, true);

        }
    };
    return directive;
}


// directive for buttons with icon for one-click disable, spinner icon. listens for notifications to return to original state
// <button rl-busy-button='[optional busy icon class]'><i class='fa fa-some-icon'></i> Some Text</button>
RLBusyButton.$inject = ["$timeout", "$window", "eventService", "notifyService"];
export function RLBusyButton($timeout: ng.ITimeoutService, $window: ng.IWindowService, eventService: EventService, notifyService: NotifyService) {
    var directive: ng.IDirective = {
        restrict: "A",
        priority: -100,
        //terminal: true,
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var icon: ng.IAugmentedJQuery = null;							// icon element <i> under button tag
            var busyIcon: string = "fa fa-spinner fa-spin";		// class to show busy state on icon

            if (!_.isEmpty(attributes["rlBusyButton"])) {
                busyIcon = attributes["rlBusyButton"];
            }

            var ngDisabledKey = "ngDisabled";
            // find icon 
            icon = element.find("i");

            var click = ($event: JQueryEventObject) => {
                // store old disabeld state for restoring
                element.data("old-disabled", element.prop("disabled"));
                if (icon != null) {
                    // store old icon class
                    element.data("old-icon", icon.attr("class") || "");
                    // set icon to busy class
                    icon.attr("class", busyIcon);
                }

                // after the $scope digest set disabled
                $timeout(() => {
                    // disable the button
                    element.prop("disabled", true);
                });
            };

            // restores button to original state
            var restore = () => {
                var oldDisabledState = element.data("old-disabled");
                // set disabled state back to orignal if a previous state was found AND ng-disabled='{expr}' is not set
                if (!_.isNull(oldDisabledState)) {
                    // if ng-disabled attribute needs to be evaluated
                    if (attributes[ngDisabledKey] != null) {
                        // restore disabled state after the $scope digest
                        $timeout(() => {
                            // evaluate state of ng-disabled attribute
                            element.prop("disabled", scope.$eval(attributes[ngDisabledKey]));
                        });
                    } else {
                        // restore disabled state after the $scope digest
                        $timeout(() => {
                            element.prop("disabled", oldDisabledState);
                        });
                    }
                    element.data("old-disabled", null);
                }

                var oldIconClass = element.data("old-icon");
                // set icon css back to original
                if (icon != null && oldIconClass != null) {
                    icon.attr("class", oldIconClass);
                    element.data("old-icon", null);
                }
            };

            // bind to click
            element.bind("click", click);

            // listen for eventService 'notify:done'
            eventService.on(Consts.Events.NotifyDone, restore);

            // listen for $scope 'notify:done'
            scope.$on(Consts.Events.NotifyDone, restore);

            // listen for directive destroy
            scope.$on("$destroy", restore);
        }
    };
    return directive;
}

RLCreateEntityButton.$inject = ["$interpolate", "$q", "entityConfigService", "entityService", "aclService"];
export function RLCreateEntityButton($interpolate: ng.IInterpolateService, $q: ng.IQService, entityConfigService: EntityConfigService, entityService: EntityService, aclService: AclService) {

    var directive: ng.IDirective = {
        template: require("/assets/app/templates/create-entity-button.html"),
        scope: {
            url: "@rlCreateEntityButton",
            charTypeID: "@charTypeId",
            templateGroupIDs: "=?templateGroupIds",
            childTemplateID: "@?childTemplateId",
            childCharTypeID: "@?childCharTypeId",
            boundURL: "=?boundUrl",
            boundCharTypeID: "=?boundCharTypeId",
            boundChildCharTypeID: "=?boundChildCharTypeId",
            boundTemplateID: "=?boundTemplateId",
            isParentRelationship: "@?"
        },
        link: (scope: IRLCreateEntityButtonScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var allTemplates: Models.ICharacteristicTemplate[] = [];

            scope.formatHtmlName = (cmdName: string): string => {
                var ret: string = _.isEmpty(cmdName) ? "" : ("cmd_" + cmdName.replace(/[^0-9a-zA-Z]/g, '_').toLowerCase());
                while (ret.indexOf('__') != -1) {
                    ret = ret.replace('__', '_');
                }
                return ret;
            };

            var loadTemplates = (templatePromise: ng.IPromise<Models.ICharacteristicTemplate[]>, charTypeID: number) => {
                $q.all([templatePromise, aclService.loadDataAcls()])
                    .then((results: [Models.ICharacteristicTemplate[], string[]]) => {
                        allTemplates = results[0].filter(ct => Utils.AclUtil.hasCreateAccess(results[1], Utils.AclUtil.getDataEntityAcl(charTypeID, ct.templateGroupID, ct.templateID)));
                    });
            };

            scope.$watch(() => [scope.charTypeID, scope.childTemplateID, scope.childTemplateID],
                (newValue, oldValue) => {
                    if (!_.isEmpty(scope.childTemplateID) && !_.isEmpty(scope.childTemplateID)) {
                        loadTemplates(entityService.getAssociatedParentTemplatesForTemplate(_.parseInt(scope.childCharTypeID), _.parseInt(scope.childTemplateID), _.parseInt(scope.charTypeID)), _.parseInt(scope.charTypeID));
                    }
                    else {
                        if (scope.charTypeID != null) {
                            loadTemplates(entityConfigService.getCharacteristicTemplates(_.parseInt(scope.charTypeID)), _.parseInt(scope.charTypeID));
                        }
                    }
                }, true);

            scope.$watchCollection(() => [scope.boundCharTypeID, scope.boundChildCharTypeID, scope.boundTemplateID, scope.isParentRelationship], (newValue, oldValue) => {
                if (scope.boundCharTypeID != null && scope.boundChildCharTypeID != null && scope.boundTemplateID != null) {
                    if (scope.isParentRelationship != null && scope.isParentRelationship.toLowerCase() == "true") {
                        loadTemplates(entityService.getAssociatedParentTemplatesForTemplate(scope.boundCharTypeID, scope.boundTemplateID, scope.boundChildCharTypeID), scope.boundChildCharTypeID);
                    }
                    else {
                        loadTemplates(entityService.getAssociatedTemplatesForTemplate(scope.boundCharTypeID, scope.boundTemplateID, scope.boundChildCharTypeID), scope.boundCharTypeID);
                    }
                }
            });

            scope.$watch(() => [scope.templateGroupIDs, allTemplates],
                (newValue: any[], oldValue: any[]) => {
                    var templateGroupIDs: number[] = newValue[0];
                    var allTemplates: Models.ICharacteristicTemplate[] = newValue[1];

                    if (templateGroupIDs != null && templateGroupIDs.length > 0) {
                        scope.templates = _.filter<Models.ICharacteristicTemplate>(allTemplates, (template) => _.contains(templateGroupIDs, template.templateGroupID));
                    } else {
                        scope.templates = allTemplates;
                    }
                }, true);



        }
    };

    return directive;
}

interface IRLCreateEntityButtonScope extends ng.IScope {
    url: string;
    charTypeID: string;
    templates: Models.ICharacteristicTemplate[];
    templateGroupIDs: number[];
    childTemplateID: string;
    childCharTypeID: string;
    boundURL: string;
    boundCharTypeID: number;
    boundChildCharTypeID: number;
    boundTemplateID: number;
    isParentRelationship: string;
    formatHtmlName: (cmdName: string) => string;
}

// --------------------------------------------------------------------------------

interface RLEntityByStatusChartScope extends ng.IScope {
    template: Models.ICharacteristicTemplate;
    charTypeID: number;
    origData: any[];
    data: any[];
}

RLEntityByStatusChart.$inject = ["$timeout", "infoService"];
export function RLEntityByStatusChart($timeout: ng.ITimeoutService, infoService: InfoService) {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            template: "=?template",
            charTypeID: "=charTypeId"
        },
        link: (scope: RLEntityByStatusChartScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            scope.$watch(() => scope.template, (newValue: Models.ICharacteristicTemplate, oldValue: Models.ICharacteristicTemplate) => {

                if (newValue != oldValue) {

                    infoService.getEntityStatusCounts(scope.template.templateID, scope.charTypeID)
                        .then((result) => {
                            if (result.length > 0) {
                                scope.origData = [];
                                scope.data = [];
                                scope.origData = _(result).map<{ label: string; data: number }>((kvp) => { return { label: kvp.key, data: kvp.value }; }).valueOf();
                                scope.data = _(result).map<{ label: string; data: number }>((kvp) => { return { label: kvp.key.substring(0, 20), data: kvp.value }; }).valueOf();
                                scope.data = scope.data.slice(0, 10);

                                var options = {
                                    colors: ["#FA5833", "#2FABE9", "#FABB3D", "#78CD51"],
                                    series: {
                                        pie: {
                                            innerRadius: 0.25,
                                            show: true
                                        }
                                    },
                                    legend: {
                                        show: true
                                    },
                                    grid: {
                                        borderWidth: 3,
                                        hoverable: true,
                                        clickable: true
                                    }
                                };

                                $("#nodata").hide();
                                $("#donutchart").show();

                                $["plot"]($("#donutchart", element), scope.data, options);

                                $("#donutchart").off("plotclick");

                            }
                            else {
                                $("#donutchart").hide();
                                $("#nodata").show();
                            }
                        });
                }
            }, true);

            $timeout(() => {
                if (!_.isEmpty(scope.template)) {


                }
            });

        }

    };

    return directive;
}

// --------------------------------------------------------------------------------

export function RLQuickLinksList() {

    var directive: ng.IDirective = {
        template: require("/assets/app/templates/quick-links-list.html"),
        controller: RLQuickLinksController,
        controllerAs: "linksVM"
    };
    return directive;
}

class RLQuickLinksController {

    static $inject = ["$window", "favoriteService", "notifyService", "eventService"];
    links: Models.IFavoriteLink[];

    constructor(private $window: ng.IWindowService, private favoriteService: FavoriteService, private notifyService: NotifyService, private eventService: EventService) {
        this.GetQuickLinks();

        eventService.on(Consts.Events.QuickLinksRefresh, () => {
            this.GetQuickLinks();
        });
    }

    Remove(link: Models.IFavoriteLink, $event: ng.IAngularEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.$window.confirm("Are you sure?")) {
            this.favoriteService.removeUrl(link.name, link.url);
            _.remove(this.links, l => l.name == link.name && l.url == link.url);
            this.notifyService.notifySuccess("Link " + link.name + " Removed");
        }
    }

    GetQuickLinks() {
        this.favoriteService.getLinks().then((result) => {
            if (result != null) {
                this.links = [];
                var quickLinks = JsonUtil.Parse(result.savedReportsJson);

                for (var key in quickLinks) {
                    var values = quickLinks[key];
                    _.forEach(values, (value) => {
                        let quickLink: Models.IFavoriteLink = {
                            name: key,
                            url: value
                        };
                        this.links.push(quickLink);
                    });
                }
            }
        });
    }
}

export function RLContactQuickSearch() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/contact-quick-search.html"),
        transclude: true,
        scope: {
            callback: "&callback",
            selectedTemplateId: '=',
            selectedPartyId: '=',
            selectedCharTypeId: '=',
            typedName: "="
        },
        controller: RLContactQuickSearchController,
        controllerAs: "searchVM"
    };
    return directive;
}

interface RLContactQuickSearchScope extends ng.IScope {
    callback: (value: { contact: string }) => void;
    selectedTemplateId: number;
    selectedPartyId: number;
    selectedCharTypeId: number;
    typedName: string;
}

class RLContactQuickSearchController {
    static $inject = ["$scope", "notifyService", "contactService"];

    keywords: string;
    page: number;
    pageCount: number;
    itemRows: Models.IContactSearchDoc[];
    filteredItemRows: Models.IContactSearchDoc[];
    initialized: boolean;
    sortField: string;
    sortDir: number;
    rowCount: number;
    numFound: number;
    templates: Models.IKeyValuePair<string, string>[];
    statuses: Models.IKeyValuePair<string, string>[];
    selectedTemplate: string;
    selectedStatus: string;
    selectedTemplateId: number;
    selectedPartyId: number;
    selectedCharTypeId: number;
    typedName: string;

    constructor(private $scope: RLContactQuickSearchScope, private notifyService: NotifyService, private contactService: ContactService) {

        this.keywords = "";
        this.page = 1;
        this.pageCount = 0;
        this.itemRows = [];
        this.initialized = false;
        this.sortField = "";
        this.sortDir = 0;
        this.selectedTemplateId = 0;
        this.selectedPartyId = 0;
        this.selectedCharTypeId = 0;

        this.rowCount = 10;

        var searchHash1 = () => { return [this.selectedTemplate]; };
        $scope.$watch(searchHash1,
            (newValue: any[], oldValue: any[]) => {
                this.selectedStatus = null;
            }, true);

        var searchHash2 = () => { return [this.selectedTemplate, this.selectedStatus]; };
        $scope.$watch(searchHash2,
            (newValue: any[], oldValue: any[]) => {
                if (newValue != oldValue) {
                    this.page = 1;
                }
            }, true);

        var searchHash3 = () => { return [this.page, this.selectedTemplate, this.selectedStatus, this.sortDir, this.sortField, this.rowCount]; };
        $scope.$watch(searchHash3, (newValue: any[], oldValue: any[]) => {
            if (newValue && newValue != oldValue) {
                this.Search();
            }
        }, true);

        $scope.$watch(() => this.$scope.selectedPartyId, (newValue: number, oldValue: number) => {
            if (newValue != oldValue && newValue > 0) {
                this.itemRows = [];
                this.Search();
            } else {
                this.selectedTemplate = null;
            }
        });

        if ($scope.typedName != '')
            this.keywords = $scope.typedName;

        this.Search();
    }

    Search() {
        var searchState: Models.ISearchRequest = {
            k: this.keywords || "",
            p: this.page || 1,
            r: this.rowCount,
            sf: this.sortField || "",
            sd: this.sortDir || 0,
            s: this.selectedStatus || "",
            t: this.selectedTemplate || "",
            ct: this.$scope.selectedCharTypeId,
            tid: this.$scope.selectedTemplateId,
            pid: this.$scope.selectedPartyId,
            act: true
        };

        this.notifyService.startProgress();
        this.contactService.search(searchState)
            .then((results) => {
                this.numFound = results.numFound;
                this.itemRows = results.resultDocs;
                this.pageCount = results.pageCount;
                this.statuses = this.FormatFacets(results.statusFacets);
                this.templates = this.FormatFacets(results.templateFacets);
                this.initialized = true;
            }).finally(() => {
                this.notifyService.endProgress();
            });
    }

    FormatFacets(facets: Models.IKeyValuePair<string, number>[]): Models.IKeyValuePair<string, string>[] {
        return _(facets).map<Models.IKeyValuePair<string, string>>(
            (kvp) => {

                var value = "";
                var pair = kvp.key.split("|");
                if (pair.length == 2) {
                    value = pair[0] + " (" + kvp.value + ")";
                }
                return { key: kvp.key, value: value, count: kvp.value };
            }).valueOf();

    }

    Select(contact: string) {
        this.$scope.callback({ contact: contact });
    }
}

/*
 * directive for loading the keyart of a property based only on it's entityID
 * the has-image binding will tell the parent scope whether the image was successfully loaded
 * <img rl-asset-image='[entityID scope var]'  has-image='[bool scope var]'/>
 */
RLAssetImage.$inject = ["$timeout", "attachmentService"];
export function RLAssetImage($timeout: ng.ITimeoutService, attachmentService: AttachmentService) {

    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            entityID: "=rlAssetImage",
            hasImage: "=?"
        },
        link: (scope: IRLAssetImageScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var getImage = (entityID: string) => {
                var recID = Utils.IdBuilder.splitEntityID(entityID).recID;
                // get the keyart via rest
                attachmentService.getKeyArt(entityID)
                    .then((result) => {
                        if (!_.isEmpty(result.src)) {
                            var image = new Image();

                            // image successfully loads callback
                            image.onload = () => {
                                // set <img src='[src]' />
                                element.attr("src", image.src);
                                // show image
                                element.show();
                                $timeout(() => {
                                    // update flag (on next scope digest)
                                    scope.hasImage = true;
                                });
                            };

                            // image fails to load callback
                            image.onerror = () => {
                                // hide <img />
                                element.hide();
                                $timeout(() => {
                                    // update flag (on next scope digest)
                                    scope.hasImage = false;
                                });
                            };

                            // start image load
                            image.src = result.src;
                        }
                    });
            };

            scope.$watch(() => scope.entityID,
                (newValue: string, oldValue: string) => {
                    if (newValue != oldValue && !_.isEmpty(newValue)) {
                        getImage(newValue);
                    }
                });

            if (!_.isEmpty(scope.entityID)) {
                getImage(scope.entityID);
            }
        }
    };
    return directive;
}

interface IRLAssetImageScope extends ng.IScope {
    entityID: string;
    hasImage: boolean;
}

export function RLFavoriteStar() {

    var directive: ng.IDirective = {
        replace: true,
        template: require("/assets/app/templates/favorite-star.html"),
        controller: RLFavoriteStarController,
        controllerAs: "fsVM",
        scope: {
            rlFavoriteStarName: "@"
        }
    };

    return directive;
}

class RLFavoriteStarController {
    static $inject = ["$scope", "$window", "favoriteService", "notifyService", "eventService"];

    active: boolean;

    constructor(private $scope: IRLFavoriteStarScope, private $window: ng.IWindowService, private favoriteService: FavoriteService, private notifyService: NotifyService, private eventService: EventService) {

        this.Refresh();

        eventService.on(Consts.Events.QuickLinksRefresh, () => {
            this.Refresh();
        });

        this.Init();
    }

    Refresh() {
        var currentLink = this.GetLink();
        this.favoriteService.getLinks().then((result) => {
            if (result != null) {
                var links: Models.IFavoriteLink[] = [];
                var quickLinks = JsonUtil.Parse(result.savedReportsJson);

                for (var key in quickLinks) {
                    var values = quickLinks[key];
                    _.forEach(values, (value) => {
                        let quickLink: Models.IFavoriteLink = {
                            name: key,
                            url: value
                        };
                        links.push(quickLink);
                    });
                }

                this.active = _.any(links, (link) => link.url.toLowerCase() == currentLink.url.toLowerCase());
            }
        });
    }

    Click() {
        var link = this.GetLink();
        if (!this.active) {
            this.notifyService.notifySuccess("Added");
            this.favoriteService.addLink(link);
            this.active = true;
        } else {
            if (this.$window.confirm("Are you sure you wan't to remove this link?")) {
                this.RemoveLink(link.name, link.url);
                this.notifyService.notifySuccess("Link removed");
                this.active = false;
            }
        }

        this.eventService.call(Consts.Events.QuickLinksRefresh);
    }

    GetLink(): Models.IFavoriteLink {
        var link = {
            name: "",
            url: ""
        };
        var location = this.$window.location;
        link.url = location.pathname + location.search;
        link.name = this.$scope.rlFavoriteStarName;
        return link;
    }

    AddLink(link: Models.IFavoriteLink) {
        this.favoriteService.addLink(link);
    }

    RemoveLink(name: string, url: string) {
        this.favoriteService.removeUrl(name, url);
    }

    Init() {
        this.favoriteService.MoveSavedQuickLinksFromLocalStorageToDB();
    }
}

interface IRLFavoriteStarScope extends ng.IScope {
    rlFavoriteStarName: string;
}

RLAvailRow.$inject = ["$compile"];
export function RLAvailRow($compile: ng.ICompileService) {

    var childElements;

    var hasValue = (val: any) => {
        var output = _.parseInt(val);

        return !_.isNaN(output) && _.isNumber(output);
    };

    var directive: ng.IDirective = {
        restrict: "A",
        templateUrl: "row.html",
        scope: {
            node: "=rlAvailRow",
            exclusive: "=",
            media: "=",
            entity: "="
        },
        controller: RLAvailRowController,
        controllerAs: "arVM",
        link: (scope: IRLAvailRowScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var subTemplate = $("<tbody	ng-repeat='childNode in	node.children' rl-avail-row='childNode' entity='arVM.entity'	 exclusive='arVM.exclusiveState'	media='arVM.mediaState' class='ngFadeRepeat'></tbody>");

            childElements = $compile(subTemplate)(scope);

            element.after(childElements);
        }
    };
    return directive;
}

interface IRLAvailRowScope extends ng.IScope {
    node: IRLAvailRowNode;
    exclusive: boolean;
    media: boolean;
    entity: string;
}

interface IRLAvailRowNode {
    endDate: string;
    exclusive: number;
    leafNode: number;
    level: number;
    media: string;
    parentTerritory: string;
    parentTerritoryID: number;
    rightsCode: number;
    startDate: string;
    territory: string;
    territoryID: number;
    children: IRLAvailRowNode[];
}

class RLAvailRowController {
    static $inject = ["$scope", "reportService"];

    open: boolean;
    hasChildren: boolean;
    exclusiveState: boolean;
    mediaState: boolean;
    entity: string;

    constructor(private $scope: IRLAvailRowScope, private reportService: ReportService) {
        this.open = false;
        this.hasChildren = false;
        this.exclusiveState = $scope.node.exclusive != null || $scope.exclusive;
        this.mediaState = !_.isEmpty($scope.node.media) || $scope.media;
        this.entity = $scope.entity;
    }

    Toggle() {
        if ((this.$scope.node.children || []).length === 0) {
            this.reportService.getPropertyAvailsRows(this.$scope.entity, this.$scope.node.territoryID, this.$scope.node.startDate, this.$scope.node.endDate)
                .then((result) => {
                    this.$scope.node.children = _.map(result, (itm) => {
                        return {
                            endDate: itm.endDate,
                            exclusive: itm.exclusive,
                            leafNode: itm.leafNode,
                            level: itm.level,
                            media: itm.media.replace(/\n/g, ' | '),
                            parentTerritory: itm.parentTerritory,
                            parentTerritoryID: itm.parentTerritoryID,
                            rightsCode: itm.rightsCode,
                            startDate: itm.startDate,
                            territory: itm.territory,
                            territoryID: itm.territoryID,
                            children: []
                        };
                    });
                    this.hasChildren = this.$scope.node.children.length > 0;
                    this.open = true;
                });
        } else {
            //childElements.remove();
            this.$scope.node.children = [];
            this.open = false;
        }
    }

}

RLMediaelement.$inject = ["$timeout"];
export function RLMediaelement($timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        restrict: "A",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            $timeout(() => {
                $(element).mediaelementplayer({
                    pluginPath: "/assets/mediaelement/"
                });
            }, 100);
        }
    };
    return directive;
}

export interface IRLFilepickerScope extends ng.IScope {
    pickedFiles: IFilestackPickFile[];
    isMultiple: string;
    maxSize: number;
    mimeTypes: string[];
    preValidate: () => void;
    attachmentTypeID: number;
    isValid: boolean;
    entityID: string;
}

RLFilepicker.$inject = ["$timeout", "eventService", "$window", "documentEntityService"];
export function RLFilepicker($timeout: ng.ITimeoutService, eventService: EventService, $window: ng.IWindowService, documentEntityService: DocumentEntityService) {

    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            pickedFiles: "=rlFilepicker",
            isMultiple: "@?rlMultiple",
            maxSize: "=?rlMaxSize",
            mimeTypes: "=?rlMimeTypes",
            preValidate: "&?preValidate",
            attachmentTypeID: "=?attachmentTypeId",
            isValid: "=?isValid",
            entityID: "=?entityId"
        },
        link: (scope: IRLFilepickerScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var fileStackOptions: IFilestackPickOptions = {
                fromSources: ['local_file_system', 'googledrive', 'dropbox', 'box', 'gmail', 'onedrive', 'clouddrive'],
                storeTo: {
                    location: "s3",
                    path: "/filepicker/"
                },
                onFileSelected: (file) => {
                    var executableTypes: string[] = Consts.ExecutableExtensions.Types;
                    var splits = file.filename.split(".");
                    if (splits.length === 1 || (splits[0] === "" && splits.length === 2)) {
                        throw new Error('Please select a file with a valid extension');
                    }
                    var fileExt = splits.pop();
                    if (_.any(executableTypes, e => e == fileExt.toLowerCase())) {
                        throw new Error('Please select a file that is not an executable');
                    }
                },
                onFileUploadFailed: (file, fpError) => {
                    eventService.call(Consts.Events.NotifyDone);
                }
            };

            var setMimeType = (mimeType: string[]) => {
                if (mimeType != null && _.any(mimeType)) {
                    fileStackOptions.accept = mimeType;
                } else {
                    delete fileStackOptions.accept;
                }
            }

            if (scope.isMultiple == "true") {
                fileStackOptions.minFiles = 1;
                fileStackOptions.maxFiles = 100;
            } else {
                fileStackOptions.minFiles = 1;
                fileStackOptions.maxFiles = 1;
            }

            if (_.isNull(scope.isValid)) {
                scope.isValid = true;
            }

            if (_.isNumber(scope.maxSize)) {
                fileStackOptions.maxSize = scope.maxSize;
            }

            if (_.any(scope.mimeTypes)) {
                setMimeType(scope.mimeTypes);
            }

            var filepickerClick = () => {
                if (_.isNumber(scope.attachmentTypeID)) {
                    scope.preValidate();

                    scope.maxSize = Consts.AttachmentTypeDicts.MaxSizes[scope.attachmentTypeID];
                    fileStackOptions.maxSize = scope.maxSize;

                    scope.mimeTypes = Consts.AttachmentTypeDicts.MimeTypes[scope.attachmentTypeID];
                    setMimeType(scope.mimeTypes);
                    scope.$apply();
                }
                else {
                    pickAndStore();
                }
            };

            var pickAndStore = () => {
                var expiry = moment.utc().add(30, "minutes").unix();
                var policy = { "expiry": expiry };
                var policyEncoded = btoa(JSON.stringify(policy));
                documentEntityService.getFileStackSignature(expiry).then((result) => {
                    var security = { policy: policyEncoded, signature: result.signature };

                    var client = filestack.init(Consts.fileStackKey, security);
                    scope.isValid = false;
                    client.pick(fileStackOptions)
                        .then((results) => {
                            $timeout(() => {
                                scope.pickedFiles = results.filesUploaded;
                                var pickedFileWithEntity = <Models.IFilestackPickFileWithEntityID>{
                                    entityID: scope.entityID,
                                    pickedFiles: results.filesUploaded
                                };
                                eventService.call(Consts.Events.KeyArtSave, pickedFileWithEntity);
                            });
                        });
                });
            };

            element.bind("click", filepickerClick);

            scope.$watch(() => scope.isValid, (newValue: boolean, oldValue: boolean) => {
                if (newValue != oldValue && newValue) {
                    pickAndStore();
                }
            });
        }
    };
    return directive;
}

RLDatePicker.$inject = ["dateLocaleService"];
export function RLDatePicker(dateLocaleService: DateLocaleService) {
    var directive: ng.IDirective = {
        restrict: "AEC",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var dateFormat: string = moment.localeData()["_longDateFormat"]["L"];

            // convert from moment.js format to jqueryUI format   MM/DD/YYYY -> mm/dd/yy
            dateFormat = dateFormat.replace("MM", "mm").replace("DD", "dd").replace("YYYY", "yy");

            var options: JQueryUI.DatepickerOptions = {
                onSelect: (d, ins) => {
                    $(element).focus();
                    $(element).change();
                    $(element).blur();
                },
                changeMonth: true,
                changeYear: true,
                yearRange: '1900:2100',
                dateFormat: dateFormat,
                firstDay: 0
            };
            $(element).datepicker(options);
            $(element).keypress(function (event) {
                //if they are typing in the date, hide the calendar away
                $(element).datepicker("hide");
            });
        }
    };
    return directive;
}

export function RLTimecode() {
    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            $(element).mask("?99:99:99");
        }
    };
    return directive;
}

export interface IRLTreeListScope extends ng.IScope {
    selectedNodeTitles: string[];
}

RLTreelist.$inject = ["$timeout", "entityService"];
export function RLTreelist($timeout: ng.ITimeoutService, entityService: EntityService) {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/treelist.html"),
        scope: {
            model: "=rlTreelist",
            selectedNodeTitles: '=?'
        },
        require: ["rlTreelist", "ngModel"],
        controller: RLTreelistController,
        controllerAs: "tlVM",
        link: (scope: IRLTreeListScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var charTypeID = attributes["chartypeid"];
            var charID = attributes["charid"];
            var templateID = attributes["templateid"];
            var charValueSourceID = attributes["charvaluesourceid"];

            var treeCtrl = <RLTreelistController>controllers[0];
            var ngModelCtrl = <ng.INgModelController>controllers[1];

            var treeDiv = $(".form-control.tree", element);

            var watchValues = true;

            var treeOptions: JQueryFancyTreeOptions = {
                extensions: ["filter"],
                activeVisible: true,
                checkbox: true,	// Show	checkboxes.
                debugLevel: 0, // 0:quiet, 1:normal, 2:debug
                icons: false, // Display node icons.
                selectMode: 3, // 1:single,	2:multi, 3:multi-hier
                minExpandLevel: 1, // 1: root node is not collapsible
                tabbable: false,
                keyboard: false,
                filter: {
                    mode: "hide"
                },
                select: (e, data) => {
                    if (watchValues) {
                        var selectedKeys: string[] = [];
                        var selectedTitles: string[] = [];

                        data.tree.getSelectedNodes(true).forEach((value, index, array) => {
                            selectedKeys.push(value.key);
                            selectedTitles.push(value.title);
                        });

                        ngModelCtrl.$setViewValue(selectedKeys.map((v) => _.parseInt(v)));
                        scope.selectedNodeTitles = selectedTitles;
                    }
                },
            };

            var promise: ng.IPromise<Models.IFancyTreeNode[]>;

            if (!_.isEmpty(charValueSourceID) && !_.isNull(charValueSourceID)) {
                promise = entityService.getTreeListValueBySourceID(charValueSourceID);
            } else {
                promise = entityService.getTreeListValue(charTypeID, templateID, charID);
            }

            var tree: JQueryFancyTreeTree;

            promise.then((result) => {
                treeOptions.source = result;
                $(treeDiv).fancytree(treeOptions);
                tree = $(treeDiv).fancytree("getTree");
                tree.rootNode.children[0].setExpanded(true);
            });

            scope.$watch<number[]>(() => ngModelCtrl.$modelValue, (newValue, oldValue) => {
                if (newValue != oldValue && watchValues) {
                    watchValues = false;
                    var newKeys = _.clone(newValue);
                    var selectedNodes = tree.getSelectedNodes(true);
                    selectedNodes.forEach((node) => {
                        var contains = _.contains(newKeys, _.parseInt(node.key));
                        if (!contains) {
                            node.setSelected(false);
                        }
                        _.remove(newKeys, (key) => key == _.parseInt(node.key));
                    });
                    newKeys.forEach((key) => {
                        var node = tree.getNodeByKey(key.toString());
                        if (node != null) {
                            node.setSelected(true);
                        }
                    });

                    tree.getSelectedNodes(true).forEach((node) => {
                        node.makeVisible({ scrollIntoView: false });
                    });
                    watchValues = true;
                }
            }, true);

            // when filter value changes
            scope.$watch(() => treeCtrl.filterValue, (newValue: string, oldValue: string) => {
                if (newValue != oldValue) {
                    if (newValue === "") {
                        // clear the filter
                        tree.clearFilter();
                    } else {
                        // apply new filter
                        tree.filterNodes(newValue);
                        tree.visit((node) => {
                            node.setExpanded(true);
                        });
                    }
                }
            });

            // when directive is destroyed, destroy treelist api as well.  [good practice]
            scope.$on("$destroy", function () {
                $(element).fancytree("destroy");
            });
        }
    };
    return directive;
}

class RLTreelistController {

    filterValue: string;

    constructor() {
        this.filterValue = "";
    }

    ClearFilter() {
        this.filterValue = "";
    }
}


class RLCharTemplateSelectController {

    static $inject = ["$scope", "entityConfigService", "entityService", "aclService"];

    charTypeID: string;
    templates: Models.ICharacteristicTemplate[];
    templateGroupIDs: string;
    parentCharTypeID: string;
    templateID: string;
    isParentRelationship: string;
    parentTemplateID: string;
    modelTemplateID: number;
    disabled = true;
    ngModel: ng.INgModelController;

    constructor(private $scope: ng.IScope, private entityConfigService: EntityConfigService, private entityService: EntityService, private aclService: AclService) {
    }

    Init() {

        this.$scope.$watch(() => this.charTypeID, (newValue) => {
            this.Setup(_.parseInt(this.charTypeID));
        }, true);

        this.$scope.$watch(() => this.ngModel.$viewValue, (newValue, oldValue) => {
            this.modelTemplateID = _.parseInt(newValue);
        }, true);

    }

    Setup(charTypeID: number) {
        var parentCharTypeID = _.parseInt(this.parentCharTypeID);
        var parentTemplateID = _.parseInt(this.parentTemplateID);
        if (!_.isNull(charTypeID)) {
            if (parentCharTypeID != null && parentCharTypeID > 0 && this.templateID != null && this.isParentRelationship != null) {
                if (this.isParentRelationship != null && this.isParentRelationship.toLowerCase() == "true") {
                    this.entityService.getAssociatedParentTemplatesForTemplate(parentCharTypeID, parentTemplateID, charTypeID)
                        .then((result) => {
                            this.templates = result;
                            // setupTemplates(result);
                        }).then(() => {
                            this.disabled = false;
                        });
                }
                else {
                    this.entityService.getAssociatedTemplatesForTemplate(parentCharTypeID, parentTemplateID, charTypeID)
                        .then((result) => {
                            this.templates = result;
                            // setupTemplates(result);
                        }).then(() => {
                            this.disabled = false;
                        });
                }
            }
            else {
                this.entityConfigService.getCharacteristicTemplates(charTypeID)
                    .then((result) => {
                        this.templates = this.FilterTemplates(result);
                        // setupTemplates(templates);
                    }).then(() => {
                        this.disabled = false;
                    });
            }
        }
    };

    FilterTemplates(templates: Models.ICharacteristicTemplate[]) {

        var templateGroupIDs = <number[]>this.$scope.$eval(this.templateGroupIDs) || [];
        return templates.filter((template) => {
            if (_.isEmpty(templateGroupIDs) || (_.contains(templateGroupIDs, template.templateGroupID) || templateGroupIDs.length == 0)) {
                if (Utils.AclUtil.hasCreateAccess(this.aclService.acls, template.acl)) {
                    return true;
                }
            }
            return false;
        });
    };

    Changed() {
        this.ngModel.$setViewValue(this.modelTemplateID);
    }
}

RLCharTemplateSelect.$inject = ["$compile", "entityConfigService", "entityService", "aclService"];
export function RLCharTemplateSelect($compile: ng.ICompileService, entityConfigService: EntityConfigService, entityService: EntityService, aclService: AclService) {

    var directive: ng.IDirective = {
        restrict: "E",
        require: ["?ngModel", "rlCharTemplateSelect"],
        //replace: true,
        controller: RLCharTemplateSelectController,
        bindToController: true,
        controllerAs: "ctsVM",
        template: `<select class="form-control" ng-model="ctsVM.modelTemplateID" ng-disabled="ctsVM.disabled" ng-change="ctsVM.Changed()">
            <option ng-repeat='template in ctsVM.templates' ng-value='template.templateID' ng-bind='template.templateName'></option>
        </select>`,
        scope: {
            charTypeID: "=rlCharType",
            templateGroupIDs: "=?templateGroupIds",
            parentCharTypeID: "@?parentCharTypeId",
            templateID: "@?templateId",
            isParentRelationship: "@?",
            parentTemplateID: "@?parentTemplateId"
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [ng.INgModelController, RLCharTemplateSelectController]) => {

            controllers[1].ngModel = controllers[0];
            controllers[1].Init();
        }
    };
    return directive;
}

RLCharVisibilitySelect.$inject = ["entityConfigService"];
export function RLCharVisibilitySelect(entityConfigService: EntityConfigService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "?ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
            var disabled: boolean = element.prop("disabled");
            element.prop("disabled", true);

            if (ngModel != null) {
                ngModel.$render = () => {
                    element.val(ngModel.$viewValue);
                };
            }

            entityConfigService.getVisibilityOptions()
                .then((result) => {
                    result.forEach((kvp) => {
                        element.append($("<option />").attr("value", kvp.key).html(kvp.value));
                    });
                }).then(() => {
                    var attrValue = attributes["rlCharVisibilitySelect"];
                    if (ngModel != null) {
                        ngModel.$render();
                    } else if (attrValue != null && !_.isEmpty(attrValue)) {
                        element.val(attrValue);
                    }
                    if (!disabled) {
                        element.prop("disabled", false);
                    }
                });
        }
    };
    return directive;
}

RLCharTemplateGroupSelect.$inject = ["entityConfigService"];
export function RLCharTemplateGroupSelect(entityConfigService: EntityConfigService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "?ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
            var disabled: boolean = element.prop("disabled");
            element.prop("disabled", true);

            attributes.$observe("rlCharTypeId", (newValue: number) => {
                setup(newValue);
            });

            if (ngModel != null) {
                ngModel.$render = () => {
                    element.val(ngModel.$viewValue);
                };
            }

            var setup = (charTypeID: number) => {
                $("option[value!='']", element).remove();
                if (!_.isNull(charTypeID) && !_.isEmpty(charTypeID)) {
                    entityConfigService.getCharacteristicTemplateGroups(charTypeID)
                        .then((result) => {
                            result.forEach((templateGroup) => {
                                element.append($("<option />").attr("value", templateGroup.characteristicTemplateGroupID).html(templateGroup.characteristicTemplateGroupName));
                            });
                        }).then(() => {
                            var attrValue = attributes["rlCharTemplateGroupSelect"];
                            if (ngModel != null) {
                                ngModel.$render();
                            } else if (attrValue != null && !_.isEmpty(attrValue)) {
                                element.val(attrValue);
                            }
                            if (!disabled) {
                                element.prop("disabled", false);
                            }
                        });
                }
            };
        }
    };
    return directive;
}


RLCharDataTypeSelect.$inject = ["entityConfigService"];
export function RLCharDataTypeSelect(entityConfigService: EntityConfigService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "?ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
            var disabled: boolean = element.prop("disabled");
            element.prop("disabled", true);

            if (ngModel != null) {
                ngModel.$render = () => {
                    element.val(ngModel.$viewValue);
                };
            }

            entityConfigService.getCharDataTypes()
                .then((result) => {
                    result.forEach((kvp) => {
                        element.append($("<option />").attr("value", kvp.key).html(kvp.value));
                    });
                }).then(() => {
                    var attrValue = attributes["rlCharDataTypeSelect"];
                    if (ngModel != null) {
                        ngModel.$render();
                    } else if (attrValue != null && !_.isEmpty(attrValue)) {
                        element.val(attrValue);
                    }
                    if (!disabled) {
                        element.prop("disabled", false);
                    }
                });
        }
    };
    return directive;
}

RLChangeRedirect.$inject = ["$window"];
export function RLChangeRedirect($window: ng.IWindowService) {

    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var urlString: string = attributes["rlChangeRedirect"];
            element.bind("change", (event: JQueryEventObject) => {
                var selectedValue = $(element).val();
                var newUrl = urlString.replace("[value]", <string>selectedValue);
                $window.location.assign(newUrl);
            });
        }
    };
    return directive;
}

RLWorkflowActionSelect.$inject = ["workflowService"];
export function RLWorkflowActionSelect(workflowService: WorkflowService) {

    var directive: ng.IDirective = {
        restrict: "A",
        require: "?ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
            var disabled: boolean = element.prop("disabled");
            element.prop("disabled", true);

            if (ngModel != null) {
                ngModel.$render = () => {
                    element.val(ngModel.$viewValue);
                };
            }

            scope.$watch(() => { return [attributes["rlCharTypeId"], attributes["rlTemplateId"], attributes["rlStatusId"]]; },
                (newValue: any[], oldValue: any[]) => {
                    if (newValue.length == 3 && _.all(newValue, (val) => { return val != ""; })) {
                        setup(newValue[0], newValue[1], newValue[2]);
                    }
                }, true);

            var setup = (charTypeID: number, templateID: number, statusID: number) => {
                $("option[value!='']", element).remove();
                workflowService.getAvailableWorkflowActions(charTypeID, templateID, statusID)
                    .then((result) => {
                        result.forEach((action) => {
                            element.append($("<option />").attr("value", action.actionID).html(action.actionName));
                        });
                        if (ngModel != null) {
                            ngModel.$setViewValue($("option:first").val());
                        }
                    }).then(() => {
                        var attrValue = attributes["rlCharDataTypeSelect"];
                        if (ngModel != null) {
                            ngModel.$render();
                        } else if (attrValue != null && !_.isEmpty(attrValue)) {
                            element.val(attrValue);
                        }
                        if (!disabled) {
                            element.prop("disabled", false);
                        }
                    });
            };
        }
    };
    return directive;
}

RLWorkflowProcessSelect.$inject = ["workflowService"];
export function RLWorkflowProcessSelect(workflowService: WorkflowService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "?ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModel: ng.INgModelController) => {
            var disabled: boolean = element.prop("disabled");
            element.prop("disabled", true);

            attributes.$observe("rlCharTypeId", (newValue: number) => {
                setup(newValue);
            });

            if (ngModel != null) {
                ngModel.$render = () => {
                    element.val(ngModel.$viewValue);
                };
            }

            var setup = (charTypeID: number) => {
                $("option[value!='']", element).remove();
                if (!_.isNull(charTypeID) && !_.isEmpty(charTypeID)) {
                    workflowService.getWorkflowProcesses(charTypeID)
                        .then((result) => {
                            result.forEach((workflowProcess) => {
                                element.append($("<option />").attr("value", workflowProcess.processID).html(workflowProcess.processName));
                            });
                        }).then(() => {
                            var attrValue = attributes["rlWorkflowProcessSelect"];
                            if (ngModel != null) {
                                ngModel.$render();
                            } else if (attrValue != null && !_.isEmpty(attrValue)) {
                                element.val(attrValue);
                            }
                            if (!disabled) {
                                element.prop("disabled", false);
                            }
                        });
                }
            };
        }
    };
    return directive;
}

// allows forms with action='' to avoid being attached by ngFrom
// <form ng-form-ignore='' ..>
NGFormIgnore.$inject = ["$window"];
export function NGFormIgnore($window: ng.IWindowService) {
    var directive: ng.IDirective = {
        priority: 1000,
        restrict: "A",
        compile: () => {
            return {
                pre: (scope: ng.IScope, formElement: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
                    if (attributes["action"] != undefined && attributes["action"] === "") {
                        attributes["action"] = "?";
                    }
                }
            };
        }
    };
    return directive;
}

// emits an event on the first element of an ng-repeat
// <... ng-repeat='something in somethings' firstRepeat='' />
RLFirstRepeat.$inject = ["$timeout"];
export function RLFirstRepeat($timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        restrict: "A",
        link: (scope: IRLFirstRepeatScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            if (scope.$first === true) {
                $timeout(() => {
                    scope.$emit("firstRepeat", element);
                });
            }
        }
    };
    return directive;
}

interface IRLFirstRepeatScope extends ng.IScope {
    $first: boolean;
}

// allows transcluded content to be cloned under a different scope
// <div transclude-scope='$parent.$parent' >[cloned content ends up here]</div>
RLTranscludeScope.$inject = ["$parse"];
export function RLTranscludeScope($parse: ng.IParseService) {
    var directive: ng.IDirective = {
        priority: 10000,
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any, transclude: ng.ITranscludeFunction) => {
            var group: string = attributes["rlTranscludeGroup"];
            var getter = $parse(attributes["rlTranscludeScope"]);
            var targetScope: ng.IScope = getter(scope) || scope;

            var elementHasContent = (input: Node) => {

                var textNodes = _.filter(input.childNodes, (node) => node.nodeName == "#text");
                var otherNodes = _.filter(input.childNodes, (node) => node.nodeName != "#text");

                return _.any(otherNodes) || _.any(textNodes, (node) => node.nodeValue.trim().length > 0);
            };


            transclude(targetScope, (clone) => {
                element.empty();
                if (!_.isEmpty(group)) {
                    for (var i = 0; i < clone.length; i++) {
                        var child = clone[i];
                        if ((child.tagName || "").toLowerCase() == group.toLowerCase()) {
                            if (elementHasContent(child)) {
                                element.append(child);
                            } else {
                                console.log(child);
                            }
                        }
                    }
                } else {
                    element.append(clone);
                }
            });
        }
    };
    return directive;
}

export function RLAddress() {
    var directive: ng.IDirective = {
        restrict: "A",
        template: require("/assets/app/templates/address.html"),
        replace: true,
        scope: {
            entityData: "=rlAddress",
            expanded: "=",
            partyID: "=partyId",
            parentCharTypeID: "=parentCharTypeId",
            callback: "&callback",
            hasChildTemplates: "=?"
        },
        controller: RLAddressController,
        controllerAs: "addrVM"
    };
    return directive;
}

interface IRLAddressScope extends ng.IScope {
    entityData: Models.ICharDataCollection;
    expanded: boolean;
    callback: (value: { recordID: number, partyID: number }) => void;
    partyID: number;
    parentCharTypeID: number;
    hasChildTemplates: boolean;
}

class RLAddressController {
    static $inject = ["$scope", "aclService"];

    contactName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    email: string;
    phone: string;
    recordID: number;
    template: string;
    entityID: string;
    canRead: boolean;
    canSync: boolean;

    expandAddress: boolean;
    status: string;
    partyID: number;
    parentCharTypeID: number;
    hasChildTemplates: boolean;

    constructor(private $scope: IRLAddressScope, private aclService: AclService) {

        this.canRead = Utils.AclUtil.hasReadAccess(this.aclService.acls, this.$scope.entityData.templateMetaData.template.acl);
        this.canSync = Utils.AclUtil.hasWriteAccess(this.aclService.acls, Consts.Acl.Activities._Site._Mod1.Contacts);

        this.expandAddress = false;

        this.recordID = Utils.IdBuilder.splitEntityID($scope.entityData.entityID).recID;
        this.template = $scope.entityData.templateMetaData.template.templateName;
        this.entityID = $scope.entityData.entityID;
        this.expandAddress = $scope.expanded;
        this.partyID = $scope.partyID;
        this.parentCharTypeID = $scope.parentCharTypeID;
        this.hasChildTemplates = $scope.hasChildTemplates;

        if (this.canRead) {
            this.contactName = this.GetCharValue("entity_title");
            this.address1 = this.GetCharValue("address_line_1");
            this.address2 = this.GetCharValue("address_line_2");
            this.city = this.GetCharValue("city");
            this.state = this.GetCharValue("state_or_province");
            this.zip = this.GetCharValue("zip_or_postal_code");
            this.country = this.GetCharValue("country");
            this.email = this.GetCharValue("email");
            this.phone = this.GetCharValue("phone");
            this.status = this.GetCharValue("entity_status");
        } else {
            this.contactName = `${this.template} #${this.recordID}`;
        }
    }

    GetCharValue(tagLabel: string) {
        var charDatas = this.$scope.entityData.charDatas[tagLabel];
        if (charDatas != null && charDatas.length > 0) {
            return charDatas[0].value || "";
        }
        return "";
    }

    Toggle() {
        this.expandAddress = !this.expandAddress;
    }

    SyncContact(recordID: number, partyID: number) {
        this.$scope.callback({ recordID: recordID, partyID: partyID });
    }

}

RLExtendedAssociateTreeItem.$inject = ["$compile"];
export function RLExtendedAssociateTreeItem($compile: ng.ICompileService) {

    var directive: ng.IDirective = {
        template: require("/assets/app/templates/extended-associate-tree-item.html"),
        restrict: "A",
        require: ["^ngController", "rlExtendedAssociateTreeItem"],
        scope: {
            node: "=",
            targetRecordID: "=targetRecordId",
            previewRecordID: "=previewRecordId",
            detailsUrl: "=",
            parentOpen: "=",
            level: "@",
            doRefresh: "=",
            targetLevel: "=?",
            isParentList: "=?",
            canEdit: "=?"
        },
        controller: RLExtendedAssociateTreeItemController,
        controllerAs: "atiVM",
        link: (scope: IRLExtendedAssociateTreeItemScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

            var pageCtrl: BaseAssociationController<any> = controllers[0];
            var ctrl: RLExtendedAssociateTreeItemController = controllers[1];

            // hook click event up to page controller
            ctrl.showEntityCallback = (entityID: string) => {
                pageCtrl.ShowEntity(entityID);
            };

            if (_.any(ctrl.childNodes) && ctrl.open) {
                var template = "<tr ng-repeat='childNode in atiVM.childNodes' ng-show='atiVM.open && parentOpen' parent-open='atiVM.open' rl-extended-associate-tree-item='' node='childNode' level='{{atiVM.levelInt+1}}' target-record-id='targetRecordID' preview-record-id='previewRecordID' details-url='detailsUrl' do-refresh='atiVM.doRefresh' target-level=atiVM.targetRecordLevel></tr>";
                var el = angular.element(template);
                var compiled = $compile(el);
                element.after(el);
                compiled(scope);
            }

            scope.$watch(() => pageCtrl.canEdit, (newValue, oldValue) => { ctrl.canEdit = newValue; });
        }
    };
    return directive;
}

interface IRLExtendedAssociateTreeItemScope extends ng.IScope {
    node: Models.IEntityNode;
    targetRecordID: number;
    previewRecordID: number;
    detailsUrl: string;
    parentOpen: boolean;
    level: string;
    doRefresh: boolean;
    targetLevel: number;
    isParentList: boolean;
    canEdit: boolean;
}

class RLExtendedAssociateTreeItemController {
    static $inject = ["$scope", "$rootScope", "$interpolate", "notifyService", "entityService"];

    levelInt: number;
    url: string;
    showCheckbox: boolean;
    childNodes: Models.IEntityNodeWRelID[];
    childCount: number;
    open: boolean;
    arrowClass: string;
    showEntityCallback: (entityID: string) => void;
    canEdit: boolean;
    emptyClass: string;
    isDirectParentOrChild: boolean;
    targetRecordLevel: number;
    doRefresh: boolean;

    constructor(private $scope: IRLExtendedAssociateTreeItemScope,
        private $rootScope: ng.IRootScopeService,
        private $interpolate: ng.IInterpolateService,
        public notifyService: NotifyService,
        private entityService: EntityService) {

        var interpolated = $interpolate($scope.detailsUrl);
        this.levelInt = _.parseInt($scope.level);

        this.childNodes = _($scope.node.relatedEntities)
            .pairs()
            .map((pair: any[]) => {
                var output: Models.IEntityNodeWRelID = pair[1];
                output.relID = pair[0];
                return output;
            })
            .sortBy((node) => node.entity.title)
            .valueOf();


        this.childCount = this.childNodes.length;
        this.open = true;
        this.arrowClass = "fa-caret-right";
        this.url = interpolated($scope);
        this.canEdit = false;
        this.emptyClass = "mrm";

        $scope.$watch(() => this.open, (newValue: boolean, oldValue: boolean) => {
            var open = newValue;
            var newClass = "";

            if (this.childCount > 0) {
                if (open) {
                    newClass = "fa-caret-down prx";
                } else {
                    newClass = "fa-caret-right prs";
                }
            }

            this.arrowClass = newClass;
        });

        $scope.$watch("parentOpen", (newValue: boolean) => {
            if (!newValue) {
                this.open = false;
            }
        });

        $scope.$watch(() => $scope.targetRecordID,
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.isDirectParentOrChild = this.ShowCheckbox();
                    this.showCheckbox = $scope.targetRecordID != $scope.node.entity.recordID && this.isDirectParentOrChild;
                }
            });

        $scope.$watch(() => $scope.doRefresh,
            (newValue, oldValue) => {
                this.doRefresh = $scope.doRefresh;
            });

        $scope.$watch(() => this.doRefresh,
            (newValue, oldValue) => {
                if (newValue) {
                    $scope.doRefresh = this.doRefresh;
                }
            });
    }

    ShowCheckbox() {
        if (this.childNodes != null && this.childNodes.length == 0 && this.$scope.isParentList)
            return true;

        if (this.childNodes == null)
            return false;

        if (this.childNodes.filter((cn) => cn.entity.recordID == this.$scope.targetRecordID).length > 0)
            return true;

        if (this.$scope.targetLevel + 1 == this.levelInt)
            return true;

        if (this.$scope.node.entity.recordID == this.$scope.targetRecordID)
            this.targetRecordLevel = this.levelInt;

        return false;
    }

    Toggle() {
        if (this.$scope.level != null && _.parseInt(this.$scope.level) > 0) {
            this.open = !this.open;
        }
        else {
            this.$scope.parentOpen = !this.$scope.parentOpen;
        }
    }

    ShowEntity(entityID: string) {
        if (this.showEntityCallback != null) {
            this.showEntityCallback(entityID);
        }
    }

    RemoveAssociated(node: Models.IEntityNodeWRelID): ng.IPromise<any> {
        var relID = null;

        //For child items of the targetItem, we want the relID, as it's pulling the correct relationship.
        if (this.$scope.targetLevel != null)
            relID = node.relID;

        //For parent items of the targetItem, we want the relatedEntities relID, as that is the correctly tied relationship
        if (relID == null) {
            var relatedEntities = _(node.relatedEntities)
                .pairs()
                .map((pair: any[]) => {
                    var output: Models.IEntityNodeWRelID = pair[1];
                    output.relID = pair[0];
                    return output;
                }).valueOf();

            if (relatedEntities.length > 0) {
                relID = relatedEntities[0].relID;
            }
            else if (this.$scope.isParentList) {
                //We can grab the relationship to the target entity and use its relRecID since we do not have the relatedEntities collection to use
                var validRels = _.filter(node.relationships, rel => rel.childCharTypeID == node.entity.charTypeID && rel.childRecID == this.$scope.targetRecordID);

                if (validRels.length > 0) {
                    var parentRelID = Utils.IdBuilder.buildEntityID(node.entity.divisionID, Consts.CharTypeIDs.relationship, validRels[0].relRecID);

                    relID = parentRelID;
                }
            }
        }

        var selectedIDs: number[] = [];
        selectedIDs.push(Utils.IdBuilder.splitEntityID(relID).recID);

        var currentEntityID = Utils.IdBuilder.buildEntityID(node.entity.divisionID, node.entity.charTypeID, this.$scope.targetRecordID);

        return this.entityService.deleteAssociations(currentEntityID, selectedIDs)
            .then(() => {
                this.notifyService.notifySuccess("Associations removed");
                this.doRefresh = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    PreviewEntity(entityID: string) {
        this.$rootScope.$broadcast(Consts.Events.ViewEntity, entityID);
    }
}


RLAssociateTreeItem.$inject = ["$compile"];
export function RLAssociateTreeItem($compile: ng.ICompileService) {

    var directive: ng.IDirective = {
        template: require("/assets/app/templates/associate-tree-item.html"),
        restrict: "A",
        require: ["^ngController", "rlAssociateTreeItem"],
        scope: {
            node: "=",
            targetRecordID: "=targetRecordId",
            previewRecordID: "=previewRecordId",
            selectedRelIDs: "=selectedRelIds",
            detailsUrl: "=",
            parentOpen: "=",
            level: "@",
            previewEntityID: '=?previewEntityId'
        },
        controller: RLAssociateTreeItemController,
        controllerAs: "atiVM",
        link: (scope: IRLAssociateTreeItemScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

            var pageCtrl: BaseAssociationController<any> = controllers[0];
            var ctrl: RLAssociateTreeItemController = controllers[1];

            // hook click event up to page controller
            ctrl.showEntityCallback = (entityID: string) => {
                pageCtrl.ShowEntity(entityID);
            };

            if (_.any(ctrl.childNodes) && ctrl.open) {
                var template = "<tbody ng-repeat='childNode in atiVM.childNodes' ng-show='atiVM.open && parentOpen' parent-open='atiVM.open' rl-associate-tree-item='' node='childNode' level='{{atiVM.levelInt+1}}' target-record-id='targetRecordID' preview-record-id='previewRecordID' selected-rel-ids='selectedRelIDs' details-url='detailsUrl' preview-entity-id='atiVM.previewEntityID' ng-class=\"{'preview-row':atiVM.previewEntityID==childNode.entity.id}\"></tbody>";
                var el = angular.element(template);
                var compiled = $compile(el);
                element.after(el);
                compiled(scope);
            }

            scope.$watch(() => pageCtrl.canEdit, (newValue, oldValue) => { ctrl.canEdit = newValue; });
        }
    };
    return directive;
}

interface IRLAssociateTreeItemScope extends ng.IScope {
    node: Models.IEntityNode;
    targetRecordID: number;
    previewRecordID: number;
    selectedRelIDs: number[];
    detailsUrl: string;
    parentOpen: boolean;
    level: string;

}

class RLAssociateTreeItemController {
    static $inject = ["$scope", "$interpolate"];

    levelInt: number;
    url: string;
    showCheckbox: boolean;
    childNodes: Models.IEntityNodeWRelID[];
    childCount: number;
    open: boolean;
    liClass: string;
    showEntityCallback: (entityID: string) => void;
    canEdit: boolean;
    previewEntityID: string;

    constructor(private $scope: IRLAssociateTreeItemScope, private $interpolate: ng.IInterpolateService) {

        var interpolated = $interpolate($scope.detailsUrl);
        this.levelInt = _.parseInt($scope.level);
        this.showCheckbox = $scope.node.entity.recordID == $scope.targetRecordID;
        this.childNodes = _($scope.node.relatedEntities)
            .pairs()
            .map((pair: any[]) => {
                var output: Models.IEntityNodeWRelID = pair[1];
                output.relID = pair[0];
                return output;
            })
            .sortBy((node) => node.entity.title)
            .valueOf();

        this.childCount = this.childNodes.length;
        this.open = true;
        this.liClass = "fa-caret-right";
        this.url = interpolated($scope);
        this.canEdit = false;

        $scope.$watch(() => this.open, (newValue: boolean, oldValue: boolean) => {
            var open = newValue;
            var newClass = "";
            if (this.childCount > 0) {
                if (open) {
                    newClass = "fa-minus-square-o";
                } else {
                    newClass = "fa-plus-square-o";
                }
            } else {
                newClass = "fa-fw";
            }
            this.liClass = newClass;
        });

        $scope.$watch("parentOpen", (newValue: boolean) => {
            if (!newValue) {
                this.open = false;
            }
        });

        $scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            this.previewEntityID = data;
        });
    }

    Toggle() {
        this.open = !this.open;
    }

    ShowEntity(entityID: string) {
        if (this.showEntityCallback != null) {
            this.previewEntityID = entityID;
            this.showEntityCallback(entityID);
        }
    }

}
/*
export function RLWorkflowExecute() {
	var directive: ng.IDirective = {
		restrict: "AE",
		template: require("/assets/app/templates/workflow-execute.html"),
		scope: {
			entityRecord: "=rlWorkflowExecute",     // ++++
			callback: "&?"                          // ++++
		},
		controller: RLWorkflowExecuteController,
		controllerAs: "wfeVM"
	};
	return directive;
}

interface IRLWorkflowExecuteScope extends ng.IScope {
	entityRecord: Models.IEntity;                   // ++++
	callback: () => ng.IPromise<any>;               // ++++
}

class RLWorkflowExecuteController {
	static $inject = ["$scope", "$timeout", "$q", "workflowService", "notifyService", "workflowConfigService", "docGenService", "entityService", "eventService"];

	statusID: number;       // ++++
	templateID: number;     // ++++
	charTypeID: number;     // ++++
	recordID: number;       // ++++
	processID: number;      // ++++
	initialized: boolean;   // ++++

	workflowActions: Models.IWFAction[];        // ++++

	/* ! * /// ++++

	actionID: number;

	buttonDisabled: boolean;
	wfModel: Models.IWFAction[];

	draftDoc: boolean;
	docGenTemplateID: number;
	allDocGenTemplates: Models.IDocTemplate[];
	allDocGenFormats: Models.IDocGenTemplate[];
	docGenFormat: Models.IDocGenTemplate;

	editNotification: boolean;
	notifications: Models.IWFNotificationWithAttachments[];
	documents: Models.IEntityDocumentsCollection;
	uploadedDocuments: { [key: string]: string };
	selectedNotification: Models.IWFNotificationWithAttachments;
	editNotificationView: number;

	documentPreviewModalOpen: boolean;
	documentModalTitle: string;
	documentViewSrc: string;
	documentFileName: string;
	documentTemplateGroupId: number;

	showJobProgressStatus: boolean;
	jobId: string;
	jobTitle: string;
	progressStatus: string;

	constructor(private $scope: IRLWorkflowExecuteScope, private $timeout: ng.ITimeoutService, private $q: ng.IQService, private workflowService: WorkflowService,
		private notifyService: NotifyService, private workflowConfigService: WorkflowConfigService, private docGenService: DocGenService, private entityService: EntityService, private eventService: EventService) {

		this.statusID = -1;     // ++++
		this.templateID = -1;   // ++++
		this.charTypeID = -1;   // ++++
		this.recordID = -1;     // ++++
		this.processID = -1;    // ++++

		/* ! * /// ++++

		this.actionID = -1;
		this.buttonDisabled = false;
		this.draftDoc = false;
		this.docGenTemplateID = null;
		this.allDocGenTemplates = [];
		this.allDocGenFormats = [];
		this.docGenFormat = null;

		this.editNotification = false;
		this.notifications = [];
		this.selectedNotification = null;
		this.editNotificationView = 0;
		this.initialized = false;
		this.documents = null;
		this.uploadedDocuments = {};
		this.documentPreviewModalOpen = false;

		this.wfModel = [];;

		/* ++++ * /
		$scope.$watch("entityRecord", (newValue: Models.IEntity, oldValue: Models.IEntity) => {
			if ((newValue != oldValue || !this.initialized) && newValue != null) {
				this.statusID = newValue.statusID;
				this.templateID = newValue.templateID;
				this.charTypeID = newValue.charTypeID;
				this.recordID = newValue.recordID;
			}
		}, true);

		/* ++++ * /
		$scope.$watch(() => [this.statusID, this.templateID, this.charTypeID, this.recordID],
			(newValue: any[], oldValue: any[]) => {
				if (_.all<any>(newValue, (val) => !_.isNaN(_.parseInt(val)))) {
					if (this.statusID > 0) {
						workflowService.getAvailableWorkflowActions(this.charTypeID, this.templateID, this.statusID)
							.then((result) => {
								this.workflowActions = result;
								if (this.workflowActions.length > 0) {
									this.processID = this.workflowActions[0].processID;
								}
							});
					}
				}
			}, true);

		/* ! * /// ++++
		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && (newValue == "Done" || newValue == "Failed")) {
				this.showJobProgressStatus = false;
				if (newValue == "Done") {
					this.notifyService.notifySuccess("Workflow Action Successful.");
				}
				else {
					this.notifyService.notifyError("Workflow Action Failed.");
				}
				entityService.getEntity(this.$scope.entityRecord.id)
					.then((result) => {
						this.statusID = result.record.statusID;
						if (this.$scope.callback != null) {
							return this.$scope.callback()
								.then(() => {
									return this.eventService.call(Consts.Events.WorkflowExecuted + this.$scope.entityRecord.id);
								});
						}
						else {
							return this.eventService.call(Consts.Events.WorkflowExecuted + this.$scope.entityRecord.id);
						}
					});
			}
		});
	}

	SetEditNotificationView(val: number) {
		this.editNotificationView = val;
	}

	LoadDocGenFormats() {
		//currently only two
		this.allDocGenFormats = [];
		this.allDocGenFormats.push(<Models.IDocGenTemplate>{ id: 1, name: Consts.DocGenFormats.PDF });
		this.allDocGenFormats.push(<Models.IDocGenTemplate>{ id: 2, name: Consts.DocGenFormats.DOCX });
		this.docGenFormat = _.find(this.allDocGenFormats, dgf => dgf.id = 1);
	}

	LoadTemplateTypes(charTypeID: number, charTemplateID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		var request = <Models.IDocTemplateByCharTemplateRequest>{};
		request.charTemplateID = charTemplateID;
		request.charTypeID = charTypeID;
		return this.workflowService.getDocTemplatesByCharTemplate(request)
			.then((results) => {
				this.allDocGenTemplates = results;
				if (_.any(this.allDocGenTemplates)) {
					this.docGenTemplateID = this.allDocGenTemplates[0].documentTemplateID;
				}
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
	CancelNotificationEdit() {
		this.notifyService.broadcastDone();
		this.editNotification = false;
	}
	Cancel() {
		this.notifyService.broadcastDone();
		this.draftDoc = false;
	}

	GenerateDoc(form: ng.IFormController) {
		if (form.$valid) {
			this.notifyService.startProgress();
			var req = <Models.IDocGenRequest>{};
			req.actionID = this.actionID;
			req.characteristicTypeID = this.charTypeID;
			req.documentTemplateID = this.docGenTemplateID;

			switch (this.charTypeID) {
				case Consts.CharTypeIDs.invoice:
					req.documentTypeID = 2;
					req.invoiceID = this.recordID;
					break;
				case Consts.CharTypeIDs.transaction:
				case Consts.CharTypeIDs.job:
					req.documentTypeID = 1;
					req.requestID = this.recordID;
					break;
			}
			req.formatType = this.docGenFormat.id;
			req.processID = _.find(this.workflowActions, (a) => { return a.actionID == this.actionID; }).processID;
			req.requestRevisionID = 0;
			req.templateFileName = _.find(this.allDocGenTemplates, (t) => { return t.documentTemplateID == this.docGenTemplateID; }).fileName;

			this.docGenService.createDoc(req)
				.then((result) => {
					if (result.success) {
						var fileName = result.fileName;
						this.workflowService.createBatchID()
							.then((batchIDResult) => {
								this.RunPreProcess(this.charTypeID, this.processID, this.actionID, this.recordID, this.statusID)
									.then(() => {
										this.ExecuteWorkflow(batchIDResult.batchID)
											.then(() => {
												this.draftDoc = false;
												var entityID = Utils.IdBuilder.buildEntityID(0, this.charTypeID, this.recordID);
												this.entityService.getEntityDocuments(entityID)
													.then((result) => {
														var recDocuments = result.recordDocuments;
														var recDocumentUrls = result.recordUrls;
														if (_.any(recDocuments, (doc) => doc.filename == fileName)) {
															var previewDoc = _.find(recDocuments, (doc) => doc.filename == fileName);
															var previewDocTitle = previewDoc.documentID + "-" + previewDoc.documentRevisionID;
															var previewDocUrl = recDocumentUrls[previewDocTitle];
															this.documentPreviewModalOpen = true;
															this.documentModalTitle = previewDocTitle;
															this.documentFileName = previewDoc.filename;
															this.documentViewSrc = previewDocUrl;
															this.documentTemplateGroupId = Consts.TemplateGroupIDs.RightslineDocTemplateGroup;
														}
													})
												this.notifyService.notifySuccess("Workflow action successful!");
											},
											() => {
												this.notifyService.notifyError("There was an error executing your workflow action.");
											})
											.finally(() => {
												this.notifyService.endProgress();
											});
									});
							});
					}
					else {
						this.draftDoc = false
						this.notifyService.notifyError("There was an error executing your workflow action.");
						this.notifyService.endProgress();
					}
				});
		}
		else {
			//console.log("form validation error");
		}
	}

	IsDocGenAction(actionID: number) {
		var a = _.find(this.workflowActions, (_a) => { return _a.actionID == actionID; });
		return a.docGenIndicator == 1;
	}

	SetAttachments(notification: Models.IWFNotificationWithAttachments): ng.IPromise<any> {
		var entityID = Utils.IdBuilder.buildEntityID(notification.divisionID, this.charTypeID, this.recordID);
		return this.entityService.getEntityDocuments(entityID)
			.then((results: Models.IEntityDocumentsCollection) => {
				this.documents = results;
				_.each(this.documents.uploadedDocuments, doc=> {
					var tagLabel = _.find(doc.charDataCollection.templateMetaData.characteristicMetaDatas, (md) => { return md.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.file }).tagLabel;
					var docFileName = doc.charDataCollection.charDatas[tagLabel][0].value;
					this.uploadedDocuments[doc.record.recordID] = docFileName;
				});
			});
	}

	SetNotificationAttachments(notification: Models.IWFNotificationWithAttachments): ng.IPromise<any> {
		return this.workflowService.getNotificationAttachments(this.charTypeID, this.recordID, 0, notification.id, 0)
			.then((results) => {
				notification.attachments = results;
			});
	}

	GetNotificationsForAction(actionID: number): ng.IPromise<any> {
		var retVal = false;
		var a = _.find(this.workflowActions, (_a) => { return _a.actionID == actionID; });
		return this.workflowConfigService.getEditAction(a.processID, a.actionID, this.charTypeID)
			.then((result) => {
				var action = result;
				return action.selectedRoleNotifications;
			});
	}

	SendNotifications() { //from edit/preview modal
		this.notifyService.startProgress();
		var a = _.find(this.workflowActions, (_a) => { return _a.actionID == this.actionID; });

		this.workflowService.createBatchID()
			.then((batchIDResult) => {
				var batchID = batchIDResult.batchID;

				var promises = [];
				var hasAttachments: boolean = false;

				_.each(this.notifications, (n) => {
					var request = <Models.IWFSendNotificationRequest>{};
					request.batchID = batchID;
					request.actionID = this.actionID;
					request.attachments = n.attachments;
					request.charTypeID = this.charTypeID;
					request.htmlText = n.bodyHTML;
					request.messageID = n.id;
					request.notificationSubject = n.subject;
					request.plainText = n.body;
					request.processID = a.processID;
					request.recordID = this.recordID;
					request.uploadedDocuments = {};
					_.each(n.uploadedDocuments, doc=> {
						request.uploadedDocuments[this.uploadedDocuments[doc]] = this.documents.documentUrls[doc];
						hasAttachments = true;
					});

					promises.push(this.workflowService.mergeAndAddNotificationToQueue(request));
				});

				return this.$q.all(promises)
					.then(() => {
						if (hasAttachments) {
							return this.ExecuteWorkflowAsJob(batchID)
								.then(() => {
									this.editNotification = false;
									this.notifyService.notifySuccess("Workflow action successful!");
								});
						}
						else {
							return this.ExecuteWorkflow(batchID)
								.then(() => {
									this.editNotification = false;
									this.notifyService.notifySuccess("Workflow action successful!");
								});
						}
					});
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	GetPreviewNotifications(processID: number, actionID: number): ng.IPromise<any> {
		return this.workflowConfigService.getPreviewNotifications(processID, actionID);
	}

	Execute() { //when selecting action from dropdown
		this.showJobProgressStatus = false;
		if (this.IsDocGenAction(this.actionID)) { //triggers modal with doc gen options
			if (this.allDocGenTemplates.length == 0) {
				this.notifyService.startProgress();
				this.LoadDocGenFormats();
				this.LoadTemplateTypes(this.charTypeID, this.templateID)
					.then(() => {
						this.draftDoc = true;
					})
					.finally(() => {
						this.notifyService.endProgress();
					});
			}
			else {
				this.draftDoc = true;
			}
		}
		else {
			this.notifyService.startProgress();
			this.GetPreviewNotifications(this.processID, this.actionID)
				.then((result) => {
					this.notifications = result.notifications;
					if (!_.isEmpty(this.notifications)) {
						this.LoadAttachments();
					}
					else {
						var batchID: string = '';
						return this.workflowService.createBatchID()
							.then((batchIDResult) => {
								batchID = batchIDResult.batchID;
								return this.workflowConfigService.getWorkflowActionExtensions(this.processID, this.actionID)
									.then((results) => {
										if (results.extensions.length > 0) {

											if (_.any(results.paths, (wfextpath) => wfextpath.pathTypeID == Consts.WorkflowExtPathType.ExecuteService)) {
												return this.ExecuteWorkflowAsJob(batchID);
											}
											else {
												return this.ExecuteWorkflow(batchID)
													.then(() => {
														this.notifyService.notifySuccess("Workflow action successful!");
													});
											}
										}
										else {
											return this.ExecuteWorkflow(batchID)
												.then(() => {
													this.notifyService.notifySuccess("Workflow action successful!");
												});
										}
									});
							});
					}
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	LoadAttachments() {
		var promises = [];
		_.each(this.notifications, (n) => {
			promises.push(this.SetAttachments(n));
			promises.push(this.SetNotificationAttachments(n));
		});

		this.$q.all(promises)
			.then(() => {
				this.selectedNotification = this.notifications[0];
				this.SetEditNotificationView(0);
				this.editNotification = true;
			});
	}

	/*individual steps* /
	AddNotificationsToQueue(charTypeID: number, recordID: number, actionID: number, batchID: string, processID: number): ng.IPromise<any> {
		return this.workflowService.addNotificationsToQueue(charTypeID, recordID, actionID, batchID, processID);
	}

	RunPreProcess(charTypeID: number, processID: number, actionID: number, recordID: number, statusID: number): ng.IPromise<any> {
		return this.workflowService.runPreProcess(charTypeID, processID, actionID, recordID, statusID);
	}

	RunPostProcess(charTypeID: number, processID: number, actionID: number, recordID: number, statusID: number): ng.IPromise<any> {
		return this.workflowService.runPostProcess(charTypeID, processID, actionID, recordID, statusID);
	}

	SendNotificationsFromQueue(charTypeID: number, recordID: number, batchID: string): ng.IPromise<any> {
		return this.workflowService.sendNotificationsFromQueue(charTypeID, recordID, batchID);
	}

	WorkflowUpdateEntityStatus(charTypeID: number, processID: number, actionID: number, recID: number, statusID: number): ng.IPromise<any> {
		return this.workflowService.workflowUpdateEntityStatus(charTypeID, processID, actionID, recID, statusID);
	}
	/*individual steps* /

	ExecuteWorkflowAsJob(batchID: string): ng.IPromise<any> {
		return this.workflowService.executeWorkflowJob(this.charTypeID, this.recordID, this.actionID, this.processID, batchID)
			.then((result) => {
				this.showJobProgressStatus = true;
				this.jobId = result.jobID;
				this.jobTitle = result.jobTitle;
			});
	}

	ExecuteWorkflow(batchID: string): ng.IPromise<any> {
		this.showJobProgressStatus = false;
		return this.workflowService.executeWorkflow(this.charTypeID, this.recordID, this.actionID, this.processID, batchID)
			.then((result) => {
				var newStatusID = result.newStatusID;
				if (newStatusID != this.statusID) {
					this.statusID = newStatusID;
				}

				if (this.$scope.callback != null) {
					return this.$scope.callback()
						.then(() => {
							return this.eventService.call(Consts.Events.WorkflowExecuted + this.$scope.entityRecord.id);
						});
				}
				else {
					return this.eventService.call(Consts.Events.WorkflowExecuted + this.$scope.entityRecord.id);
				}
			});
	}

	CloseDocModal() {
		this.documentFileName = "";
		this.documentModalTitle = "";
		this.documentViewSrc = "";
		this.documentPreviewModalOpen = false;
	}
}
*/

RLPageDisabler.$inject = ["eventService"];
export function RLPageDisabler(eventService: EventService) {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: "<div class='pageDisabler'></div>",
        replace: true,
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            eventService.on(Consts.Events.NotifyStart, () => {
                element.show();
            });

            eventService.on(Consts.Events.NotifyDone, () => {
                element.hide();
            });
        }
    };
    return directive;
}

export function RLEntityStatusInfo() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-status-info.html"),
        replace: true,
        controller: RLEntityStatusInfoController,
        controllerAs: "esiVM",
        scope: {
            entityID: "=rlEntityStatusInfo"
        }
    };
    return directive;
}

interface IRLEntityStatusInfoScope extends ng.IScope {
    entityID: string;
}

class RLEntityStatusInfoController {
    static $inject = ["$scope", "entityService", "notifyService"];

    charTypeName: string;
    recordID: string;
    template: string;
    createdBy: string;
    created: string;
    status: string;
    statusUpdated: string;
    loaded: boolean;

    constructor(private $scope: IRLEntityStatusInfoScope, private entityService: EntityService, private notifyService: NotifyService) {
        this.loaded = false;
        $scope.$watch(() => $scope.entityID,
            (newValue, oldValue) => {
                if (!_.isEmpty(newValue)) {
                    this.RefreshInfo(newValue);
                }
            });
    }

    RefreshInfo(entityID: string) {
        this.entityService.getEntityRecord(entityID)
            .then((result) => {
                var record = result;
                this.charTypeName = "Request";
                if (record.charTypeID == Consts.CharTypeIDs.transaction) {
                    this.recordID = record.recordID + "-" + record.recordRevisionID;
                } else {
                    this.recordID = record.recordID.toString();
                }
                this.template = record.template;
                this.created = record.created;
                this.status = record.status;
                this.statusUpdated = record.statusUpdated;
                return this.RefreshUser(record.divisionID, record.createdBy);
            }, () => {
                this.notifyService.notifyError("Error loading status");
            })
            .then(() => {
                this.loaded = true;
            });
    }

    RefreshUser(divID: number, userID: number) {
        var userEntityID = Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.user, userID);
        return this.entityService.getEntityRecord(userEntityID)
            .then((result) => {
                var record = result;
                this.createdBy = record.title;
            });
    }
}

RLAssetPopup.$inject = ["$compile", "$timeout", "$q", "attachmentService", "entityService"];
export function RLAssetPopup($compile: ng.ICompileService, $timeout: ng.ITimeoutService, $q: ng.IQService, attachmentService: AttachmentService, entityService: EntityService) {
    var directive: ng.IDirective = {
        restrict: "A",
        scope: {
            assetID: "@rlAssetPopup",
            charTypeID: "@rlCharTypeId"
        },
        link: (scope: IRLAssetPopupScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var timeoutPromise: ng.IPromise<any> = null;

            // on mouseover start a 1 second timer with a promise
            element.mouseover((e) => {
                timeoutPromise = $timeout(getPopup, 1000);
            });

            // on mouse out, kill the previous promise
            element.mouseout((e) => {
                if (timeoutPromise != null) {
                    $timeout.cancel(timeoutPromise);
                }
                element.popover("hide");
            });

            // on directive destroy, remove element popover api
            scope.$on("$destroy", () => {
                element.popover("destroy");
            });


            // setup popup
            var getPopup = () => {
                // destroy existing popovers on element
                element.popover("destroy");

                // build entityID
                var entityID = Utils.IdBuilder.buildEntityID(0, scope.charTypeID, scope.assetID);

                // instantiate an entityMiniInfo directive
                var templateEl = angular.element("<div rl-entity-mini-info='' record='record' image-src='imageSrc' ></div>");
                var compiled = $compile(templateEl);

                // start 2 tasks (entityinfo + keyart)
                $q.all<Models.IEntity | Models.IKeyArtResponse>([entityService.getEntityRecord(entityID), attachmentService.getKeyArt(entityID)])
                    .then((results) => {
                        // entity response
                        var entity = <Models.IEntity>results[0];
                        // keyart response
                        var keyArtResult = <Models.IKeyArtResponse>results[1];

                        // set record to local scope
                        scope.record = entity;

                        // function to activate popup
                        var runPopUp = () => {
                            // evaluate scope
                            compiled(scope);
                            // run popup options
                            $timeout(() => {
                                var options: PopoverOptions = {
                                    placement: "right",
                                    html: true,
                                    content: () => templateEl,
                                    title: scope.record.title
                                };
                                element.popover(options);
                                element.popover("show");
                            }, 0);

                        };

                        // if keyart was found
                        if (!_.isEmpty(keyArtResult.src)) {
                            // start loading the source and proceed depending on result of image load
                            var image = new Image();
                            // on success
                            image.onload = () => {
                                // set src on scope
                                scope.imageSrc = image.src;
                                // run popup
                                runPopUp();
                            };
                            // on error
                            image.onerror = () => {
                                // run popup without src
                                runPopUp();
                            };
                            // start activation
                            image.src = keyArtResult.src;
                        } else {
                            // run popup without src
                            runPopUp();
                        }
                    });
            };
        }
    };
    return directive;
}

interface IRLAssetPopupScope extends ng.IScope {
    assetID: number;
    charTypeID: number;
    record: Models.IEntity;
    imageSrc: string;
}

export function RLEntityMiniInfo() {
    var directive: ng.IDirective = {
        restrict: "AE",
        replace: true,
        template: require("/assets/app/templates/entity-mini-info.html"),
        scope: {
            record: "=",
            imageSrc: "="
        }
    };
    return directive;
}

/*
 * Directive for quick bootstrap modal dialog template
 * 
 * <rl-modal modal-open="[[2-way bound to boolean]]" modal-style="[string of style]">
 *      <modal-title>[title controls]</modal-title>
 *      <modal-body>[body controls]</modal-body>
 *      <modal-footer>[button controls]</modal-footer>
 * </rl-modal>
 */
RLModal.$inject = ['$compile', '$document'];
export function RLModal($compile: ng.ICompileService, $document: ng.IDocumentService) {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/modal.html"),
        transclude: true,
        scope: {
            open: "=modalOpen",
            form: "=modalForm"
        },
        controller: RLModalController,
        controllerAs: "mVM",
        require: "rlModal",
        link: (scope: RLModalScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLModalController, transclude: ng.ITranscludeFunction) => {
            var style = attributes["modalStyle"];
            if (!_.isNull(style) && !_.isEmpty(style)) {
                element.find(".modal-dialog").attr("style", style);
            }

            var attach = (clone: JQuery, transcludeSelector: string, transcludeTargetSelector: string) => {
                var $part = clone.find(transcludeSelector).addBack(transcludeSelector);
                var targetEl = element.find(transcludeTargetSelector);
                targetEl.empty();
                targetEl.append($part);
            };

            transclude(scope.$parent, (clone) => {

                var modalHeaderElement = _.find(clone, (c) => {
                    var tagName = $(c).prop("tagName");
                    return (!_.isEmpty(tagName) && tagName.toLowerCase() === "modal-header");
                });

                if (modalHeaderElement != null) {
                    attach(clone, "modal-header", ".modal-header");
                }
                attach(clone, "modal-body", ".modal-body");
                attach(clone, "modal-title", ".modal-title");
                attach(clone, "modal-footer", ".modal-footer");

                //if (attributes["appendToBody"]) {
                //    angular.element(element).remove();

                //    $document.find('body').append(element);
                //}
            });
        }
    };
    return directive;
}


interface RLModalScope extends ng.IScope {
    open: boolean;
    form: ng.IFormController;
}

export class RLModalController {
    static $inject = ["$scope"];
    constructor(private $scope: RLModalScope) {

    }

    Close() {
        this.$scope.open = false;
    }
}

/* Transclude inner content to a directives inner element with matching class name */
export function RLTranscludeByClass() {
    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any, transclude: ng.ITranscludeFunction) => {
            var classKey: string = attributes["rlTranscludeByClass"];
            var targetScope: ng.IScope = scope.$parent;
            transclude(targetScope, (clone) => {
                _.forEach(clone, (item) => {
                    // only if transcluded content's tag-name matches classKey  ex. <modal-title>...</modal-title>  transcludes to <div class="modal-title">..</div>
                    if (item.tagName != null && item.tagName == classKey.toUpperCase()) {
                        element.empty();
                        element.append(item);
                    }
                });
            });
        }
    };
    return directive;
}



export interface IRLKeyArtScope extends ng.IScope {
    assetID: number;
    entityID: string;
    entityIDObj: Models.IEntityID;
    hasImage: boolean;
    attachmentTypeID: number;
    editMode: boolean;
    saveAttachmentTypeID: number;
    allowHover: boolean;
    maxSize: number;
    readonly: boolean;
    pickedFile: IFilestackPickFile;
}

RLKeyArt.$inject = ["$timeout", "eventService"];
export function RLKeyArt($timeout: ng.ITimeoutService, eventService: EventService) {

    var keyArtSrc: string;
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/keyart.html"),
        controller: AssetKeyArtController,
        controllerAs: "keyArtVM",
        scope: {
            entityID: "=?rlEntityId",
            assetID: "=?rlAssetId",
            hasImage: "=?",
            attachmentTypeID: "=?rlattachmentTypeId",
            editMode: "=?rlEditMode",
            saveAttachmentTypeID: "=?rlSaveAttachmentTypeId",
            allowHover: "=?rlAllowHover",
            maxSize: "=?rlMaxSize",
            readonly: '@',
            pickedFile: "=",
            locked: "=?"
        },
        link: (scope: IRLKeyArtScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: AssetKeyArtController) => {

            element.find("img#keyart").on('load', function () {
                controller.ResetActivityIndicator();  // dismisses activity indicator when the image is finished loading (for rotate / upload)
            });

            scope.$watch(() => controller.keyArtSrc,
                (newValue: string, oldValue: string) => {
                    if (newValue != oldValue && !_.isEmpty(newValue)) {
                        loadImage(newValue);
                    }
                });

            eventService.on(Consts.Events.KeyArtSave, (fpe: Models.IFilestackPickFileWithEntityID) => {
                if (fpe.entityID == scope.entityID) { //only if entity ID is the same
                    controller.pickedFile = fpe.pickedFiles[0];
                }
            });

            var loadImage = (keyArtSrc: string) => {
                if (!_.isNumber(controller.attachmentTypeID)) {
                    $timeout(() => {
                        controller.attachmentTypeID = Consts.AttachmentTypeDicts.IDs[Consts.AttachmentTypeNames.KeyArt];
                    });
                }
                scope.maxSize = Consts.AttachmentTypeDicts.MaxSizes[controller.attachmentTypeID];
                var image = new Image();

                // image successfully loads callback
                image.onload = () => {
                    // set <img src='[src]' />
                    element.find("img#keyart").attr("src", image.src);
                    // show image
                    element.find("img#keyart").show();
                    $timeout(() => {
                        // update flag (on next scope digest)
                        //controller.hasImage = true; //
                    });
                };

                // image fails to load callback
                image.onerror = () => {
                    // hide <img />
                    //element.find("img#keyart").hide();
                    element.find("img#keyart").attr("src", Consts.DefaultImages.KeyartMissing);
                    $timeout(() => {
                        // update flag (on next scope digest)
                        controller.hasImage = false;
                    });
                };

                // start image load
                image.src = keyArtSrc;
            };

            scope.$watch(() => scope.assetID,
                (newValue: number, oldValue: number) => {
                    if (newValue != oldValue && !_.isEmpty(newValue)) {
                        controller.assetID = newValue;
                        controller.SetKeyArtSrc();
                    }
                });
            scope.$watch(() => scope.entityID,
                (newValue: string, oldValue: string) => {
                    if (newValue != oldValue && !_.isEmpty(newValue)) {
                        controller.entityID = newValue;
                        scope.entityIDObj = Utils.IdBuilder.splitEntityID(newValue);
                    }
                });
            scope.$watch(() => scope.saveAttachmentTypeID,
                (newValue: number, oldValue: number) => {
                    if (newValue != oldValue && !_.isEmpty(newValue)) {
                        controller.saveAttachmentTypeID = newValue;
                    }
                });
            scope.$watch(() => scope.allowHover,
                (newValue: boolean, oldValue: boolean) => {
                    if (newValue != oldValue && !_.isEmpty(newValue)) {
                        controller.allowHover = newValue;
                    }
                });

            if (!_.isEmpty(scope.entityID)) {
                $timeout(() => {
                    controller.entityID = scope.entityID;
                    scope.entityIDObj = Utils.IdBuilder.splitEntityID(scope.entityID);
                });
            }
            //if (_.isNumber(scope.assetID)) {
            //    $timeout(() => {
            //        controller.assetID = scope.assetID;
            //    });
            //}
            if (_.isNumber(scope.saveAttachmentTypeID)) {
                $timeout(() => {
                    controller.saveAttachmentTypeID = scope.saveAttachmentTypeID;
                });
            }
            if (_.isBoolean(scope.allowHover)) {
                $timeout(() => {
                    controller.allowHover = scope.allowHover;
                });
            }

        }
    };
    return directive;
}


export interface IAssetKeyArtControllerScope extends ng.IScope {
    entityID: string;
    entityIDObj: Models.IEntityID;
    assetID: number;
    assetTypeID: number;
    hasImage: boolean;
    showBtnUpload: boolean;
    keyArtSrc: string;
    saveAttachmentTypeID: number;
    allowHover: boolean;
    maxSize: number;
    locked: boolean;
}

export class AssetKeyArtController {
    static $inject = ["$scope", "$sce", "$window", "attachmentService", "notifyService"];

    pickedFile: IFilestackPickFile;
    attachmentTypeID: number;       // [1:keyart,2:keyart-small,3:original,4:other]
    entityID: string;               // entity ID in d{0}c{1}r{2} format
    entityIDObj: Models.IEntityID;
    assetID: number;
    hasImage: boolean;              // set by directive
    keyArtSrc: string;              // set by directive
    saveAttachmentTypeID: number;   //set by directive
    allowHover: boolean;
    maxSize: number;
    locked: boolean;


    public activityIndicatorMessage: string = "Processing...";
    public shouldShowActivityIndicator: boolean = false;

    constructor(private $scope: IAssetKeyArtControllerScope, private $sce: ng.ISCEService, private $window: ng.IWindowService,
        public attachmentService: AttachmentService, private notifyService: NotifyService) {
        this.attachmentTypeID = Consts.AttachmentTypes.KeyArt;
        this.keyArtSrc = "";
        this.hasImage = false;
        this.saveAttachmentTypeID = Consts.AttachmentTypes.KeyArt;
        this.allowHover = true;
        this.maxSize = Consts.AttachmentTypeDicts.MaxSizes[Consts.AttachmentTypes.KeyArt];
        this.entityID = "";
        this.entityIDObj = <Models.IEntityID>{};
        this.assetID = 0;

        $scope.$watch(() => this.pickedFile,
            (newValue: IFilestackPickFile, oldValue: IFilestackPickFile) => {
                if (newValue != oldValue && newValue != null) {
                    this.notifyService.startProgress();
                    this.ShowActivityIndicator("Uploading image...");
                    this.SaveKeyArt(newValue)
                        .then((results) => {
                            this.notifyService.notifySuccess("Uploaded");
                            this.SetKeyArtSrc();
                        })
                        .finally(() => {
                            notifyService.endProgress();
                        });
                }
            }, true);

        $scope.$watch(() => this.assetID,
            (newValue: number, oldValue: number) => {
                if (newValue != oldValue && _.isNumber(newValue)) {
                    $scope.assetID = newValue;
                    if (_.isEmpty(this.entityID)) {
                        this.entityID = Utils.IdBuilder.buildEntityID(0, 0, newValue);//temp until we can test avails
                    }
                    this.SetKeyArtSrc();
                }
            });

        $scope.$watch(() => this.entityID,
            (newValue: string, oldValue: string) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    $scope.entityID = newValue;
                    this.entityIDObj = Utils.IdBuilder.splitEntityID(newValue);
                    $scope.entityIDObj = this.entityIDObj;
                    this.SetKeyArtSrc();
                }
            });

        $scope.$watch(() => this.keyArtSrc,
            (newValue: string, oldValue: string) => {
                if (newValue != oldValue && !_.isEmpty(newValue)) {
                    $scope.keyArtSrc = newValue;
                }
            });

        $scope.$watch(() => this.hasImage,
            (newValue: boolean, oldValue: boolean) => {
                if (newValue != oldValue) {
                    $scope.hasImage = newValue;
                }
            });

        $scope.$watch(() => $scope.saveAttachmentTypeID,
            (newValue: number, oldValue: number) => {
                if (newValue != oldValue) {
                    this.saveAttachmentTypeID = newValue;
                }
            });

        $scope.$watch(() => $scope.allowHover,
            (newValue: boolean, oldValue: boolean) => {
                if (newValue != oldValue) {
                    this.allowHover = newValue;
                }
            });

        $scope.$watch(() => $scope.locked, (newValue: boolean, oldValue: boolean) => {
            this.locked = newValue;
        });

    }

    SetAssetID(entityID: string) {
        var recID = Utils.IdBuilder.splitEntityID(entityID).recID;
        this.assetID = recID;
    }

    DeleteKeyArt() {
        if (this.$window.confirm("Are you sure you want to delete the Key Art?")) {
            this.notifyService.startProgress();
            this.attachmentService.getAssetAttachments(this.entityID, Consts.AttachmentTypes.KeyArt)
                .then((result) => {
                    if (result.length == 1) {
                        var attachmentID = result[0].attachmentID;
                        this.attachmentService.deleteAssetAttachment(this.entityIDObj.charTypeID, this.entityIDObj.recID, attachmentID, Consts.AttachmentTypes.KeyArt)
                            .then(() => {
                                this.SetKeyArtSrc();
                                this.notifyService.notifySuccess("Key Art deleted successfully");
                            }, () => {
                                this.notifyService.notifyError("Key Art could not be deleted");
                            });
                    }
                    else {
                        this.notifyService.notifyError("Key Art could not be deleted");
                    }
                }).finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    SaveKeyArt(fpFile: IFilestackPickFile): ng.IPromise<any> {
        if (!_.isEmpty(fpFile)) {
            // build request message
            var request: Models.IEntityAttachmentRequest = {
                charTypeID: this.entityIDObj.charTypeID,
                recID: this.entityIDObj.recID,
                path: fpFile.key,
                name: fpFile.filename,
                attachmentTypeID: this.saveAttachmentTypeID,
                makeKeyArt: false,
                makeThumb: false
            };

            // call	service
            return this.attachmentService.saveAttachment(request);
        }
        return;
    }

    SetKeyArtSrc(): ng.IPromise<any> {
        return this.attachmentService.getAssetAttachments(this.entityID, this.attachmentTypeID)
            .then((result) => {
                if (result.length > 0) {
                    this.keyArtSrc = result[0].mediaUrl;
                    this.hasImage = true;

                } else {
                    this.keyArtSrc = Consts.DefaultImages.KeyartMissing;
                    this.hasImage = false;
                }
            });
    }

    private ShowActivityIndicator(message: string) {
        this.activityIndicatorMessage = message;
        this.shouldShowActivityIndicator = true;
    }

    public ResetActivityIndicator() {
        this.shouldShowActivityIndicator = false;
    }

    RotateKeyArt() {
        this.notifyService.startProgress();
        this.ShowActivityIndicator("Rotating...");
        this.attachmentService.rotateImage(this.entityIDObj.charTypeID, this.entityIDObj.recID, 0, this.attachmentTypeID, 1)
            .then(() => {
                this.SetKeyArtSrc()
                    .then(() => {
                        this.notifyService.notifySuccess("Key Art rotated");
                    })
                    .finally(() => {
                        this.ShowActivityIndicator("Reloading...");
                        this.notifyService.endProgress();
                    });
            });
    }
}


/* keeps the WCF service alive by pinging every 10 mins */
RLKeepAlive.$inject = ["$timeout", "$interval", "infoService"];
export function RLKeepAlive($timeout: ng.ITimeoutService, $interval: ng.IIntervalService, infoService: InfoService) {
    var directive: ng.IDirective = {
        restrict: "A",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            // 10 mins worth of milliseconds
            var interval: number = 10 * 60 * 1000;
            // promise for the interval
            var intervalPromise: ng.IPromise<any> = null;
            // promise for the timeout, wait 10 mins before starting interval
            var timeoutPromise = $timeout(() => {
                // start running this service on 10 min intervals
                intervalPromise = $interval(() => {
                    infoService.keepAlive();
                }, interval);
            }, interval);

            // on destroy
            scope.$on("$destroy", () => {
                // cancel timeout promise
                $timeout.cancel(timeoutPromise);
                // cancel interval promise
                if (intervalPromise != null) {
                    $interval.cancel(intervalPromise);
                }
            });
        }
    };
    return directive;
}

export function RLDynamicReportCell() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/dynamicReportCell.html"),
        scope: {
            characteristic: "=",
            row: "="
        }
    };
    return directive;
}

RLCharMultiSelect.$inject = ["entityConfigService"];
export function RLCharMultiSelect(entityConfigService: EntityConfigService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "?ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: ng.INgModelController) => {
            var disabled = element.prop("disabled");
            element.prop("disabled", true);
            element.prop("multiple", "multiple");
            if (ngModel != null) {
                ngModel.$render = () => {
                    $("option", element).each(() => {
                        if ($.inArray($(this).val(), ngModel.$viewValue) > -1) {
                            $(this).attr("selected", "true");
                        } else {
                            $(this).attr("selected", "false");
                        }
                    });
                };
            }

            scope.$watch(() => [attrs["rlCharTypeId"], attrs["rlTemplateId"]], (newValue, oldValue) => {
                if (newValue.join(",") != oldValue.join(",")) {
                    var charTypeID = attrs["rlCharTypeId"];
                    var templateID = attrs["rlTemplateId"];
                    $("option[value!='']", element).remove();
                    if (charTypeID > 0 && templateID > 0) {
                        entityConfigService.getCharacteristicTemplateMetaDataCollection(charTypeID, templateID)
                            .then((result) => {
                                result.forEach((char: Models.ICharacteristic) => {
                                    element.append($("<option />").attr("value", char.tagLabel).html(char.label));
                                });
                                if (ngModel != null) {
                                    ngModel.$setViewValue([]); // $("option:first").val());
                                }
                            }).then(() => {
                                var attrValue = attrs["rlCharDataTypeSelect"];
                                if (ngModel != null) {
                                    ngModel.$render();
                                } else if (attrValue != null && !_.isEmpty(attrValue)) {
                                    element.val(attrValue);
                                }
                                if (!disabled) {
                                    element.prop("disabled", false);
                                }
                            });
                    }
                }
            }, true);
        }
    };
    return directive;
}

RLCheckListModel.$inject = ["$parse", "$compile"];
export function RLCheckListModel($parse: ng.IParseService, $compile: ng.ICompileService) {
    // contains
    var contains = (arr, item): boolean => {
        if (angular.isArray(arr)) {
            for (var i = 0; i < arr.length; i++) {
                if (angular.equals(arr[i], item)) {
                    return true;
                }
            }
        }
        return false;
    };

    // add
    var add = (arr, item, trackBy?: (any) => any): any[] => {
        arr = angular.isArray(arr) ? arr : [];
        var value1 = item;
        if (trackBy != null) {
            value1 = trackBy(value1);
        }
        for (var i = 0; i < arr.length; i++) {
            var value2 = arr[i];
            if (trackBy != null) {
                value2 = trackBy(value2);
            }
            if (angular.equals(value2, value1)) {
                return arr;
            }
        }
        arr.push(item);
        return arr;
    };

    // remove
    var remove = (arr, item, trackBy?: (any) => any) => {
        if (angular.isArray(arr)) {
            var value1 = item;
            if (trackBy != null) {
                value1 = trackBy(value1);
            }
            for (var i = 0; i < arr.length; i++) {
                var value2 = arr[i];
                if (trackBy != null) {
                    value2 = trackBy(value2);
                }
                if (angular.equals(value2, value1)) {
                    arr.splice(i, 1);
                    break;
                }
            }
        }
        return arr;
    };

    // http://stackoverflow.com/a/19228302/1458162
    var postLinkFn = (scope: IRLCheckListModelScope, elem: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
        // compile with `ng-model` pointing to `checked`
        $compile(elem)(scope);

        // getter / setter for original model
        var getter = $parse(attrs["checklistModel"]);
        var setter = getter.assign;

        var trackBy: (item: any) => any = null;

        if (attrs["checklistTrackBy"]) {
            var trackByParser = $parse(attrs["checklistTrackBy"]);
            trackBy = (item) => {
                return trackByParser({ $item: item });
            };
        }

        // value added to list
        var value = $parse(attrs["checklistValue"])(scope.$parent);

        // watch UI checked change
        scope.$watch<boolean>(() => scope.checked, (newValue, oldValue) => {
            if (newValue === oldValue) {
                return;
            }
            var current = getter(scope.$parent);
            if (newValue === true) {
                setter(scope.$parent, add(current, value, trackBy));
            } else {
                setter(scope.$parent, remove(current, value, trackBy));
            }
        });


        var watchFunc = () => {
            var arr = getter(scope.$parent);
            if (trackBy != null && angular.isArray(arr)) {
                return (<any[]>arr).map(v => trackBy(v));
            } else {
                return arr
            }
        };

        // watch original model change
        scope.$parent.$watch(() => watchFunc(),
            (newArr, oldArr) => {
                //console.log("checking  " + attrs["checklistModel"] + " " + totalTime + "ms");
                var checkValue = value;
                if (trackBy != null) {
                    checkValue = trackBy(value);
                }
                scope.checked = contains(newArr, checkValue);

            }, true);
    };

    var directive: ng.IDirective = {
        restrict: "A",
        priority: 1000,
        terminal: true,
        scope: true,
        compile: (tElement: ng.IAugmentedJQuery, tAttrs: ng.IAttributes) => {
            if (tElement[0].tagName !== "INPUT" || !tElement.attr("type", "checkbox")) {
                throw "checklist-model should be applied to 'input[type='checkbox']'.";
            }

            if (!tAttrs["checklistValue"]) {
                throw "You should provide 'checklist-value'.";
            }

            // exclude recursion
            tElement.removeAttr("checklist-model");

            // local scope var storing individual checkbox model
            tElement.attr("ng-model", "checked");

            return postLinkFn;
        }
    };

    return directive;
}

interface IRLCheckListModelScope extends ng.IScope {
    checked: boolean;
}



RLTextareaWriter.$inject = ["eventService"];
export function RLTextareaWriter(eventService: EventService) {
    var directive: ng.IDirective = {
        restrict: "A",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var logName = attributes["rlTextareaWriter"];

            var prepend = attributes["writeMode"] == "prepend" || false;

            eventService.on("write:" + logName, (text: string) => {
                element.val((i: number, txt: string) => {
                    if (txt.length == 0) {
                        return text;
                    } else {
                        if (prepend) {
                            return text + "\n" + txt;
                        } else {
                            return txt + "\n" + text;
                        }
                    }
                });
            });

            eventService.on("clear:" + logName, () => {
                element.val("");
            });
        }
    };
    return directive;
}

/*
 * Directive for a persistant drop-panel similar to droplist
 * <div rl-drop-panel=''><button data-toggle='droppanel'>[click this]</button><div class='droppanel'>[content here]</div></div>
 */
RLDropPanel.$inject = ["$q", "$timeout"];
export function RLDropPanel($q: ng.IQService, $timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        restrict: "A",
        controller: RLDropPanelController,
        controllerAs: "dpVM",
        bindToController: {
            onDropPanelOpen: "&?",
            watchOpen: "=?open"
        },
        scope: true,
        require: "rlDropPanel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLDropPanelController) => {

            var backdrop = ".droppanel-backdrop";
            var arrow = ".arrow";
            var $parent = element;
            var button = element.find("*[data-toggle=droppanel]");
            var panel = element.find(".droppanel");


            var close = (e?: JQueryEventObject) => {
                $(backdrop).remove();
                $(arrow).removeClass("open");
                if (!$parent.hasClass("open")) { return; }
                if (e != null && e.isDefaultPrevented()) { return; }
                $parent.removeClass("open");
                $timeout(() => {
                    controller.open = false;
                    controller.watchOpen = false;
                });
            };

            var open = () => {
                $parent.toggleClass("open");
                $(arrow).toggleClass("open");
                $timeout(() => {
                    controller.open = true;
                    controller.watchOpen = true;
                });
            };

            var toggle = (e?: JQueryEventObject) => {
                var isActive = $parent.hasClass("open");
                close();
                if (!isActive) {
                    var backdropdiv = $("<div class='droppanel-backdrop'></div>").click(<any>close);
                    element.append(backdropdiv);
                    if (e != null && e.isDefaultPrevented()) { return; }
                    scope.$parent.$broadcast(Consts.Events.RLDropPanelOpening);
                    if (controller.onDropPanelOpen != null) {
                        $q.when(controller.onDropPanelOpen())
                            .then(() => open());
                    } else {
                        open();
                    }
                }
            };


            if (button != null && panel != null) {
                button.click(<any>toggle);
                panel.click((e) => {
                    e.stopPropagation();
                });
            }

            scope.$on(Consts.Events.RLDropPanelClose, () => {
                close();
            });

            scope.$watch(() => controller.watchOpen, (newValue, oldValue) => {
                if (newValue === true && oldValue !== true && !controller.open) {
                    toggle();
                } else if (newValue === false && oldValue !== true && controller.open) {
                    toggle();
                }
            });
        }
    };
    return directive;
}

class RLDropPanelController {
    static $inject = ["$scope"];

    onDropPanelOpen: () => ng.IPromise<any> | void;
    open: boolean;
    watchOpen: boolean;

    constructor(private $scope: ng.IScope) {
    }
}





RLHierarchyRow.$inject = ["$compile", "$timeout", "$window"];
/**
 * Directive for a single row of the Hierarchy nodes
 * <li  rl-hierarchy-row="" node="[row node]" nodes="[current node list]" level="[level number]"></li>
 **/
export function RLHierarchyRow($compile: ng.ICompileService, $timeout: ng.ITimeoutService, $window: ng.IWindowService) {
    // current node being dragged over (static among all rlHierarchyRow instances)
    var currentDropSpan: JQuery = null;
    var hoverTopClass = "hover-top";
    var hoverMiddleClass = "hover-middle";
    var hoverBottomClass = "hover-bottom";

    var directive: ng.IDirective = {
        template: require("/assets/app/templates/hierarchy-row.html"),
        controller: RLHierarchyRowController,
        controllerAs: "hrVM",
        replace: true,
        require: ["rlHierarchyRow", "^rlHierarchyList", "^ngController"],
        scope: {
            node: "=",
            nodes: "=",
            level: "="
        },
        link: (scope: IRLHierarchyRowScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            // controllers for tree, current level list, current row
            var rowCtrl = <RLHierarchyRowController>controllers[0];
            var listCtrl = <RLHierarchyListController>controllers[1];
            var treeCtrl = <HierarchyController>controllers[2];

            // set parent list controller to row controller
            rowCtrl.listCtrl = listCtrl;
            // set page controller to row controller
            rowCtrl.treeCtrl = treeCtrl;

            if (scope.node != null) {
                // build out the nested hierarchy list
                var templateElement = angular.element("<div rl-hierarchy-list='' nodes='node.childNodes' add-mode='hrVM.addMode' parent-node='node' level='hrVM.nextLevel' ng-if='hrVM.open'></div>");
                var compiled = $compile(templateElement);
                element.append(templateElement);
                compiled(scope);
            }

            // event called as mouse drags a node
            var mouseMoved: JQueryUI.DraggableEvent = (event, ui) => {
                if (currentDropSpan != null) {
                    // current coords of mouse pointer
                    var mouseCoords = { top: event["pageY"], left: event["pageX"] };
                    // current coords of the row being dragged over
                    var dropCoords = currentDropSpan.offset();

                    // vertical differnce of mouse and drop zone row
                    var topDiff = mouseCoords.top - dropCoords.top;

                    // percent coverage of the pointer over the drop zone row (0.0 - top, 1.0 - bottom)
                    var percentageCovered = topDiff / dropSpan.outerHeight();
                    // current positionState of the drop zone row
                    var positionState = currentDropSpan.data("positionstate") || Consts.PositionState.none;

                    // calculate which portion of the dropzone (top middle bottom) is being hovered over;
                    if (percentageCovered >= 0 && percentageCovered < .25) {
                        //top fourth
                        if (positionState != Consts.PositionState.before) {
                            positionState = Consts.PositionState.before;
                            currentDropSpan.data("positionstate", positionState);
                            currentDropSpan.removeClass(hoverMiddleClass + " " + hoverBottomClass).addClass(hoverTopClass);
                        }
                    } else if (percentageCovered >= .25 && percentageCovered <= .75 && !rowCtrl.flatList) {
                        // middle half
                        if (positionState != Consts.PositionState.onto) {
                            positionState = Consts.PositionState.onto;
                            currentDropSpan.data("positionstate", positionState);
                            currentDropSpan.removeClass(hoverTopClass + " " + hoverBottomClass).addClass(hoverMiddleClass);
                        }
                    } else if (percentageCovered > .75 && percentageCovered <= 1) {
                        // bottom fourth
                        if (positionState != Consts.PositionState.after) {
                            positionState = Consts.PositionState.after;
                            currentDropSpan.data("positionstate", positionState);
                            currentDropSpan.removeClass(hoverTopClass + " " + hoverMiddleClass).addClass(hoverBottomClass);
                        }
                    } else {
                        if (positionState != Consts.PositionState.none) {
                            positionState = Consts.PositionState.none;
                            currentDropSpan.data("positionstate", positionState);
                            currentDropSpan.removeClass(hoverTopClass + " " + hoverMiddleClass + " " + hoverBottomClass);
                        }
                    }
                }
            };

            // set up draggable plugin for <li>
            $(element).draggable({
                handle: ".drag-handle",
                revert: true,
                zIndex: 100,
                drag: mouseMoved
            });

            // get the content <span> inside the <li>
            var dropSpan = $(element).children("span.node");

            // called when an <li> is dropped on a <span>
            var dropCallback: JQueryUI.DroppableEvent = (event, ui) => {
                var dropNodeEl = ui.draggable;

                if ($window.confirm("Are you sure?")) {
                    // node that was dragged
                    var dragNode = <Models.IGraphNode<Models.ICharacteristicValue>>dropNodeEl.data("node");
                    // parent list of node that was dragged
                    var dragNodes = <Models.IGraphNode<Models.ICharacteristicValue>[]>dropNodeEl.data("nodes");

                    var positionState = <number>dropSpan.data("positionstate") || Consts.PositionState.none;
                    if (positionState == Consts.PositionState.before || positionState == Consts.PositionState.onto || positionState == Consts.PositionState.after) {
                        $timeout(() => {
                            listCtrl.MoveNode(dragNode, dragNodes, scope.node, positionState);
                            rowCtrl.open = true;
                        });
                    }
                }
            };

            // called when the pointer of a dragged <li> enters a droppable <span>
            var dropOverCallback: JQueryUI.DroppableEvent = (event, ui) => {
                if (currentDropSpan != null) {
                    currentDropSpan.removeClass(hoverTopClass + " " + hoverMiddleClass + " " + hoverBottomClass);
                }
                // set the current shared dropSpan
                currentDropSpan = dropSpan;
                //console.log("start");
            };

            // set up the droppable <span>
            dropSpan.droppable({
                greedy: true,               // don't propagate to parent <li>s
                hoverClass: "drop-hover",   // add this class to the dropable node
                tolerance: "pointer",       // trigger whenever the mouse pointer is within the <span> dropzone
                drop: dropCallback,
                over: dropOverCallback
            });

            // store info in the data attribute for the jquery-ui draggable to discover
            scope.$watch(() => scope.node, (newValue, oldValue) => {
                if (newValue != oldValue) {
                    element.data("node", newValue);
                }
            });
            // set initial value
            element.data("node", scope.node);

            // store info in the data attribute for the jquery-ui draggable to discover
            scope.$watchCollection(() => scope.nodes, (newValue) => {
                element.data("nodes", newValue);
            });
            // set initial value
            element.data("nodes", scope.nodes);

            // destroy plugins when directive is finished
            scope.$on("$destroy", () => {
                $(element).draggable("destroy");
                dropSpan.droppable("destroy");
            });
        }
    };
    return directive;
}

interface IRLHierarchyRowScope extends ng.IScope {
    node: Models.IGraphNode<Models.ICharacteristicValue>;         // node for this row
    nodes: Models.IGraphNode<Models.ICharacteristicValue>[];      // node list this row belongs to
    editItemForm: ng.IFormController;                       // the ng-form surround the edit row textbox
    level: number;
}

/**
 * Controller for Hierarchy Row directive
 **/
class RLHierarchyRowController {
    static $inject = ["$scope"];

    addMode: boolean;                   // add mode of this rows child list
    isDuplicated: boolean;              // whether this row's list item is referenced in two places
    hasGroupAssocs: boolean;

    listCtrl: RLHierarchyListController;            // reference to the parent list controller
    treeCtrl: HierarchyController;      // reference to the page level controller

    open: boolean;
    iconClass: string;

    flatList: boolean;
    nextLevel: number;

    descendantCount: number;

    constructor(private $scope: IRLHierarchyRowScope) {
        this.addMode = false;
        this.isDuplicated = false;
        this.flatList = false;
        this.nextLevel = $scope.level + 1;
        this.open = $scope.level == 0;
        this.iconClass = "";
        this.descendantCount = 0;

        // watch for the page controllers single addModeNode to change, set addMode = true if matches this row's node
        // this is to make sure only one row has addMode==true at a time
        $scope.$watch(() => this.treeCtrl.addModeNode, (newValue, oldValue) => {
            this.addMode = newValue == $scope.node;
        });


        // watch for changes to the page controllers dupeListValueIDs, make the duplicate icon visible if our row's list id matches.
        $scope.$watch(() => this.treeCtrl.dupeListValueIDs, (newValue, oldValue) => {
            this.isDuplicated = newValue.indexOf($scope.node.item.charValueID) > -1;
        }, true);

        // match local flatList variable to page level flatList
        $scope.$watch(() => this.treeCtrl.flatList,
            (newValue) => {
                this.flatList = newValue;
            });

        // if addMode changes to true, expand child list
        $scope.$watch(() => this.addMode, (newValue, oldValue) => {
            if (newValue) {
                this.open = true;
            }
        });


        // if openstate or childcount changes, re-evaluate icon class
        $scope.$watch(() => [this.open, $scope.node.childNodes.length],
            (newValue, oldValue) => {
                var open = <boolean>newValue[0];
                var childCount = <number>newValue[1] || 0;

                if (open) {
                    if (childCount > 0) {
                        this.iconClass = "fa-minus-square-o";
                    } else {
                        this.iconClass = "";
                    }
                } else {
                    if (childCount > 0) {
                        this.iconClass = "fa-plus-square-o";
                    } else {
                        this.iconClass = "";
                    }
                }
            }, true);

        $scope.$watch(() => this.treeCtrl.nodeDescendantCounts[$scope.node.uniq], (newValue, oldValue) => {
            if (newValue != null) {
                this.descendantCount = newValue;
            }
        });

        $scope.$watch(() => this.treeCtrl.charValueIDValueGroupAssocs[$scope.node.uniq], (newValue, oldValue) => {
            this.hasGroupAssocs = newValue != null && newValue.length > 0;
        }, true);
    }

	/**
	 * Toggles open state of current row
	 **/
    ToggleOpen() {
        this.open = !this.open;
    }

	/**
	 * Toggles the Edit Mode for this row
	 **/
    ToggleEditMode() {
        this.treeCtrl.EditNode(this.$scope.node);
    }

	/**
	 * Toggles the Add Mode for the child list of this row
	 **/
    ToggleAddMode() {
        if (this.treeCtrl.addModeNode == this.$scope.node) {
            // toggle off if this node is already selected
            this.treeCtrl.addModeNode = null;
        } else {
            // toggle on
            this.treeCtrl.addModeNode = this.$scope.node;
        }

    }

    ToggleGroupMode() {
        this.treeCtrl.GroupAssocNode(this.$scope.node);
    }

	/**
	 * Removes a node from current list
	 * @param node the node to remove
	 **/
    RemoveNode(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        this.listCtrl.RemoveNode(node);
    }

}

/**
 * Directive for the list of Hierarchy nodes
 * <div rl-hierarchy-list="" nodes="[list of nodes]" parent-node='[node]' add-mode="[boolean scope var]"></div>
 **/
export function RLHierarchyList() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/hierarchy-list.html"),
        controller: RLHierarchyListController,
        controllerAs: "hlVM",
        replace: true,
        require: ["rlHierarchyList", "^ngController"],
        scope: {
            nodes: "=",
            addMode: "=",
            parentNode: "=",
            level: "=?"
        },
        link: (scope: IRLHierarchyListScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

            var listCtrl = <RLHierarchyListController>controllers[0];
            var treeCtrl = <HierarchyController>controllers[1];

            // initialize scope level if not inherited
            scope.level = scope.level || 0;

            // add the treecontroller to the list controller
            listCtrl.treeCtrl = treeCtrl;

            var textbox = element.find("input.new-value");

            // when addMode goes from false->true, automatically focus the new item input textbox
            scope.$watch(() => scope.addMode, (newValue, oldValue) => {
                if (!oldValue && newValue) {
                    textbox.focus();
                }
            });
        }
    };
    return directive;
}

interface IRLHierarchyListScope extends ng.IScope {
    parentNode: Models.IGraphNode<Models.ICharacteristicValue>;   // parent node to this list
    nodes: Models.IGraphNode<Models.ICharacteristicValue>[];      // the nodes for this list
    addMode: boolean;                                       // whether this node is in addMode
    addNodeForm: ng.IFormController;                        // the ng-form surrounding the new item input textbox
    level: number;                                          // current depth level of list
}

/**
 * Controller for the Hierarchy List directive
 **/
class RLHierarchyListController {
    static $inject = ["$scope", "$timeout", "$window"];

    newValue: string;                           // value of the New Item input textbox
    parentRowCtrl: RLHierarchyRowController;    // reference to parent Row controller
    treeCtrl: HierarchyController;  // reference to page controller
    newValueMessage: string;                    // placeholder value for New Item input textbox
    flatList: boolean;

    maxLength = 500;
    rangeOffset = 0;
    offset = 0;

    constructor(private $scope: IRLHierarchyListScope, private $timeout: ng.ITimeoutService, private $window: ng.IWindowService) {
        this.newValue = "";
        this.treeCtrl = null;
        this.flatList = false;

        // whenever the addModeNode changes, update the Placeholder value on the New Item input
        $scope.$watch(() => this.treeCtrl.addModeNode,
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.newValueMessage = "Add Sub Item to " + newValue.item.charValueLabel;
                } else {
                    this.newValueMessage = "Add New Item";
                }
            }, true);

        // when addMode goes from false -> true
        // clear out newValue, reset form to $pristine
        $scope.$watch(() => $scope.addMode,
            (newValue, oldValue) => {
                if (!oldValue && newValue) {
                    this.newValue = "";
                    $scope.addNodeForm.$setPristine();
                }
            });

        // match local flatList variable to page level flatList
        $scope.$watch(() => this.treeCtrl.flatList,
            (newValue) => {
                this.flatList = newValue;
            });

        $scope.$watch(() => this.newValue,
            (newValue, oldValue) => {
                if (newValue != undefined) {
                    if (this.treeCtrl.ConfirmAdd(newValue, this.$scope.nodes, this.$scope.level, this.$scope.parentNode)) {
                        this.$scope.addNodeForm.$setValidity("Duplicate Value", false, null);
                    } else {
                        this.$scope.addNodeForm.$setValidity("Duplicate Value", true, null);
                    }
                }
            });
    }

    OffsetChanged() {
        this.$timeout(() => {
            this.offset = this.rangeOffset;
        }, 500);
    }

    get rangeMessage() {
        return `Showing ${Math.min(this.rangeOffset + 1, this.$scope.nodes.length - this.maxLength)} - ${Math.min(this.rangeOffset + this.maxLength, this.$scope.nodes.length)} of ${this.$scope.nodes.length}`;
    }

	/**
	 * Add a new node to this list
	 **/
    Add() {
        var listValue = this.treeCtrl.FindOrCreateListValue(this.newValue);
        var node = new Models.GraphNode<Models.ICharacteristicValue>(listValue);

        if (this.$scope.addNodeForm.$valid && this.treeCtrl.ConfirmValidity(node, this.$scope.parentNode)) {
            this.$scope.nodes.push(node);
            this.newValue = "";
            this.$scope.addNodeForm.$setPristine();
            this.treeCtrl.SetDirty(true);
        }
        else { this.ToggleAddMode(); }
    }

	/**
	 * Removes the node from the current list
	 * @param node the node to be removed
	 **/
    RemoveNode(node: Models.IGraphNode<Models.ICharacteristicValue>) {
        this.treeCtrl.GetCharValSrcCharacteristicCount(node)
            .then((result) => {
                if (result.data > 0) {
                    this.$window.alert("You cannot delete this node because there are entities associated with this CharValueSource and CharValue.");
                }
                else {
                    if (this.$window.confirm("Are you sure?")) {
                        var index = _.indexOf(this.$scope.nodes, node);
                        if (index > -1) {
                            this.$scope.nodes.splice(index, 1);
                            this.treeCtrl.SetDirty(true);
                        }
                    }
                }
            });
    }

	/**
	 * Moves the dragged node from one location to another
	 * @param node the node being moved
	 * @param fromNodes the node list the dragged node originates from
	 * @param toNode the node dropped onto
	 * @param positionState before/after/onto the toNode, ref Consts.PositionState
	 **/
    MoveNode(node: Models.IGraphNode<Models.ICharacteristicValue>, fromNodes: Models.IGraphNode<Models.ICharacteristicValue>[], toNode: Models.IGraphNode<Models.ICharacteristicValue>, positionState: number) {
        if (node != null && this.treeCtrl.ConfirmMove(node, toNode)) {
            var fromIndex = fromNodes.indexOf(node);
            if (fromIndex > -1) {
                fromNodes.splice(fromIndex, 1);
                this.treeCtrl.SetDirty(true);
            }

            var toIndex = this.$scope.nodes.indexOf(toNode);
            if (toIndex > -1) {
                switch (positionState) {
                    case Consts.PositionState.before:
                        this.$scope.nodes.splice(toIndex, 0, node);
                        this.treeCtrl.SetDirty(true);
                        break;
                    case Consts.PositionState.after:
                        this.$scope.nodes.splice(toIndex + 1, 0, node);
                        this.treeCtrl.SetDirty(true);
                        break;
                    case Consts.PositionState.onto:
                        toNode.childNodes.push(node);
                        this.treeCtrl.SetDirty(true);
                        break;
                    default:
                        break;
                }
            }
        }
    }

	/**
	 * Add current newValue if Enter is pressed
	 * Turn off new Value mode if Esc is pressed
	 **/
    CaptureKeysUp(event: JQueryEventObject) {
        if (event.keyCode == 13) {
            event.preventDefault();
            this.Add();
        } else if (event.keyCode == 27) {
            this.treeCtrl.addModeNode = null;
        }
    }

	/**
	 * Add current newValue if Tab is pressed
	 **/
    CaptureKeysDown(event: JQueryEventObject) {
        if (event.keyCode == 9) {
            if (!_.isEmpty(this.newValue)) {
                event.preventDefault();
                this.Add();
            }
        } else if (_.isEmpty(this.newValue)) {
            if (event.keyCode == 37) {
                // left arrow
                this.ShiftAddBox(0);
            } else if (event.keyCode == 39) {
                // right arrow
                this.ShiftAddBox(1);
            }
        }
    }

	/**
	 * Moves the Add New box deeper one level, or back to it's parent level
	 * @param direction 0 - left/shallow, 1 - right/deeper
	 **/
    ShiftAddBox(direction: number) {
        if (!this.flatList) {
            if (direction == 0) {
                if (this.$scope.parentNode != null) {
                    var parentParentNode = this.treeCtrl.FindParentNode(this.$scope.parentNode);
                    if (parentParentNode != null) {
                        this.treeCtrl.addModeNode = parentParentNode;
                    } else {
                        this.treeCtrl.addModeNode = null;
                    }
                }
            } else if (direction == 1) {
                if (this.$scope.nodes.length > 0) {
                    this.treeCtrl.addModeNode = _.last(this.$scope.nodes);
                }
            }
        }
    }

	/**
	 * Turns off Add Mode for this List
	 **/
    ToggleAddMode() {
        this.treeCtrl.addModeNode = null;
    }
}

RLQuickPost.$inject = ["$window", "notifyService"];
export function RLQuickPost($window: ng.IWindowService, notifySerivce: NotifyService) {
    var directive: ng.IDirective = {
        restrict: "A",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            var action = attributes["postAction"] || "";
            var confirm = attributes["postConfirm"] || "";
            var data: {} = scope.$eval(attributes["postData"]);

            if (!_.isEmpty(action)) {
                element.click((e) => {
                    e.preventDefault;

                    if (_.isEmpty(confirm) || (!_.isEmpty(confirm) && $window.confirm(confirm))) {
                        var form = $("<form></form>").attr("action", action).attr("method", "post");
                        for (var key in data) {
                            if (data.hasOwnProperty(key)) {
                                var input = $("<input type='hidden'/>").attr("name", key).attr("value", data[key]);
                                form.append(input);
                            }
                        }
                        form.appendTo('body').submit();
                    } else {
                        notifySerivce.broadcastDone();
                    }
                });
            }
        }
    };
    return directive;
}

export function RLMinSelected() {
    var directive: ng.IDirective = {
        require: "ngModel",
        restrict: "A",
        scope: {
            listSelected: "=",
            rlMinSelected: "=",
            listName: "@?"
        },
        link: (scope: IRLMinSelectedScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModelCtrl: ng.INgModelController) => {

            var parser: ng.IModelParser = (value: any) => {
                var countCurrentValue = value ? 1 : -1;
                var isValid: boolean = false;
                var listLength: number = scope.listSelected.length + countCurrentValue;
                if (listLength >= scope.rlMinSelected) {
                    isValid = true;
                }
                else {
                    isValid = false;
                }
                ngModelCtrl.$setValidity(scope.listName + "Selected", isValid);
                return value;
            };
            ngModelCtrl.$parsers.unshift(parser);
        }
    };
    return directive;
}

interface IRLMinSelectedScope extends ng.IScope {
    rlMinSelected: number;
    listSelected: any[];
    listName: string;
}

export function RLUniqueListName() {
    var directive: ng.IDirective = {
        require: "ngModel",

        scope: {
            rlUniqueListName: "="
        },
        link: (scope: IRLUniqueListNameScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModelCtrl: ng.INgModelController) => {

            var parser: ng.IModelParser = (value: any) => {
                var exists = _.any(scope.rlUniqueListName, (val: string, key: number) => {
                    if (!_.isEmpty(value)) {
                        return val.trim().toLowerCase() == value.trim().toLowerCase();
                    }
                    else {
                        return false;
                    }
                });
                ngModelCtrl.$setValidity("uniqueListName", !exists);
                return value;
            };
            ngModelCtrl.$parsers.unshift(parser);
        }
    };
    return directive;
}

interface IRLUniqueListNameScope extends ng.IScope {
    rlUniqueListName: _.Dictionary<string>;
}

RLUniqueUserIdentity.$inject = ["adminService"];
export function RLUniqueUserIdentity(adminService: AdminService) {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModelCtrl: ng.INgModelController) => {

            var parser: ng.IModelParser = (value: any) => {
                adminService.validateEmail(value).then((result) => {
                    ngModelCtrl.$setValidity("uniqueUserName", result.success);
                });

                return value;
            };
            ngModelCtrl.$parsers.unshift(parser);
        }
    };
    return directive;
}



export function RLValidationMessages() {
    var directive: ng.IDirective = {
        restrict: "AE",
        require: "^form",
        template: "",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, formCtrl: ng.IFormController) => {
            var name = attributes["name"] || "";
            var parentEl = element.parents(".form-group");
            scope.$watch(
                () => {
                    if (formCtrl != null && formCtrl[name] != null) {
                        return formCtrl[name].$invalid && formCtrl[name].$dirty;
                    } else {
                        return null;
                    }
                },
                (newValue, oldValue) => {
                    parentEl.toggleClass("has-error", newValue);
                });
        }
    };
    return directive;
}

RLUniqueValue.$inject = ["$parse"];

export function RLUniqueValue($parse: ng.IParseService) {
    var directive: ng.IDirective = {
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, modelCtrl: ng.INgModelController) => {

            var compareValues = [];
            var getter = $parse(attributes["rlUniqueValue"]);
            compareValues = getter(scope);

            scope.$watch(() => getter(scope), (newValue, oldValue) => {
                compareValues = newValue;
            }, true);

            var validate: ng.IModelParser = (value: any) => {
                var valid = !_.contains(compareValues, (value || "").trim());
                return valid;
            };

            modelCtrl.$validators["uniqueValue"] = validate;
        }
    };
    return directive;
}

RLValidateMethod.$inject = ["$parse"];
/**
 * Directive to validate a ngModel via a controller's method
 * <input ... ng-model='vm.something' rl-validate-method='vm.[ValidateMethodDictionary]' />
 **/
export function RLValidateMethod($parse: ng.IParseService) {
    var directive: ng.IDirective = {
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, modelCtrl: ng.INgModelController) => {

            var compareValues = [];
            var getter = $parse(attributes["rlValidateMethod"]);

            var methodDict = getter(scope);

            if (methodDict != null) {
                angular.forEach(methodDict,
                    (v: (value: string) => boolean, k: string) => {
                        modelCtrl.$validators[k] = v;
                    });

                scope.$on("$destroy",
                    () => {
                        angular.forEach(methodDict,
                            (v: (value: string) => boolean, k: string) => {
                                delete modelCtrl.$validators[k];
                            });
                    });
            }

            //scope.$watch(() => modelCtrl.$viewValue, (newValue, oldValue) => { modelCtrl.$validate(); }, true);

            //var validate: ng.IModelParser = (value: any) => {
            //    var validationFunc: (value: any) => { name: string; valid: boolean } = getter(scope);
            //    var result = validationFunc(value);
            //    modelCtrl.$setValidity(result.name, result.valid);
            //    return value;
            //};

            //modelCtrl.$parsers.unshift(validate);
            //modelCtrl.$formatters.unshift(validate);
        }
    };
    return directive;
}

RLValidateOnChange.$inject = ["$parse", "$timeout"];
export function RLValidateOnChange($parse: ng.IParseService, $timeout: ng.ITimeoutService) {
    var directive: ng.IDirective = {
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, modelCtrl: ng.INgModelController) => {

            var watchVarGetter = $parse(attributes["rlValidateOnChange"]);

            scope.$watch(() => watchVarGetter(scope),
                (newValue, oldValue) => {
                    $timeout(() => {
                        modelCtrl.$validate();
                    });
                }, true);
        }
    };
    return directive;
}

export function RLEntityTitleNav() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-title-nav.html"),
        scope: {
            entity: "=?",
            entityId: "@?"
        },
        replace: true,
        transclude: true,
        controllerAs: "tnVM",
        controller: RLEntityTitleNavController,
        link: (scope: IRLEntityTitleNavScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any, transcludeFn: ng.ITranscludeFunction) => {
            transcludeFn(scope.$parent, (clone) => {
                var opsDiv = element.find(".rl-title-ops");
                opsDiv.empty();
                opsDiv.append(clone);
            });
        }
    };
    return directive;
}

class RLEntityTitleNavController {
    static $inject = ["$scope", "entityService", "notifyService"];

    initialized: boolean;
    title: string;

    entityRecord: Models.IEntity;

    constructor(private $scope: IRLEntityTitleNavScope, private entityService: EntityService, private notifyService: NotifyService) {

        this.initialized = false;
        this.title = "";

        this.entityRecord = null;

        if (!_.isNull($scope.entityId) && !_.isEmpty($scope.entityId)) {
            this.LoadEntity($scope.entityId);
        } else {
            $scope.$watch<Models.IEntity>("entity", (newValue, oldValue) => {
                if (newValue != null) {
                    this.entityRecord = newValue;
                }
            });
        }

        $scope.$watch(() => this.entityRecord,
            (newValue, oldValue) => {
                if (newValue != oldValue || (newValue != null && !this.initialized)) {
                    if (!_.isEmpty(newValue.title)) {
                        this.title = newValue.title;
                    }
                    else {
                        this.title = newValue.template + " " + newValue.recordID;
                    }
                    this.initialized = true;
                }
            });
    }

    LoadEntity(entityID: string) {
        this.notifyService.startProgress();
        this.entityService.getEntityRecord(entityID)
            .then((result) => {
                this.entityRecord = result;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }
}

interface IRLEntityTitleNavScope extends ng.IScope {
    entity: Models.IEntity;
    entityId: string;
}

export interface IRLScrollExpandScope extends ng.IScope {
    topOffset: number;
}

RLScrollExpand.$inject = ["$window"];
export function RLScrollExpand($window: ng.IWindowService) {
    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            var initialTopPosition = element.position().top;
            var placeholder = $("<div></div>");
            placeholder.hide();
            placeholder.insertAfter(element);

            element.addClass("scroll-expand");
            var expanded = false;

            var expand = () => {
                placeholder.width(element.width());
                placeholder.height(element.height());
                element.css("left", element.position().left);
                element.addClass("expanded");
                placeholder.show();
                expanded = true;
            };

            var collapse = () => {
                element.removeClass("expanded");
                placeholder.hide();
                expanded = false;
            };

            var checkScroll = () => {
                var scrollTop = $(document).scrollTop();
                if (scrollTop > initialTopPosition && !expanded) {
                    expand();
                } else if (scrollTop <= initialTopPosition && expanded) {
                    collapse();
                }
            }

            $(document).on("scroll", () => {
                checkScroll();
            });

            angular.element($window).bind('resize', () => {
                checkScroll();
            });

            $(document).on("show.bs.modal", ".modal", () => { collapse(); });
        }
    };
    return directive;
}


export function RLEntityPanel() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-panel.html"),
        replace: true,
        transclude: true,
        controllerAs: "epVM",
        controller: RLEntityPanelController,
        scope: {
            expanded: "@?",
            showBottom: "=?"
        }
    };
    return directive;
}

interface IRLEntityPanelScope extends ng.IScope {
    expanded: string;
    showBottom: boolean;
}

class RLEntityPanelController {
    static $inject = ["$scope"];

    open: boolean;
    showBottomButtons: boolean;

    constructor(private $scope: IRLEntityPanelScope) {
        this.open = $scope.expanded != "false";
        this.showBottomButtons = false;
    }

    ToggleOpen() {
        this.open = !this.open;
    }
}



export function RLHorizontalScroll() {
    var directive: ng.IDirective = {
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {


            var scrollFunc = (event: JQuery.Event) => {
                var scrollLeft = element.scrollLeft();
                scrollLeft += (<WheelEvent>event.originalEvent).deltaY;
                element.scrollLeft(scrollLeft);
                event.preventDefault();
            };

            element.on("mousewheel", scrollFunc);

            scope.$on("$destroy", () => {
                element.off("mousewheel", scrollFunc);
            });
        }
    };
    return directive;
}
/*
export function RLEntityTitleSubHeader() {
	var directive: ng.IDirective = {
		restrict: "AE",
		template: require("/assets/app/templates/entity-title-sub-header.html"),
		scope: {
			entity: "=?",
			entityId: "@?"
		},
		controller: RLEntityTitleSubHeaderController,
		controllerAs: "etshVM",
		transclude: true,
		link: (scope: IRLEntityTitleSubHeaderScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any, transclude: ng.ITranscludeFunction) => {

		}
	};
	return directive;
}

interface IRLEntityTitleSubHeaderScope extends ng.IScope {
	entity: Models.IEntity;
	entityId: string;
}

class RLEntityTitleSubHeaderController {
	static $inject = ["$scope", "entityService", "notifyService"];

	entityRecord: Models.IEntity;

	constructor(private $scope: IRLEntityTitleSubHeaderScope, private entityService: EntityService, private notifyService: NotifyService) {
		this.entityRecord = null;

		if (!_.isNull($scope.entityId) && !_.isEmpty($scope.entityId)) {
			this.LoadEntity($scope.entityId);
		} else {
			$scope.$watch<Models.IEntity>("entity", (newValue, oldValue) => {
				if (newValue != null) {
					this.entityRecord = newValue;
				}
			});
		}
	}

	LoadEntity(entityID: string) {
		this.notifyService.startProgress();
		this.entityService.getEntityRecord(entityID)
			.then((result) => {
				this.entityRecord = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}
*/
export function RLMatchInput() {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, ngModelController: ng.INgModelController) => {
            var expr: string = attributes["rlMatchInput"];
            ngModelController.$validators["match"] = (value: string) => {
                return value == scope.$eval(expr);
            };

            scope.$watch(expr, (newValue) => {
                ngModelController.$setValidity("match", newValue == ngModelController.$viewValue);
            }, true);
        }
    };
    return directive;
}

export function RLCheckbox() {
    var directive: ng.IDirective = {
        restrict: "A",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            //var label = angular.element("<label />").addClass("rl-checkbox");
            //var onIcon = angular.element("<i />").addClass("fa").addClass("on");
            //var offIcon = angular.element("<i />").addClass("fa fa-square-o fa-stack-2x").addClass("off");
            //var spans = angular.element("<span />").addClass("fa-stack").append(onIcon).append(offIcon);
            //element.wrap(label);
            //element.parent().append(spans);

            var id = element.attr("id") || uuid.v4();

            element.attr("id", id);
            var span = angular.element("<div />").addClass("checkbox checkbox-inline");
            var label = angular.element("<label />").attr("for", id);


            element.wrap(span);
            element.parent().append(label);
        }
    };
    return directive;
}

RLTreeList2.$inject = ["$parse"];
export function RLTreeList2($parse: ng.IParseService) {

    var directive: ng.IDirective = {
        template: require("/assets/app/templates/tree-list-2.html"),
        controller: RLTreeList2Controller,
        controllerAs: "tlVM",
        require: ["rlTreeList2", "ngModel"],
        link: (scope: IRLTreeList2Scope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {

            var treeListCtrl: RLTreeList2Controller = controllers[0];
            var ngModelCtrl: ng.INgModelController = controllers[1];

            var textParse = $parse(attributes["treeListText"]);
            var valueParse = $parse(attributes["treeListValue"]);
            var childrenParse = $parse(attributes["treeListChildren"]);
            var keyParse: ng.ICompiledExpression = null;

            // update ngModelCtrl's $name (since this element isn't a <input/>)
            ngModelCtrl.$name = attributes["name"] || _.uniqueId().toString();;

            ngModelCtrl.$isEmpty = function (value: any[]) {
                // eslint-disable-next-line no-self-compare
                return value == undefined || value === null || value.length == 0;
            }

            // assign treeListControllers's attribute based values
            treeListCtrl.valueGetter = valueParse;
            treeListCtrl.childrenGetter = childrenParse;
            treeListCtrl.textGetter = textParse;
            // give treeListCtrl access to the ngModelCtrl
            treeListCtrl.ngModelCtrl = ngModelCtrl;

            // optionally set the tree-list-key  getter
            if (!_.isEmpty(attributes["treeListKey"])) {
                keyParse = $parse(attributes["treeListKey"]);
                treeListCtrl.keyGetter = keyParse;
            }

            treeListCtrl.SetupTree();
        },
        scope: {
            items: "=treeListData",
            selectedItems: "=?treeListSelectedItems",
            searchFilter: "=?treeListSearchFilter",
            selectedPaths: "=?treeListSelectedPaths",
            selectedExpandedValues: "=?treeListSelectedExpandedValues",
            selectedLeafValues: "=?treeListSelectedLeafValues",
            onSelectionChanged: "&?"
        }
    };
    return directive;
}

interface IRLTreeList2Scope extends ng.IScope {
    items: Models.ITreeList2Item[];
    selectedItems: Models.ITreeList2Item[];
    searchFilter: string;
    selectedPaths: string[];
    selectedExpandedValues: any[];
    selectedLeafValues: any[];
    onSelectionChanged: () => any;
}

class RLTreeList2Controller {
    static $inject = ["$scope", "$timeout"];

    intialized: boolean;

    ngModelCtrl: ng.INgModelController;             // controller for ngModel
    textGetter: ng.ICompiledExpression;             // expression for getting text ex. tree-list-text="$item.label"
    valueGetter: ng.ICompiledExpression;            // expression for getting value to add to ng-model ex. tree-list-value="$item.valueID"
    childrenGetter: ng.ICompiledExpression;         // expression for getting children ex. tree-list-children="$item.childValues"
    keyGetter: ng.ICompiledExpression;              // expression for getting unique key (optional fallback to valueGetter)  ex. tree-list-key="$item.valueID"

    baseDepth: number;                              // default depth = 0

    filterOn: boolean;                              // whether filtering is active
    filterText: string;                             // text of search string (two-way bound)
    filterMatchCount: number;                       // count of filter matched items
    filterMatched: { [key: string]: boolean }       // list of nodes matching the filters [item id] => true/false;
    filterHidden: { [key: string]: boolean }        // list of nodes to hide to display matches on the filters [item id] => true/false;
    delayedFilterGraph: {};

    subFilterHandlers: { [key: string]: ITreeListPathHandler };     // filterHandlers of child RLTreeList2NodeListControllers
    subShowHandlers: { [key: string]: ITreeListPathHandler };       // showHandlers of child RLTreeList2NodeListControllers
    delayedShowGraph: {};

    searchMap: { [key: string]: string };           // items remapped by [item text] => [descendent path of ids to leaf]  ex. map["I'm number 3"] = "11|22|3"
    keyPathMap: { [key: string]: string[] };        /* items remapped by [item id] => [array of descendent paths of ids to leaf]  ex. map["3"] = ["11|22|3","11|44|3"]  
														   multi-location leaves have more than 1 value */
    contains: (arr: any[], item: any) => boolean;   // helper function of array contains
    add: (arr: any[], item: any) => any[];          // helper function of array add
    remove: (arr: any[], item: any) => any[];       // helper function of array remove


    items: Models.ITreeList2Item[];

    fullSet: any[];

    clickEvent: boolean = false;

    constructor(private $scope: IRLTreeList2Scope, private $timeout: ng.ITimeoutService) {

        this.intialized = false;

        this.baseDepth = 0;
        $scope.selectedItems = $scope.selectedItems || [];

        this.items = [];

        this.filterOn = false;
        this.filterText = "";
        this.filterMatchCount = 0;
        this.filterMatched = {};
        this.filterHidden = {};
        this.delayedFilterGraph = {};
        this.subFilterHandlers = {};
        this.subShowHandlers = {};
        this.delayedShowGraph = {};
        this.searchMap = {};
        this.keyPathMap = {};

        this.fullSet = [];

        this.contains = (arr, item) => {
            if (angular.isArray(arr)) {
                for (var i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        return true;
                    }
                }
            }
            return false;
        }

        this.add = (arr, item) => {
            arr = angular.isArray(arr) ? arr : [];
            for (var i = 0; i < arr.length; i++) {
                if (angular.equals(arr[i], item)) {
                    return arr;
                }
            }
            arr.push(item);
            return arr;
        }

        this.remove = (arr, item) => {
            if (angular.isArray(arr)) {
                for (var i = 0; i < arr.length; i++) {
                    if (angular.equals(arr[i], item)) {
                        arr.splice(i, 1);
                        break;
                    }
                }
            }
            return arr;
        };

    }

    SetupTree() {
        /* refresh maps whenever the source items change */
        this.$scope.$watch(() => this.$scope.items,
            (newValue, oldValue) => {
                if (!angular.equals(newValue, oldValue) || !this.intialized) {
                    this.searchMap = {};
                    this.keyPathMap = {};
                    this.MapValues(newValue);
                    this.fullSet = this.ExplodeRootSelectedToFullSet(this.ngModelCtrl.$viewValue, newValue);
                    this.items = newValue;
                    this.intialized = true;
                    this.$timeout(() => {
                        this.ShowSelected();
                        this.ComputeValues(this.ngModelCtrl.$viewValue);
                    });
                }
            });

        /* copy filterText to ctrl and filter whenever scope's searchFilter changes*/
        this.$scope.$watch(() => this.$scope.searchFilter,
            (newValue, oldValue) => {
                this.filterText = newValue;
                this.FilterValues(newValue);
            }, true);

        /* when rootset (ngModel) changes, explode out to fullset */
        this.$scope.$watchCollection(() => this.ngModelCtrl.$viewValue,
            (newValue, oldValue) => {
                this.ComputeValues(newValue);
            });

        /* when fullset changes rectify down to roots, set to ngModel */
        this.$scope.$watchCollection(() => this.fullSet,
            (newValue, oldValue) => {
                if (!_.isEmpty(this.items)) {

                    var rectified = this.RectifyFullSetToRootSelected(newValue);
                    var topNodes = this.GetTopNodes(rectified);

                    var currentValue = _.sortBy(this.ngModelCtrl.$viewValue);
                    var newValue = _.sortBy(topNodes.topValues);
                    var same = angular.equals(currentValue, newValue);
                    if (!same) {
                        // only update if values are different
                        this.ngModelCtrl.$setViewValue(topNodes.topValues);
                        this.$scope.selectedItems = topNodes.topItems;
                        this.$scope.selectedPaths = topNodes.topPaths;
                        this.$scope.selectedExpandedValues = topNodes.expandedValues;
                        this.$scope.selectedLeafValues = topNodes.leafValues;
                        if (this.clickEvent) {
                            this.clickEvent = false;
                            if (this.$scope.onSelectionChanged != null) {
                                this.$timeout(() => {
                                    this.$scope.onSelectionChanged();
                                });
                            }
                        }
                    }
                }
            });

        this.$scope.$on(Consts.Events.TreeListShowSelected,
            () => {
                this.$timeout(() => {
                    this.ShowSelected();
                });
            });
    }

    ComputeValues(newValue: any) {
        if (!_.isEmpty(this.items)) {
            this.fullSet = this.ExplodeRootSelectedToFullSet(newValue, this.items);
            var rectified = this.RectifyFullSetToRootSelected(this.fullSet);
            var topNodes = this.GetTopNodes(rectified);
            this.$scope.selectedItems = topNodes.topItems;
            this.$scope.selectedPaths = topNodes.topPaths;
            this.$scope.selectedExpandedValues = topNodes.expandedValues;
            this.$scope.selectedLeafValues = topNodes.leafValues;
        }
    }

    ExplodeRootSelectedToFullSet(selectedValues: any[], items: Models.ITreeList2Item[]) {
        var output: any[] = [];
        var selectedChildren = this.GetItemsByValues(selectedValues, items);
        for (var i = 0; i < selectedChildren.length; i++) {
            var selectedChild = selectedChildren[i];
            var descendants = this.GetRecursiveValues(selectedChild);
            for (var j = 0; j < descendants.length; j++) {
                this.add(output, descendants[j]);
            }
        }
        return output;
    }

    RectifyFullSetToRootSelected(fullSet: any[]) {
        var output = [];
        this.RectifyFullSetToRootSelectedRecurse(fullSet, this.items, output);
        return output;
    }

    RectifyFullSetToRootSelectedRecurse(fullSet: any[], items: Models.ITreeList2Item[], output: any[]) {
        var allTrue = true;
        if (items) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var value = this.GetValue(item);
                var children = this.GetChildren(item);
                var itemTrue = this.contains(fullSet, value);

                if (children.length > 0) {
                    var childrenTrue = this.RectifyFullSetToRootSelectedRecurse(fullSet, children, output);
                    if (!childrenTrue && itemTrue) {
                        itemTrue = false;
                    } else if (childrenTrue && !itemTrue) {
                        itemTrue = true;
                    }
                }
                if (!itemTrue) {
                    allTrue = false;
                    this.remove(output, value);
                } else {
                    this.add(output, value);
                }
            }
        }
        return allTrue;

    }

    GetTopNodes(selectedSet: any[]) {
        var topValues = [];
        var topItems = [];
        var topPaths = [];
        var selectedExpandedValues = [];
        var selectedLeafValues = [];

        this.GetTopNodesRecurse(selectedSet, this.items, topValues, topItems, topPaths, selectedExpandedValues, selectedLeafValues, []);
        return {
            topValues: topValues,
            topItems: topItems,
            topPaths: topPaths,
            expandedValues: _.uniqueObjects(selectedExpandedValues),
            leafValues: selectedLeafValues
        };
    }

    GetTopNodesRecurse(selectedSet: any[], items: Models.ITreeList2Item[], topValues: any[], topItems: any[], topPaths: string[], selectedExpandedValues: any[], selectedLeafValues: any[], currentPath: any[]) {
        if (items) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var value = this.GetValue(item)
                var thisPath = currentPath.concat(value);

                var allValues = this.GetRecursiveValues(item);
                if (_.all(allValues, (v) => this.contains(selectedSet, v))) {
                    topItems.push(item);
                    this.add(topValues, value);
                    topPaths.push(thisPath.join("/"));
                    selectedExpandedValues.push.apply(selectedExpandedValues, allValues);
                    var leafValues = this.GetRecursiveLeafValues(item);
                    selectedLeafValues.push.apply(selectedLeafValues, leafValues);
                } else {
                    var children = this.GetChildren(item);
                    this.GetTopNodesRecurse(selectedSet, children, topValues, topItems, topPaths, selectedExpandedValues, selectedLeafValues, thisPath);
                }
            }
        }
    }

	/**
	 * Uses the tree-list-children attribute to access children of an item
	 * ex. tree-list-children="$item.childValues"
	 * @method GetChildren
	 * @param item {Models.ITreeList2Item}
	 * @returns {Models.ITreeList2Item[]} children of the item
	 */
    GetChildren(item: Models.ITreeList2Item) {
        return <Models.ITreeList2Item[]>this.childrenGetter(this.$scope, { $item: item }) || [];
    }

	/**
	 * Gets the resuling value from an item, to be inserted into the ngModel's result array
	 * @method GetValue
	 * @param item {Models.ITreeList2Item}
	 * @returns {any} the output value for the ngModel array
	 */
    GetValue(item: Models.ITreeList2Item) {
        return <any>this.valueGetter(this.$scope, { $item: item });
    }

	/**
	 * Get's the item's unique identifier, used for internal mapping
	 * @method GetKey
	 * @param item {Models.ITreeList2Item}
	 * @returns {string} unique identifier
	 */
    GetKey(item: Models.ITreeList2Item) {
        if (this.keyGetter != null) {
            var output = this.keyGetter(this.$scope, { $item: item });
            return <string>output.toString();
        } else {
            var value = this.GetValue(item);
            if (angular.isObject(value)) {
                // figure out something for objects
                throw "no way to make a key from an object";
            } else {
                return <string>value.toString();
            }
        }
    }

	/**
	 * Gets the text value of an item for display on the node itself.
	 * @method GetText
	 * @param item {Models.ITreeList2Item}
	 * @returns {string} text label of item
	 */
    GetText(item: Models.ITreeList2Item) {
        return <string>this.textGetter(this.$scope, { $item: item });
    }
	/**
	 * Gets the values of the item and all it's descendents
	 * @method GetRecursiveValues
	 * @param item {Models.ITreeList2Item}
	 * @returns {any[]} the values of the item param and all it's descendents
	 */
    GetRecursiveValues(item: Models.ITreeList2Item): any[] {
        var output = [];
        output.push(this.GetValue(item));
        var children = this.GetChildren(item);
        for (var i = 0; i < children.length; i++) {
            var childOutput = this.GetRecursiveValues(children[i]);
            output = output.concat(childOutput);
        }
        return output;
    }

	/**
	 * Gets the values of the item and all it's descendents
	 * @method GetRecursiveValues
	 * @param item {Models.ITreeList2Item}
	 * @returns {any[]} the values of the item param and all it's descendents
	 */
    GetRecursiveLeafValues(item: Models.ITreeList2Item): any[] {
        var output = [];
        var children = this.GetChildren(item);
        if (children.length == 0) {
            output.push(this.GetValue(item));
        } else {
            for (var i = 0; i < children.length; i++) {
                var childOutput = this.GetRecursiveLeafValues(children[i]);
                output = output.concat(childOutput);
            }
        }
        return output;
    }

	/**
	 * Recursively finds items that matcha  list of values
	 * @method GetItemsByValues
	 * @param values {any[]} list of values to retrieve items for
	 * @param items {Models.ITreeList2Item[]} an array of items to match against values
	 * @returns {Models.ITreeList2Item[]} an array of matched items
	 */
    GetItemsByValues(values: any[], items: Models.ITreeList2Item[]) {
        var output: Models.ITreeList2Item[] = [];
        if (values && items) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var value = this.GetValue(item);
                if (_.any(values, (v) => angular.equals(v, value))) {
                    output.push(item);
                }
                var children = this.GetChildren(item);
                var childOutput = this.GetItemsByValues(values, children);
                output = output.concat(childOutput);
            }
        }
        return output;
    }

	/**
	 * Gets an item by it's value
	 * @method GetItemByValue
	 * @param value {any} a value to find a matching item for
	 * @param items {Models.ITreeList2Item[]} an array of items to match against values
	 * @returns {Models.ITreeList2Item} an item that was matched to a value
	 */
    GetItemByValue(value: any, items: Models.ITreeList2Item[]) {
        var output: Models.ITreeList2Item = null;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var thisValue = this.GetValue(item);
            if (angular.equals(value, thisValue)) {
                output = item;
                break;
            }
            var children = this.GetChildren(item);
            var childOutput = this.GetItemByValue(value, children);
            if (childOutput != null) {
                output = childOutput;
                break;
            }
        }
        return output;
    }

	/**
	 * @method SetSelectedItems
	 * @param items {Models.ITreeList2Item[]} items to set as selected in the tree
	 * @param selected {boolean} select or unselect values
	 */
    SetSelectedItems(items: Models.ITreeList2Item[], selected: boolean) {
        var values = [];
        items.forEach((item) => {
            values = values.concat(this.GetRecursiveValues(item));
        });
        this.SetSelectedValues(values, selected);
    }

    SetSelectedItem(item: Models.ITreeList2Item, selected: boolean) {
        var values = this.GetRecursiveValues(item);
        this.SetSelectedValues(values, selected);
    }

    SetSelectedValues(values: any[], selected: boolean, rectify: boolean = true) {
        if (selected) {
            values.forEach((v) => {
                this.add(this.fullSet, v);
            });
        }
        else {
            values.forEach((v) => {
                this.remove(this.fullSet, v);
            });
        }
    }


    ContainsItem(item: Models.ITreeList2Item) {
        return this.ContainsValue(this.GetValue(item));
    }

    ContainsValue(value: any) {
        return this.contains(this.fullSet, value);
    }

    MapValues(items: Models.ITreeList2Item[], keyPath: string = "") {
        if (items) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var key = this.GetKey(item);
                var text = this.GetText(item);

                var itemKeyPath = "";
                if (_.isEmpty(keyPath)) {
                    itemKeyPath = key;
                } else {
                    itemKeyPath = keyPath + "|" + key;
                }
                this.searchMap[text] = itemKeyPath;

                var paths = this.keyPathMap[key] || [];
                paths.push(itemKeyPath);
                this.keyPathMap[key] = paths;

                var children = this.GetChildren(item);
                this.MapValues(children, itemKeyPath);
            }
        }
    }

    FilterValues(filterText: string = "") {
        this.filterMatchCount = 0;
        this.filterMatched = {};
        this.filterHidden = {};
        this.filterOn = !_.isEmpty(filterText) && filterText.length >= 2;
        this.delayedFilterGraph = {};

        if (this.filterOn) {
            var matchText = filterText.toLowerCase().trim();
            var matches = _.filter(this.searchMap, (value: string, key: string) => key.toLowerCase().indexOf(matchText) >= 0);
            this.filterMatchCount = matches.length;
            if (matches.length > 0) {
                var openGraph = this.BuildOpenGraph(matches.map((v) => v.split('|')));
                if (_.any(this.subFilterHandlers)) {
                    _.forEach(this.subFilterHandlers, (handler: ITreeListPathHandler) => {
                        handler(openGraph);
                    });
                } else {
                    this.delayedFilterGraph = openGraph;
                }
            }
        } else {
            this.FilterReset();
        }
    }

    FilterReset() {
        this.filterHidden = {};
        this.$scope.$broadcast(Consts.Events.TreeListFilterReset);
        this.ShowSelected();
    }

    ShowSelected() {
        var rootSet = <any[]>this.ngModelCtrl.$viewValue || [];
        if (rootSet.length > 0 && !_.isEmpty(this.items)) {
            var keys = this.GetItemsByValues(rootSet, this.items).map((item) => this.GetKey(item));
            var matches = <string[]>_.flatten(_.filter(this.keyPathMap, (value: string[], key: string) => _.contains(keys, key)));
            if (matches.length > 0) {
                var openGraph = this.BuildOpenGraph(matches.map((v) => v.split('|')));
                if (_.any(this.subShowHandlers)) {
                    _.forEach(this.subShowHandlers, (handler: ITreeListPathHandler) => {
                        handler(openGraph);
                    });
                } else {
                    this.delayedShowGraph = openGraph;
                }
            }
        }
    }

    BuildOpenGraph(keyPaths: any[][]) {
        var uniques = _(keyPaths).map((v) => _.head(v)).uniq().valueOf();
        var object = {};

        uniques.forEach((key) => {
            var children = _(keyPaths)
                .filter((v) => _.head(v) == key)
                .map((v) => _.rest(v))
                .filter((v) => v.length > 0)
                .valueOf();
            if (children.length > 0) {
                object[key] = this.BuildOpenGraph(children);
            } else {
                object[key] = true;
            }
        });

        return object;
    }
}

export function RLTreeList2NodeList() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/tree-list-2-node-list.html"),
        controller: RLTreeList2NodeListController,
        controllerAs: "tlnVM",
        replace: true,
        require: ["^rlTreeList2", "rlTreeList2NodeList"],
        link: (scope: IRLTreeList2NodeListScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var treeListCtrl = <RLTreeList2Controller>controllers[0];
            var nodeListCtrl = <RLTreeList2NodeListController>controllers[1];

            nodeListCtrl.treeListCtrl = treeListCtrl;
        },
        scope: {
            items: "=rlTreeList2NodeList",
            depth: "="
        }
    };
    return directive;
}

interface IRLTreeList2NodeListScope extends ng.IScope {
    items: Models.ITreeList2Item[];
    depth: number;

}

class RLTreeList2NodeListController {
    static $inject = ["$scope"];

    treeListCtrl: RLTreeList2Controller;

    constructor(private $scope: IRLTreeList2NodeListScope) {
        this.treeListCtrl = null;
    }
}

RLTreeList2NodeRow.$inject = ["$compile"]
export function RLTreeList2NodeRow($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/tree-list-2-node-row.html"),
        replace: true,
        controller: RLTreeList2NodeRowController,
        controllerAs: "tlrVM",
        require: ["^rlTreeList2", "^rlTreeList2NodeList", "rlTreeList2NodeRow", "?^^rlTreeList2NodeRow"],
        scope: {
            item: "=rlTreeList2NodeRow",
            depth: "="
        },
        link: (scope: IRLTreeList2NodeRow, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: any[]) => {
            var treeListCtrl = <RLTreeList2Controller>controllers[0];
            var nodeListCtrl = <RLTreeList2NodeListController>controllers[1];
            var nodeRowCtrl = <RLTreeList2NodeRowController>controllers[2];
            var parentNodeRowCtrl = <RLTreeList2NodeRowController>controllers[3];

            nodeRowCtrl.treeListCtrl = treeListCtrl;
            nodeRowCtrl.nodeListCtrl = nodeListCtrl;
            nodeRowCtrl.SetupNode();

            if (nodeRowCtrl.children.length > 0) {
                var templateElement = angular.element("<ul ng-if='tlrVM.open' rl-tree-list-2-node-list='tlrVM.children' depth='tlrVM.childDepth' class='slide-down'></ul>");
                var compiled = $compile(templateElement);
                element.append(templateElement);
                compiled(scope);
            }

            if (parentNodeRowCtrl != null) {
                parentNodeRowCtrl.subFilterHandlers[nodeRowCtrl.key] = nodeRowCtrl.filterHandler;
                parentNodeRowCtrl.subShowHandlers[nodeRowCtrl.key] = nodeRowCtrl.showHandler;
                scope.$on("$destroy", () => {
                    delete parentNodeRowCtrl.subFilterHandlers[nodeRowCtrl.key];
                    delete parentNodeRowCtrl.subShowHandlers[nodeRowCtrl.key];
                });
                var delayedShowGraph = parentNodeRowCtrl.delayedShowGraph;
                if (delayedShowGraph != null && !_.isEmpty(delayedShowGraph)) {
                    nodeRowCtrl.showHandler(delayedShowGraph);
                    delete parentNodeRowCtrl.delayedShowGraph[nodeRowCtrl.key];
                }
                var delayedFilterGraph = parentNodeRowCtrl.delayedFilterGraph;
                if (delayedFilterGraph != null && !_.isEmpty(delayedFilterGraph)) {
                    nodeRowCtrl.filterHandler(parentNodeRowCtrl.delayedFilterGraph);
                    //delete parentNodeRowCtrl.delayedFilterGraph[nodeRowCtrl.key];
                }
            } else {
                treeListCtrl.subFilterHandlers[nodeRowCtrl.key] = nodeRowCtrl.filterHandler;
                treeListCtrl.subShowHandlers[nodeRowCtrl.key] = nodeRowCtrl.showHandler;
                scope.$on("$destroy", () => {
                    delete treeListCtrl.subFilterHandlers[nodeRowCtrl.key];
                    delete treeListCtrl.subShowHandlers[nodeRowCtrl.key];
                });
                var delayedShowGraph = treeListCtrl.delayedShowGraph;
                if (delayedShowGraph != null && !_.isEmpty(delayedShowGraph)) {
                    nodeRowCtrl.showHandler(treeListCtrl.delayedShowGraph);
                    delete treeListCtrl.delayedShowGraph[nodeRowCtrl.key];
                }
                var delayedFilterGraph = treeListCtrl.delayedFilterGraph;
                if (delayedFilterGraph != null && !_.isEmpty(delayedFilterGraph)) {
                    nodeRowCtrl.filterHandler(treeListCtrl.delayedFilterGraph);
                    //delete treeListCtrl.delayedFilterGraph[nodeRowCtrl.key];
                }
            }



        }
    };
    return directive;
}

interface IRLTreeList2NodeRow extends ng.IScope {
    item: Models.ITreeList2Item;
    depth: number;
}

interface ITreeListPathHandler {
    (graph: {}): void;
}

class RLTreeList2NodeRowController {

    static $inject = ["$scope", "$timeout"];

    treeListCtrl: RLTreeList2Controller;
    nodeListCtrl: RLTreeList2NodeListController;

    children: Models.ITreeList2Item[];
    childDepth: number;
    arrowClass: string;
    open: boolean;
    checked: boolean;
    value: any;
    key: string;
    text: string;

    filterHandler: ITreeListPathHandler;
    subFilterHandlers: { [key: string]: ITreeListPathHandler };
    delayedFilterGraph = {};

    showHandler: ITreeListPathHandler;
    subShowHandlers: { [key: string]: ITreeListPathHandler };
    delayedShowGraph: {};

    constructor(private $scope: IRLTreeList2NodeRow, private $timeout: ng.ITimeoutService) {
        this.childDepth = $scope.depth + 1;
        this.open = false;
        this.checked = false;

        this.children = [];
        this.value = null;
        this.key = null;
        this.text = undefined;


        this.subFilterHandlers = {};
        this.delayedFilterGraph = {};
        this.filterHandler = (graph) => {
            var myGraph = graph[this.key];
            if (myGraph != null) {
                this.treeListCtrl.filterHidden[this.key] = false;
                this.open = _.isObject(myGraph);
                if (_.isObject(myGraph) && this.children.length > 0) {
                    this.delayedFilterGraph = {};
                    if (_.any(this.subFilterHandlers)) {
                        _.forEach(this.subFilterHandlers, (handler: ITreeListPathHandler) => {
                            handler(myGraph);
                        });
                    } else {
                        this.delayedFilterGraph = myGraph;
                    }
                }
            } else {
                this.open = false;
                this.treeListCtrl.filterHidden[this.key] = true;
            }
            this.treeListCtrl.filterMatched[this.key] = !_.isEmpty(this.treeListCtrl.filterText) && this.text.toLowerCase().indexOf(this.treeListCtrl.filterText.toLowerCase().trim()) >= 0;
        };

        this.subShowHandlers = {};
        this.delayedShowGraph = {};
        this.showHandler = (graph) => {
            var myGraph = graph[this.key];
            this.open = myGraph != null && _.isObject(myGraph);
            if (_.isObject(myGraph) && this.children.length > 0) {
                this.delayedShowGraph = {};
                if (_.any(this.subShowHandlers)) {
                    _.forEach(this.subShowHandlers, (handler: ITreeListPathHandler) => {
                        handler(myGraph);
                    });
                } else {
                    this.delayedShowGraph = myGraph;
                }
            }
        };


        $scope.$watch(() => this.open,
            (newValue, oldValue) => {
                if (newValue) {
                    this.arrowClass = "fa-caret-down";
                } else if (this.children.length > 0) {
                    this.arrowClass = "fa-caret-right";
                } else {
                    this.arrowClass = "";
                }
            });

        $scope.$watch(() => this.treeListCtrl.ContainsValue(this.value),
            (newValue, oldValue) => {
                this.checked = newValue;
            });

        $scope.$on(Consts.Events.TreeListFilterReset, () => {
            this.delayedFilterGraph = {};
            this.open = $scope.depth == 0 && this.children.length > 0;
        });


    }

    SetupNode() {
        var item = this.$scope.item;
        this.children = this.treeListCtrl.GetChildren(item);
        this.value = this.treeListCtrl.GetValue(item);
        this.text = this.treeListCtrl.GetText(item);
        this.key = this.treeListCtrl.GetKey(item);
        this.open = this.$scope.depth == 0 && this.children.length > 0;
    }

    ToggleOpen($event: ng.IAngularEvent) {

        this.open = !this.open;

        $event.stopPropagation();
        $event.preventDefault();
    }

    ToggleSelected() {
        this.treeListCtrl.clickEvent = true;
        this.treeListCtrl.SetSelectedItem(this.$scope.item, this.checked);
    }

    ToggleRowSelected() {
        this.treeListCtrl.clickEvent = true;
        this.treeListCtrl.SetSelectedItem(this.$scope.item, !this.checked);
    }
}

export interface RLJobStatusMonitorScope extends ng.IScope {
    jobTitle: string;
    reIndexAffected: boolean;
    stepParams: number[];
    templateParams: number[];
}
export function RLJobStatusMonitor() {

    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/job-status-monitor.html"),
        controllerAs: "iaVM",
        controller: IndexAdminController,
        scope: {
            jobTitle: "@",
            reIndexAffected: "=",
            stepParams: "=?",
            templateParams: "=?"
        },
        link: (scope: RLJobStatusMonitorScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IndexAdminController) => {
            scope.$watch("reIndexAffected", (newValue: boolean, oldValue: boolean) => {
                if (newValue != oldValue && newValue == true) {
                    if (!_.isEmpty(scope.stepParams)) {
                        var divID = scope.stepParams[0];
                        var processID = scope.stepParams[1];
                        var statusID = scope.stepParams[2];
                        controller.RebuildEntitiesStatusIndex(divID, processID, statusID);
                    }
                    if (!_.isEmpty(scope.templateParams)) {
                        var divID = scope.templateParams[0];
                        var charTypeID = scope.templateParams[1];
                        var templateID = scope.templateParams[2];
                        controller.selectedCharTypeIDs = [charTypeID];
                        controller.selectedDivisionIDs = [divID];
                        controller.RebuildEntitiesTemplateIndex(divID, charTypeID, templateID);
                    }
                }
            }, true);
        }
    };
    return directive;
}

export function RLPasswordValidator() {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "ngModel",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, modelCtrl: ng.INgModelController) => {

            var hasLength = (value: string): boolean => {
                return value.length >= 8;
            };

            var hasNumber = (value: string): boolean => {
                return /[0-9]/.test(value);
            };

            var hasLower = (value: string): boolean => {
                return /[a-z]/.test(value);
            };

            var hasUpper = (value: string): boolean => {
                return /[A-Z]/.test(value);
            };

            var hasSymbol = (value: string): boolean => {
                return /[^0-9a-zA-Z]/.test(value);
            };

            var hasGoodPassword = (value: string): boolean => {
                return (hasLength(value) && hasNumber(value) && hasLower(value) && hasUpper(value) && hasSymbol(value));
            };

            modelCtrl.$validators["passwordLength"] = hasLength;
            modelCtrl.$validators["passwordNumber"] = hasNumber;
            modelCtrl.$validators["passwordLower"] = hasLower;
            modelCtrl.$validators["passwordUpper"] = hasUpper;
            modelCtrl.$validators["passwordSymbol"] = hasSymbol;
            modelCtrl.$validators["passwordStrength"] = hasGoodPassword;
        }
    };
    return directive;
}

export function RLAssociationSearch() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/association-search-results.html"),
        scope: {
            entityID: "=entityId",
            searchState: "=",
            templates: "=?",
            reload: "@",
            isParentChar: "@",
            itemCount: "=?",
            addAssociationMode: "@?",
            showResults: "=?",
            selectedItems: "=?",
            selectAll: "=?",
            locked: "=?",
            canEdit: "=?"
        },
        controller: RLAssociationSearchController,
        controllerAs: "socVM",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: RLAssociationSearchController) => {

            scope.$watch('reload', (newValue: boolean, oldValue: boolean) => {
                if (newValue) {
                    controller.Search();
                }
            }, true);

            controller.charTemplates = scope["templates"];
        }
    };
    return directive;
}

export interface RLAssociationSearchScope extends ng.IScope {
    searchState: Models.IAdvancedSearchModel;
    entityID: string;
    locked: boolean;
    canEdit: boolean;
    charTypeID: number;
    templates: Models.IKeyValuePair<string, string>[];
    page: number;
    isParentChar: string;
    itemCount: number;
    addAssociationMode: string;
    showResults: boolean;
    selectedItems: Models.ICharTypeTemplateAssociationSelection[];
    selectAll: boolean;
    rowCount: number;
}

export class RLAssociationSearchController extends BaseAssociationSearchController<Models.IEntitySearchDoc> {
    static $inject = ["$scope", "$rootScope", "$sce", "entityService", "notifyService", "$filter", "$location", "$window", "eventService", "searchService"];
    templateGroupIDs: number[];
    filterByEntityID: string;
    visibility: number;
    activeFlag: boolean;
    customFilter: string[];
    searchState: Models.IAdvancedSearchModel;
    locked: boolean;
    canEdit: boolean;
    initialized: boolean;
    charTemplates: Models.IKeyValuePair<string, string>[];
    isParentChar: string;
    searchReturnsValues: boolean;
    selectedRows: { [entityID: string]: boolean };
    rowCount: number;
    sortField: string;
    sortDir: number;

    constructor(private $scope: RLAssociationSearchScope,
        private $rootScope: ng.IRootScopeService,
        private $sce: ng.ISCEService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private $filter: ng.IFilterService,
        private $location: ng.ILocationService,
        private $window: ng.IWindowService,
        private eventService: EventService,
        private searchService: SearchService
    ) {
        super($scope, $location, $filter, notifyService);
        this.locked = false;
        this.canEdit = true;
        this.charTemplates = [];
        this.selectedRows = {};
        this.rowCount = 10;

        $scope.$watch(() => $scope.locked,
            (newValue, oldValue) => {
                if ($scope.locked != null) {
                    this.locked = $scope.locked;
                }
            }, true);

        $scope.$watch(() => $scope.canEdit,
            (newValue, oldValue) => {
                if ($scope.canEdit != null) {
                    this.canEdit = $scope.canEdit;
                }
            }, true);

        $scope.$watch(() => $scope.isParentChar,
            (newValue, oldValue) => {
                if ($scope.isParentChar != null) {
                    this.isParentChar = $scope.isParentChar;
                }
            }, true);

        this.$scope.$watch(() => this.$scope.searchState, (newValue: Models.IAdvancedSearchModel, oldValue: Models.IAdvancedSearchModel) => {
            if (!_.isEmpty(newValue)) {
                this.searchState = this.$scope.searchState;
                this.Search();
            }
        }, true);

        this.$scope.$watch(() => this.templateFacets, (newValue: Models.IKeyValuePair<string, string>[], oldValue: Models.IKeyValuePair<string, string>[]) => {
            if (newValue != oldValue) {
                var dTemplates = <{ [key: string]: string }>{};
                _.each(newValue, t => {
                    dTemplates[t.key.split('|')[1]] = t.key.split('|')[0] + " (" + t.value + ")";
                });
                this.$scope.templates = newValue;
            }
        }, true);

        this.$scope.$watch(() => this.page, (newValue: number, oldValue: number) => {
            if (newValue != oldValue) {
                this.searchState.page = newValue;
                this.Search();
            }
        }, true);

        this.$scope.$watch(() => this.itemRows, (newValue, oldValue) => {
            this.$scope.itemCount = this.numFound;
        }, true);

        this.$scope.$watch(() => this.searchReturnsValues, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.$scope.showResults = this.searchReturnsValues;
            }
        }, true);

        this.$scope.$watch(() => this.$scope.selectAll, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue != null) {
                    this.ToggleAllAssociations();
                }
            }
        }, true);

        eventService.on(Consts.Events.EntityAssociationSearchRefreshAll, () => {
            this.Search();
        });

        this.$scope.$watchCollection(() => [this.sortDir, this.sortField], (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.searchState.sortDir = this.sortDir;
                this.searchState.sortField = this.sortField;
                this.Search();
            }
        });

        //this.Search();
    }

    Search() {
        if (!_.isEmpty(this.searchState)) {
            this.notifyService.startProgress();

            this.searchService.advancedSearch(this.searchState)
                .then((res) => {
                    if (this.$scope.addAssociationMode != null && this.$scope.addAssociationMode.toLowerCase() == "true") {
                        if (res.documents.length > 0) {
                            this.searchReturnsValues = true;
                            this.rowCount = res.documents.length;
                        }
                        else {
                            this.searchReturnsValues = false;
                            this.rowCount = 0;
                        }
                    }

                    this.itemRows = res.documents;
                    this.templateFacets = res.getTemplateFacets();
                    this.numFound = res.numFound;
                    this.pageCount = Math.ceil(res.numFound / this.searchState.rowCount);
                    this.initialized = true;
                })
                .finally(() => {

                    //Select any rows that are coming through as already selected
                    if (this.$scope.selectedItems != null) {
                        _.forEach(this.$scope.selectedItems, rel => {
                            if (rel.selected) {
                                var divID = Utils.IdBuilder.splitEntityID(this.searchState.relatedEntityID).divID;
                                var entityID = Utils.IdBuilder.buildEntityID(divID, rel.charTypeID, rel.associationID);
                                this.selectedRows[entityID] = rel.selected;
                            }
                        });
                    }

                    this.notifyService.endProgress();
                });
        }
    }

    RemoveAssociation(childEntityID: string) {
        if (this.$window.confirm("Are you sure?")) {
            this.notifyService.startProgress();

            var parentEntity = this.$scope.entityID;
            var childEntity = childEntityID;

            if (this.isParentChar == "true") {
                parentEntity = childEntityID;
                childEntity = this.$scope.entityID;
            }

            this.entityService.deleteAssociation(parentEntity, childEntity)
                .then(() => {
                    var itemRow = _.find(this.itemRows, ir => { return ir.entityID == childEntityID; });
                    _.remove(this.itemRows, i => i == itemRow);
                    this.numFound = this.itemRows.length;
                    this.eventService.call(Consts.Events.ValidateEntity)
                        .then(() => {
                            this.notifyService.notifySuccess("Association removed");
                        });

                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    ToggleAllAssociations() {
        _.forEach(this.itemRows, (row) => {
            this.selectedRows[row.entityID] = this.$scope.selectAll;
            this.ToggleAssociationSelected(row.entityID, row.templateID);
        });
    }

    ToggleAssociationSelected(entityID: string, templateID: number) {
        if (this.$scope.selectedItems == null) {
            this.$scope.selectedItems = [];
        }

        var charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
        var associationID = Utils.IdBuilder.splitEntityID(entityID).recID;

        var associationItem = _.find(this.$scope.selectedItems, a => a.charTypeID == charTypeID && a.templateID == templateID && a.associationID == associationID);
        var isSelected = this.selectedRows[entityID];

        if (associationItem != null && !isSelected) {
            //We have it in our list, and it is no longer selected, so set it to false
            associationItem.selected = false;
        }
        else if (associationItem != null && isSelected) {
            associationItem.selected = true;
        }
        else if (isSelected) {
            //It doesn't exist, and it's selected, so add it
            var selectedRel: Models.ICharTypeTemplateAssociationSelection = {
                isParentChar: this.isParentChar.toLowerCase() == 'true' ? true : false,
                charTypeID: charTypeID,
                templateID: templateID,
                associationID: associationID,
                selected: this.selectedRows[entityID]
            }

            this.$scope.selectedItems.push(selectedRel);
        }
    }

    PreviewEntity(entityID: string) {
        this.$rootScope.$broadcast(Consts.Events.ViewEntity, entityID);
    }
}

export function RLCharacteristicValueSourceUsageIn() {
    var directive: ng.IDirective = {
        restrict: "A",
        replace: true,
        controller: RLCharacteristicValueSourceUsageInController,
        template: require("/assets/app/templates/charvaluesource-usage-in.html"),
        controllerAs: "cvsuVM",
        bindToController: true,
        scope: {
            chrValSrcId: "@",
            templateListUrl: "@",
            templateMetaDataUrl: "@",
            templateCharAssocUrl: "@"
        }
    };
    return directive;
}

class RLCharacteristicValueSourceUsageInController {
    static $inject = ["$scope", "entityConfigService", "notifyService"];
    chrValSrcId: string;
    charValueSourceUsageIn: Models.ICharValueSourceUsageIn[];
    templateListUrl: string;
    templateMetaDataUrl: string;
    templateCharAssocUrl: string;
    loaded: boolean;

    constructor(private $scope: ng.IScope, private entityConfigService: EntityConfigService, private notifyService: NotifyService) {
        this.loaded = false;

        $scope.$on(Consts.Events.RLDropPanelOpening, () => {
            return this.entityConfigService.getCharValueSourceUsageIn(this.chrValSrcId).then((result) => {
                this.charValueSourceUsageIn = result;
            });
        });
    }
}

export function RLCharacteristicValueSetUsageIn() {
    var directive: ng.IDirective = {
        restrict: "A",
        replace: true,
        controller: RLCharacteristicValueSetUsageInController,
        template: require("/assets/app/templates/charvalueset-usage-in.html"),
        controllerAs: "cvsetuVM",
        bindToController: true,
        scope: {
            chrValSetId: "@",
            chrListUrl: "@",
            editChrUrl: "@",
        }
    };
    return directive;
}

class RLCharacteristicValueSetUsageInController {
    static $inject = ["$scope", "entityConfigService", "notifyService"];
    chrValSetId: string;
    charValueSetUsageIn: Models.ICharValueSetUsageIn[];
    chrListUrl: string;
    editChrUrl: string;
    loaded: boolean;

    constructor(private $scope: ng.IScope, private entityConfigService: EntityConfigService, private notifyService: NotifyService) {
        this.loaded = false;

        $scope.$on(Consts.Events.RLDropPanelOpening, () => {
            return this.entityConfigService.getCharValueSetUsageIn(this.chrValSetId).then((result) => {
                this.charValueSetUsageIn = result;
            });
        });
    }
}

export function RLCharacteristicUsageIn() {
    var directive: ng.IDirective = {
        restrict: "A",
        replace: true,
        controller: RLCharacteristicUsageInController,
        template: require("/assets/app/templates/characteristic-usage-in.html"),
        controllerAs: "chruVM",
        bindToController: true,
        scope: {
            charTypeId: "@",
            characteristicId: "@",
            characteristicLbl: "@",
            templateMetaDataUrl: "@",
            templateCharAssocUrl: "@"
        }
    };
    return directive;
}

class RLCharacteristicUsageInController {
    static $inject = ["$scope", "entityConfigService", "notifyService"];
    charTypeId: number;
    characteristicId: number;
    characteristicLbl: string;
    characteristicUsageIn: Models.ICharacteristicUsageIn[];
    templateMetaDataUrl: string;
    templateCharAssocUrl: string;
    loaded: boolean;

    constructor(private $scope: ng.IScope, private entityConfigService: EntityConfigService, private notifyService: NotifyService) {
        this.loaded = false;

        $scope.$on(Consts.Events.RLDropPanelOpening, () => {
            return this.entityConfigService.getCharacteristicUsageIn(this.charTypeId, this.characteristicId).then((result) => {
                this.characteristicUsageIn = result;
            });
        });
    }
}

export function RLIsolateForm() {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "?form",
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: ng.IFormController) => {
            if (!controller) {
                return;
            }

            var ctrlCopy: ng.IFormController | any = {};
            angular.copy(controller, ctrlCopy);

            var parent = element.parent().controller("form");

            parent.$removeControl(controller);

            var isolatedFormCtrl = {
                $setValidity: function (validationToken, isValid, control) {
                    ctrlCopy.$setValidity(validationToken, isValid, control);
                    parent.$setValidity(validationToken, true, controller);
                },
                $setDirty: function () {
                    element.removeClass('ng-pristine').addClass('ng-dirty');
                    controller.$dirty = true;
                    controller.$pristine = false;
                }
            };

            angular.extend(controller, isolatedFormCtrl);
        }
    };
    return directive;
}

var rlAdminDirectivesModule = angular.module("rlAdminDirectives", ["rlAdminConsts", "rlAdminServices"]);
// Directives
rlAdminDirectivesModule
    .directive("rlRecentActivity", RLRecentActivity)
    .directive("rlRecentActivityMenuBar", RLRecentActivityMenuBar)
    .directive("rlBeforeUnload", RLBeforeUnload)
    .directive("rlModalOpen", RLModalOpen)
    .directive("rlBusyButton", RLBusyButton)
    .directive("rlCreateEntityButton", RLCreateEntityButton)
    .directive("rlEntityByStatusChart", RLEntityByStatusChart)
    .directive("rlQuickLinksList", RLQuickLinksList)
    .directive("rlContactQuickSearch", RLContactQuickSearch)
    .directive("rlAssetImage", RLAssetImage)
    .directive("rlFavoriteStar", RLFavoriteStar)
    .directive("rlAvailRow", RLAvailRow)
    .directive("rlMediaelement", RLMediaelement)
    .directive("rlFilepicker", RLFilepicker)
    .directive("rlDatepicker", RLDatePicker)
    .directive("rlTimecode", RLTimecode)
    .directive("rlTreelist", RLTreelist)
    .directive("rlCharTemplateSelect", RLCharTemplateSelect)
    .directive("rlCharVisibilitySelect", RLCharVisibilitySelect)
    .directive("rlCharTemplateGroupSelect", RLCharTemplateGroupSelect)
    .directive("rlCharDataTypeSelect", RLCharDataTypeSelect)
    .directive("rlChangeRedirect", RLChangeRedirect)
    .directive("rlWorkflowActionSelect", RLWorkflowActionSelect)
    .directive("rlWorkflowProcessSelect", RLWorkflowProcessSelect)
    .directive("ngFormIgnore", NGFormIgnore)
    .directive("rlFirstRepeat", RLFirstRepeat)
    .directive("rlTranscludeScope", RLTranscludeScope)
    .directive("rlAddress", RLAddress)
    .directive("rlAssociateTreeItem", RLAssociateTreeItem)
    .directive("rlExtendedAssociateTreeItem", RLExtendedAssociateTreeItem)
    //.directive("rlWorkflowExecute", RLWorkflowExecute)
    // .directive("rlNewVsClosedChart", RLNewVsClosedChart)
    .directive("rlPageDisabler", RLPageDisabler)
    .directive("rlEntityStatusInfo", RLEntityStatusInfo)
    .directive("rlAssetPopup", RLAssetPopup)
    .directive("rlEntityMiniInfo", RLEntityMiniInfo)
    .directive("rlModal", RLModal)
    .directive("rlTranscludeByClass", RLTranscludeByClass)
    .directive("rlKeepAlive", RLKeepAlive)
    .directive("rlCharMultiSelect", RLCharMultiSelect)
    .directive("rlDynamicReportCell", RLDynamicReportCell)
    .directive("checklistModel", RLCheckListModel)
    .directive("rlDropPanel", RLDropPanel)
    .directive("rlTextareaWriter", RLTextareaWriter)
    .directive("rlKeyart", RLKeyArt)
    .directive("rlHierarchyRow", RLHierarchyRow)
    .directive("rlHierarchyList", RLHierarchyList)
    .directive("rlQuickPost", RLQuickPost)
    .directive("rlUniqueListName", RLUniqueListName)
    .directive("rlMinSelected", RLMinSelected)
    .directive("rlUniqueUserIdentity", RLUniqueUserIdentity)
    .directive("rlValidationMessages", RLValidationMessages)
    .directive("rlUniqueValue", RLUniqueValue)
    .directive("rlValidateMethod", RLValidateMethod)
    .directive("rlEntityTitleNav", RLEntityTitleNav)
    .directive("rlEntitySummaryNav", RLEntitySummaryNav)
    .directive("rlMessage", RLMessage)
    .directive("rlScrollExpand", RLScrollExpand)
    .directive("rlEntityPanel", RLEntityPanel)
    .directive("rlUserNotificationsMenuBar", RLUserNotificationsMenuBar)
    .directive("rlUserNotificationsList", RLUserNotificationsList)
    .directive("rlHorizontalScroll", RLHorizontalScroll)
    .directive("rlDocViewer", RLDocViewer)
    .directive("rlMatchInput", RLMatchInput)
    .directive("rlValidateOnChange", RLValidateOnChange)
    .directive("rlCheckbox", RLCheckbox)
    .directive("rlTreeList2", RLTreeList2)
    .directive("rlTreeList2NodeList", RLTreeList2NodeList)
    .directive("rlTreeList2NodeRow", RLTreeList2NodeRow)
    .directive("rlJobStatusMonitor", RLJobStatusMonitor)
    .directive("rlPasswordValidator", RLPasswordValidator)
    .directive("rlAssociationSearch", RLAssociationSearch)
    .directive("rlCharacteristicValueSourceUsageIn", RLCharacteristicValueSourceUsageIn)
    .directive("rlCharacteristicValueSetUsageIn", RLCharacteristicValueSetUsageIn)
    .directive("rlCharacteristicUsageIn", RLCharacteristicUsageIn)
    .directive("rlIsolateForm", RLIsolateForm)
    .directive("rlAssociateContacts", RLAssociateContacts)
    .directive("rlAdvancedSearch", RLAdvancedSearch)
    .directive("rlActivityTreeList", RLActivityTreeList)
    .directive("rlActivityTreeRow", RLActivityTreeRow)
    .directive("rlAddAlertToCharacteristic", RLAddAlertToCharacteristic)
    .directive("rlAdvancedSearchCriteria", RLAdvancedSearchCriteria)
    .directive("rlAmounts", RLAmounts)
    .directive("rlAssociationPanels", RLAssociationPanels)
    .directive("rlAssociationTableHierarchyItem", RLAssociationTableHierarchyItem)
    .directive("rlAssociationTableHierarchy", RLAssociationTableHierarchy)
    .directive("rlAssociationTable", RLAssociationTable)
    .directive("rlAvailExplorerChart", RLAvailExplorerChart)
    .directive("rlAvailsSelectedCriteria", RLAvailsSelectedCriteria)
    .directive("rlBulkActions", RLBulkActions)
    .directive("rlBulkImportUpdate", RLBulkImportUpdate)
    .directive("rlCatalogAvailsAssocSearch", RLCatalogAvailsAssocSearch)
    .directive("rlCharacteristicPolicyEditor", RLCharacteristicPolicyEditor)
    .directive("rlCharTypeTemplateAssociationsTreeView", RLCharTypeTemplateAssociationsTreeView)
    .directive("rlContacts", RLContacts)
    .directive("rlCopyEntity", RLCopyEntity)
    .directive("rlConditionalFieldsConfig", RLConditionalFieldsConfig)
    .directive("rlCreateAndAssociateHierarchicalRecords", RLCreateAndAssociateHierarchicalRecords)
    .directive("rlCustomDashboardReport", CustomDashboardReport)
    .directive("rlDashboardSearch", DashboardSearch)
    .directive("rlEditAlertList", RLEditAlertList)
    .directive("rlEditDateCalcByCharacteristic", RLEditDateCalcByCharacteristic)
    .directive("rlEntityAssetsTableRowOps", RLEntityAssetsTableRowOps)
    .directive("rlEntityAssetsTableRow", RLEntityAssetsTableRow)
    .directive("rlEntityAssetsTable", RLEntityAssetsTable)
    .directive("rlEntityHierarchyCsvExport", RLEntityHierarchyCSVExport)
    .directive("rlEntityInfoActions", RLEntityInfoActions)
    .directive("rlEntityQuickSearch", RLEntityQuickSearch)
    .directive("rlEntityRelationships", RLEntityRelationships)
    .directive("rlEntityWorkflowNav", RLEntityWorkflowNav)
    .directive("rlFocus", RLFocus)
    .directive("rlIndeterminate", RLIndeterminate)
    .directive("rlInventoryQuickSearch", RLInventoryQuickSearch)
    .directive("rlJobProgressStatusMonitor", RLJobProgressStatusMonitor)
    .directive("rlListOfValuesHierarchyCsvExport", RLListOfValuesHierarchyCSVExport)
    .directive("rlListTable", RLListTable)
    .directive("rlMigrateEntity", RLMigrateEntity)
    .directive("rlPager", RLPager)
    .directive("rlParentEntityId", RLParentEntityID)
    .directive("rlProjects", RLProjects)
    .directive("rlQuickRightsEntry", RLQuickRightsEntry)
    .directive("rlReportParamDateInput", RLReportParamDateInput)
    .directive("rlReportParamInput", RLReportParamInput)
    .directive("rlReportParamPickerModal", RLReportParamPickerModal)
    .directive("rlReportParamPicker", RLReportParamPicker)
    .directive("rlReportParamPickerV2", RLReportParamPickerV2)
    .directive("rlReportParamSelectedCriteria", RLReportParamSelectedCriteria)
    .directive("rlRightsFilter", RLRightsFilter)
    .directive("rlScrollFixed", RLScrollFixed)
    .directive("rlScrollShadow", RLScrollShadow)
    .directive("rlScrollable", Scrollable)
    .directive("rlStickyHeader", ScrollableStickyTableHeader)
    .directive("rlSelectCharacteristics", RLSelectCharacteristics)
    .directive("rlShowPanel", RLShowPanel)
    .directive("rlFinancialValidation", RLFinancialValidation)
    .directive("rlFinancialTools", RLFinancialTools)
    .directive("rlSidepanelToggle", RLSidepanelToggle)
    .directive("rlTemplateHierarchyCountItem", RLTemplateHierarchyCountItem)
    .directive("rlTemplateHierarchyCountRecursive", RLTemplateHierarchyCountRecursive)
    .directive("rlTitleCoverageChart", RLTitleCoverageChart)
    .directive("rlTypeAheadInput", RLTypeAheadInput)
    .directive("rlViewAddAlertToCharacteristic", RLViewAddAlertToCharacteristic)
    .directive("rlViewAlertsByCharacteristic", RLViewAlertsByCharacteristic)
    .directive("rlViewDateCalcByCharacteristic", RLViewDateCalcByCharacteristic)
    .directive('rlBulkCreateAmounts', RLBulkCreateAmounts)
    .directive('rlMultiValidate', MultiValidate)
    .directive('rlPercentValidator', PercentValidator)
    .directive("rlColumnPicker", RLColumnPicker)
    .service("sharedCommentService", SharedCommentService)
    .service("RecursionHelper", RecursionHelper)
    .directive("rlComments", RLComments)
    .directive("rlCommentThread", RLCommentThread)
    .directive("rlComment", RLComment)
    .directive('rlCreateDataDefault', RLCreateDataDefault)
    .directive('rlViewDataDefaults', RLViewDataDefaults)
    .directive('rlLovFilter', RLLovFilter)
    .directive("rlParseNumberModel", RLParseNumberModel)
    .directive("rlRights", RLRights)
    .directive("rlRoyaltyPanel", RLRoyaltyPanel)
    .directive("rlCellTotalValidator", RLCellTotalValidator)
    .directive("rlCellValidator", RLCellValidator)
    .directive("rlSecurityTableCell", RLSecurityTableCell)
    .directive("rlSecurityTableRow", RLSecurityTableRow)
    .directive("rlSidepanelPreviewItem", RLSidepanelPreviewItem)
    .directive("rlSidepanelPreviews", RLSidepanelPreviews)
    .directive("rlSidepanel", RLSidepanel)
    .directive("rlSortColumn", RLSortColumn)
    .directive("rlAuditHistory", RLAuditHistory)
    .directive("rlUsages", RLUsages)
    .directive("rlDocuments", RLDocuments)
    .directive("rlDocumentFolderHierarchy", RLDocumentFolderHierarchy)
    .directive("rlDocumentFolderHierarchyItem", RLDocumentFolderHierarchyItem)
    .directive("rlBulkImportV2", RLBulkImportV2)
    .directive("rlBulkImportV3", RLBulkImportV3)
    .directive("rlStatusHistory", StatusHistory)
    .component("rlListColumnFilter", new RLListColumnFilter())
    .component("rlEntityValidationSelector", new RLEntityValidationSelector())
    .component("rlEntityRelationshipSelector", new RLEntityRelationshipSelector());
export { rlAdminDirectivesModule };
